import { en_US_Abbrevs } from "./en_US-abbrev";
import { en_US_Varies } from "./en_US-varies";
import { en_symbols } from "./en_symbols";

/** either supplements to en_US or disagreements */
export const en_US_Overrides: Record<string, string> = {
  ...en_symbols,
  ...en_US_Abbrevs,
  ...en_US_Varies,

  // don't put stress on these common words
  "a": "ə",
  "an": "æn",
  "and": "ænd",
  "at": "æt",
  "by": "baɪ",
  "can": "kæn",
  "for": "fɔɹ",
  "from": "fɹəm",
  "has": "hæz",
  "her": "hɝ",
  "hers": "hɝz",
  "him": "hɪm",
  "his": "hɪz",
  "in": "ɪn",
  "into": "ɪntu",
  "is": "ɪz",
  "it": "ɪt",
  "its": "ɪts",
  "of": "əv",
  "on": "ɑn",
  "or": "ɔɹ",
  "our": "aʊɝ",
  "that": "ðæt",
  "the": "ðə",
  "their": "ðɛɹ",
  "this": "ðɪs",
  "to": "tə",
  "we're": "wɝ",
  "was": "wəz",
  "with": "wɪθ",

  "couldn't": "/ˈkʊdənt/",
  "didn't": "ˈdɪdənt",
  "isn't": "ˈɪzənt",
  "weren't": "ˈwɝnt",

  "quadrillion": "/kwɑdˈɹɪɫjən/",
  "quadrillionth": "/kwɑdˈɹɪɫjənθ/",
  "quintillion": "/kwɪnˈtɪɫjən/",
  "quintillionth": "/kwɪnˈtɪɫjənθ/",
  "sextillion": "/sɛksˈtɪɫjən/",
  "sextillionth": "/sɛksˈtɪɫjənθ/",
  "septillion": "/sɛpˈtɪɫjən/",
  "septillionth": "/sɛpˈtɪɫjənθ/",
  "octillion": "/ɑkˈtɪɫjən/",
  "octillionth": "/ɑkˈtɪɫjənθ/",
  "nonillion": "/nɑˈnɪɫjən/",
  "nonillionth": "/nɑˈnɪɫjənθ/",
  "decillion": "/dɛˈsɪɫjən/",
  "decillionth": "/dɛˈsɪɫjənθ/",

  // pronunciations that didn't match English phonotactics or were wrong or were missing
  "a.i.": "/ˌeɪˈaɪ/",
  "aaargh": "/ˈɑːɹɡ/",
  "aargh": "/ˈɑːɹɡ/",
  "abiotic": "/ˌeɪbaɪˈɑtɪk/",
  "abjure": "/æbˈdʒʊɹ/",
  "ableism": "/ˈeɪbəɫɪzəm/",
  "aboveground": "/əˈbəvˌɡɹaʊnd/",
  "abstractness": "/æbˈstɹæktnəs/",
  "absurdism": "/əbˈsɝdɪzəm/",
  "abyssal": "/əˈbɪsəɫ/",
  "acai": "/ɑˈsɑi/",
  "accountability": "/əˌkaʊntəˈbɪɫɪti/",
  "accoutrement": "/əˈkutɹəmənt/",
  "achey": "/ˈeɪki/",
  "achmed": "/ˈɑkməd/",
  "acidophilus": "/ˌæsəˈdɑfəɫəs/",
  "acumen": "/ˈækjumən/",
  "additivity": "/ˌædəˈtɪvəˌti/",
  "adequate": "/ˈædəkwət/",
  "adorably": "/əˈdɔɹəbɫi/",
  "adult": "/əˈdəɫt/",
  "adults": "/əˈdəɫts/",
  "adults'": "/əˈdəɫts/",
  "advantage": "/ədˈvæntɪdʒ/",
  "advantaged": "/ədˈvæntɪdʒd/",
  "advantages": "/ədˈvæntɪdʒɪz/",
  "adventuring": "/ædˈvɛntʃɝɪŋ/",
  "adverse": "/ædˈvɝs/",
  "advertisement": "/ˈædvɝˌtaɪzmənt/",
  "advisee": "/ədˌvaɪˈsi/",
  "adze": "/ˈædz/",
  "aegina": "/iˈdʒaɪnə/",
  "aerosolize": "/ˈɛɹəˌsɑɫaɪz/",
  "aerosolized": "/ˈɛɹəˌsɑɫaɪzd/",
  "aerostatic": "/ˌɛɹoʊˈstætək/",
  "aesir": "/ˈeɪzɪɹ/",
  "aether": "/ˈiθɝ/",
  "affordance": "/əˈfɔɹdəns/",
  "affordances": "/əˈfɔɹdənsəz/",
  "afore": "/əˈfɔɹ/",
  "afrofuturism": "/ˌæfɹoʊˈfjutʃɝɪzəm/",
  "afterword": "/ˈæftɝˌwɝd/",
  "again": "/əˈɡɛn/",
  "against": "/əˈɡɛnst/",
  "agave": "/əˈɡɑvi/",
  "agnew": "/ˈæɡnu/",
  "agoraphobic": "/əˌɡɔɹəˈfoʊbɪk/",
  "agreeably": "/əˈɡɹiəbɫi/",
  "ahem": "/əˈhɛm/",
  "ahistorical": "/eɪhɪˈstɔɹɪkəɫ/",
  "ai": "/ˈeɪˈaɪ/",
  "ailed": "/ˈeɪɫd/",
  "airbrush": "/ˈɛɹˌbɹəʃ/",
  "airbrushed": "/ˈɛɹˌbɹəʃt/",
  "airily": "/ˈɛɹɪɫi/",
  "airstream": "/ˈɛɹˌstɹim/",
  "aka": "/ˈeɪˈkeɪˈeɪ/",
  "akin": "/əˈkɪn/",
  "alchemical": "/æɫˈkɛməkəɫ/",
  "alchemist": "/ˈæɫkəmɪst/",
  "alderman": "/ˈɔɫdɝmən/",
  "algebraist": "/ˈæɫdʒəˌbɹeɪɪst/",
  "algorithmic": "/ˌæɫɡəˈɹɪθmɪk/",
  "algorithmically": "/ˌæɫɡəˈɹɪθmɪkɫi/",
  "alphabets": "/ˈæɫfəˌbɛts/",
  "already": "/ɑɫˈɹɛdi/",
  "altruist": "/ˈæɫtɹuɪst/",
  "alum": "/əˈɫəm/",
  "aluminium": "/ˌæɫjuˈmɪniəm/",
  "alveolo": "/æɫˈviəɫoʊ/",
  "amateur": "/ˈæmətʃɝ/",
  "ameba": "/əˈmibə/",
  "americanist": "/əˈmɛɹəkənɪst/",
  "amour": "/ˌɑˈmʊɹ/",
  "amphitheater": "/ˈæmfəˌθiətɝ/",
  "amphitheaters": "/ˈæmfəˌθiətɝ/",
  "amphitheatre": "/ˈæmfəˌθiətɝ/",
  "amplituhedra": "/ˈæmpɫətuˈhidɹə/",
  "amplituhedron": "/ˈæmpɫətuˈhidɹən/",
  "amygdala": "/əˈmɪɡdəɫə/",
  "anaemic": "/əˈnimɪk/",
  "anarchism": "/ˈænɝˌkɪzəm/",
  "anarchistic": "/ˌænɑɹˈkɪstɪk/",
  "andaman": "/ˈændəmən/",
  "andamanese": "/ˌændəmənˈiz/",
  "angostura": "/æŋɡəˈstjʊɹə/",
  "animalistic": "/ˌænəməɫˈɪstɪk/",
  "animating": '/ˌænəˈmeɪtɪŋ/',
  "animistic": "/ˌænəˈmɪstɪk/",
  "anisotropic": "/æˌnaɪsəˈtɹɑpɪk/",
  "anisotropically": "/æˌnaɪsəˈtɹɑpɪkɫi/",
  "anisotropy": "/ˌænaɪˈsɑtɹəpi/",
  "ankh": '/ˈɑŋk/',
  "annulus": "/ˈænjəɫəs/",
  "anointment": "/əˈnɔɪntmənt/",
  "antarctic": "/ænˈtɑɹtɪk/",
  "antarctica": "/ænˈtɑɹtɪkə/",
  "antecedent": "/ˌæntəˈsidənt/",
  "antecessor": "/ˌæntəˈsɛsɝ/",
  "anthologized": "/ænˈθɑɫədʒaɪzd/",
  "anthropocene": "/ˈænθɹəpəˌsin/",
  "anthropomorphize": "/ˌænθɹoʊpəˈmɔɹfaɪz/",
  "anthropomorphized": "/ˌænθɹoʊpəˈmɔɹfaɪzd/",
  "anthropomorphizes": "/ˌænθɹoʊpəˈmɔɹfaɪzəz/",
  "anthurium": "/ænˈθʊɹɪəm/",
  "antifa": "/ænˈtifə/",
  "anticapitalist": "/ˌæntaɪˈkæpətəɫɪst/",
  "antifragile": "/ˈænˌtaɪˈfɹædʒəɫ/",
  "antifragility": "/ˈænˌtaɪfɹəˈdʒɪɫəti/",
  "antikythera": "/æntiˈkɪθɝə/",
  "antimatter": '/ˈæntaɪˌmætɝ/',
  "antipode": "/ˈæntɪˌpoʊd/",
  "antipodes": "/ˌænˈtɪpədiz/",
  "antiscorbutic": "/ˌæntiskɔɹˈbjutɪk/",
  "antisemitism": "/ˌæntaɪˈsɛmɪˌtɪzəm/",
  "anya": "/ˈɑnjə/",
  "aotearoa": "/ˌæoʊˌtɛəˈɹoʊə/",
  "aperiodically ": "/eɪˌpiɹiˈɑdɪkɫi/",
  "appellate": "/əˈpɛɫət/",
  "appropriate": "/əˈpɹoʊpɹiət/",
  "approximant": "/əˈpɹɑksəmənt/",
  "approximants": "/əˈpɹɑksəmənts/",
  "aqua": "/ˈɑkwə/",
  "aquaculture": "/ˈɑkwəˌkəɫtʃɝ/",
  "aqualung": "/ˈɑkwəˌɫəŋ/",
  "aquaman": "/ˈɑkwəˌmæn/",
  "aquatic": "/əˈkwɑtɪk/",
  "arborist": "/ˈɑɹbɝɪst/",
  "archaea": "/ɑɹˈkiə/",
  "archeologist": "/ˌɑɹkiˈɑɫədʒɪst/",
  "archipelagoes": "/ˌɑɹkəˈpɛɫəˌɡoʊz/",
  "archnemesis": "/ˌɑɹtʃˈnɛməsɪs/",
  "aren't": "/ˈɑɹnt/",
  "arena": "/əˈɹinə/",
  "arena's": "/əˈɹinəz/",
  "arenaball": "/əˈɹinəˌbɔɫ/",
  "arenas": "/əˈɹinəz/",
  "argentinean": "/ˌɑɹdʒənˈtɪniən/",
  "arielle": "/ˌɛɹiˈɛɫ/",
  "arithmetic": "/əˈɹɪθməˌtɪk/",
  "armful": "/ˈɑɹmˌfʊɫ/",
  "arpeggio": "/ɑɹˈpɛʒioʊ/",
  "arrow": "/ˈɛɹoʊ/",
  "artemis": "/ˈɑɹtəməs/",
  "articulator": "/ɑɹˈtɪkjuˌɫeɪtɝ/",
  "artless": "/ˈɑɹtɫəs/",
  "artlessness": "/ˈɑɹtɫəsnəs/",
  "asthmatics": "/æzˈmætɪks/",
  "asphyxiation": "/æsˌfɪksiˈeɪʃən/",
  "aspirational": "/ˌæspəˈɹeɪʃənəɫ/",
  "assimilatory": "/əˈsɪməɫəˌtoʊɹi/",
  "associativity": "/əˌsoʊʃəˈtɪvɪti/",
  "astrobiological": "/ˈæstɹoʊˌbaɪəˈɫɑdʒɪkəɫ/",
  "astrobiologist": "/ˌæstɹoʊbaɪˈɑɫədʒɪst/",
  "astrobiologists": "/ˌæstɹoʊbaɪˈɑɫədʒɪsts/",
  "astrobiology": "/ˈæstɹoʊbaɪˈɑɫədʒi/",
  "astrochemist": "/ˈæstɹoʊˈkɛmɪst/",
  "atacama": '/ˌɑtəˈkɑmə/',
  "atmospheric": "/ˌætməsˈfɪɹɪk/",
  "attaché": "/ætæˈʃeɪ/",
  "attenuating": "/əˈtɛnjueɪtɪŋ/",
  "attestation": "/ætɛsˈteɪʃən/",
  "attractor": "/əˈtɹæktɝ/",
  "audiobook": "/ˈɑdiˌoʊˌbʊk/",
  "auk": "/ˈɔk/",
  "aukland": "/ˈɔkɫənd/",
  "aurelius": "/əˈɹiɫjəs/",
  "auteur": "/ɑˈtʊɹ/",
  "authorial": "/ɔˈθɔɹiəɫ/",
  "autocomplete": "/ˈɔtoʊkəmˌpɫit/",
  "autocompleted": "/ˈɔtoʊkəmˌpɫitəd/",
  "autonomously": "/ɔˈtɑnəməsɫi/",
  "avant-garde": "/ɑˌvɑntˈɡɑɹd/",
  "avocado": "/ˌɑvəˈkɑdoʊ/",
  "avocados": "/ˌɑvəˈkɑdoʊz/",
  "awe": "/ˈɔ/",
  "awesome": "/ˈɔsəm/",
  "awesomely": "/ˈɔsəmɫi/",
  "awestruck": "/ˈɔˌstɹək/",
  "awful": "/ˈɔfəɫ/",
  "awfully": "/ˈɔfəɫi/",
  "awkward": "/ˈɔkwɝd/",
  "awl": "/ˈɔɫ/",
  "awn": "/ˈɔn/",
  "awoken": "/əˈwoʊkən/",
  "axeman": "/ˈæksmæn/",
  "axes": "/ˈæksəz/",
  "axion": "/ˈæksiɑn/",
  "ayr": "/ˈɛɹ/",
  "azores": "/ˈeɪzɔɹz/",
  "azul": "/ɑˈzuɫ/",
  "b/c": "/bɪˈkəz/",
  "babbington": '/ˈbæbɪŋtən/',
  "backbeat": "/ˈbækˌbit/",
  "backyard": "/ˈbækˈjɑɹd/",
  "backyards": "/ˈbækˈjɑɹdz/",
  "backfill": "/ˈbækˌfɪɫ/",
  "backflip": "/ˈbækˌfɫɪp/",
  "backstep": "/ˈbækˌstɛp/",
  "backstories": "/ˈbækstɔɹiz/",
  "backstory": "/ˈbækstɔɹi/",
  "bactrian": "/ˈbæktɹiən/",
  "bahai": "/bəˈhaɪ/",
  "bama": "/ˈbæmə/",
  "bamboozle": "/bæmˈbuzəɫ/",
  "bamboozled": "/bæmˈbuzəɫd/",
  "bancserve": '/ˈbæŋksɝv/',
  "bandmate": "/ˈbændmeɪt/",
  "barack": "/bəˈɹɑk/",
  "barbara": "/ˈbɑɹbɹə/",
  "barcode": "/ˈbɑɹˌkoʊd/",
  "barista": "/bəˈɹistə/",
  "bartleby": "/ˈbɑɹtəɫbi/",
  "base64": '/ˈbeɪsˈsɪkstiˈfɔɹ/',
  "bass": "/ˈbeɪs/",
  "bathtub": "/ˈbæθˌtəb/",
  "bathwater": "/ˈbæθˌwɔtɝ/",
  "baton": "/bəˈtɑn/",
  "batons": "/bəˈtɑnz/",
  "batshit": "/ˈbætˌʃɪt/",
  "battlezone": "/ˈbætəɫˌzoʊn/",
  "bauhaus": "/ˈbaʊhaʊs/",
  "beachcomb": "/ˈbitʃˌkoʊm/",
  "beachcombed": "/ˈbitʃˌkoʊmd/",
  "beachcombing": "/ˈbitʃˌkoʊmɪŋ/",
  "beatific": "/biəˈtɪfɪk/",
  "beatlemania": "/bitəɫˈmeɪniə/",
  "because": "/bɪˈkəz/",
  "beethoven": '/ˈbeɪˌtoʊvən/',
  "begrudgingly": "/ˌbiˈɡɹədʒɪŋɡɫi/",
  "begun": "/biˈɡən/",
  "beignet": "/bɛnˈjeɪ/",
  "belushi": "/bəˈɫuʃi/",
  "bemusement": "/bəˈmjuzmənt/",
  "bengston": '/ˈbɛŋstən/',
  "bengtson": '/ˈbɛŋsən/',
  "benoit": "/bɛˈnwɑ/",
  "beringia": "/bəˈɹɪndʒiə/",
  "beyoncé": "/biˈɑnseɪ/",
  "beyond": "/biˈɔnd/",
  "bezel": "/ˈbɛzəɫ/",
  "bezier": "/ˈbɛziɝ/",
  "biafra": "/biˈɑfɹə/",
  "biafran": "/biˈɑfɹən/",
  "bicolored": "/ˈbaɪˈkəɫɝd/",
  "bier": "/ˈbɪɹ/",
  "bijou": "/ˈbiʒu/",
  "bilabial": "/baɪˈɫeɪbiəɫ/",
  "billionaire": "/ˈbɪɫjənɛɹ/",
  "binging": "/ˈbɪndʒɪŋ/",
  "bio": "/ˈbaɪoʊ/",
  "biocultural": "/ˌbaɪˌoʊˈkəɫtʃɝəɫ/",
  "biofilm": "/ˈbaɪoʊˌfɪɫm/",
  "bioluminescent": "/ˌbaɪoʊɫuməˈnɛsənt/",
  "bioluminescence": "/ˌbaɪoʊɫuməˈnɛsəns/",
  "biomarker": "/ˈbaɪoʊˌmɑɹkɝ/",
  "biomechanics": "/ˈbaɪoʊməˈkænɪks/",
  "biomechanical": "/ˈbaɪoʊməˈkænɪkəɫ/",
  "biophysicist": "/ˌbaɪoʊˈfɪzɪsɪst/",
  "biosignature": "/ˈbaɪoʊˈsɪɡnətʃɝ/",
  "biotic": "/baɪˈɑtɪk/",
  "bioweapon": "/ˈbaɪoʊˌwɛpən/",
  "biped": "/ˈbaɪpɛd/",
  "bipedal": "/ˌbaɪˈpɛdəɫ/",
  "bipedalism": "/ˌbaɪˈpɛdəɫɪzəm/",
  "birdwatch": "/ˈbɝdwɑtʃ/",
  "birthed": "/ˈbɝθd/",
  "biscay": "/ˈbɪˌskeɪ/",
  "bisect": "/ˈbaɪsɛkt/",
  "bisected": "/ˈbaɪsɛktəd/",
  "bisecting": "/ˈbaɪsɛktɪŋ/",
  "bitesize": "/ˈbaɪtˌsaɪz/",
  "bitmap": "/ˈbɪtmæp/",
  "björk": "/ˈbjɔɹk/",
  "blighter": "/ˈbɫaɪtɝ/",
  "blimey": "/ˈbɫaɪmi/",
  "blinker": "/ˈbɫɪnkɝ/",
  "blogged": "/ˈbɫɔɡd/",
  "bloodyminded": "/ˈbɫədiˈmaɪndəd/",
  "bloodymindedness": "/ˈbɫədiˈmaɪndədnəs/",
  "blotched": "/ˈbɫɑtʃt/",
  "bluesky": "/ˈbɫuˌskaɪ/",
  "boardingpass": '/ˈbɔɹdɪŋˌpæs/',
  "boardingpasses": '/ˈbɔɹdɪŋˌpæsɪz/',
  "bobcats": '/ˈbɑbˌkæts/',
  "bocce": "/ˈbɑtʃi/",
  "boink": '/ˈbɔɪŋk/',
  "boba": "/ˈboʊbə/",
  "bobbed": "/ˈbɑbd/",
  "bogotá": "/boʊɡəˈtɑ/",
  "boldfaced": "/ˈboʊɫdˌfeɪst/",
  "boogeyman": "/ˈbuɡiˌmæn/",
  "booklist": "/ˈbʊkɫɪst/",
  "bootstrapping": "/ˈbutstɹæpɪŋ/",
  "borehole": "/ˈbɔɹˌhoʊɫ/",
  "bosomy": "/ˈbʊzəmi/",
  "boson": "/ˈboʊzɑn/",
  "boss": "/ˈbɔs/",
  "boston": "/ˈbɔstən/",
  "bostonians": "/ˈbɔstoʊniənz/",
  "bottlenose": "/ˈbɑtəɫˌnoʊz/",
  "bottomland": "/ˈbɑtəmˌɫænd/",
  "bouche": "/ˈbuʃ/",
  "boudoir": "/ˈbuˌdwɑɹ/",
  "bouffant": "/buˈfɑnt/",
  "bouffanted": "/buˈfɑntəd/",
  "bought": "/ˈbɔt/",
  "bourgeois": "/bʊɹʒˈwɑ/",
  "bourgeon": "/ˈbɝdʒən/",
  "bourgeoned": "/ˈbɝdʒənd/",
  "bourgeoning": "/ˈbɝdʒənɪŋ/",
  "bowstring": "/ˈboʊstɹɪŋ/",
  "boxier": "/ˈbɑksiɝ/",
  "boyertown": "/ˈbɔɪɝˌtaʊn/",
  "brainiac": "/ˈbɹeɪniæk/",
  "brainstem": "/ˈbɹeɪnstɛm/",
  "bras": "/ˈbɹɑz/",
  "b'rer": "/ˈbɹɛɹ/",
  "breakups": "/ˈbɹeɪˌkəps/",
  "breastbone": "/ˈbɹɛstˌboʊn/",
  "breathable": "/ˈbɹiðəbəɫ/",
  "br'er": "/ˈbɹɛɹ/",
  "bringer": "/ˈbɹɪŋɝ/",
  "britney": "/ˈbɹɪtˌni/",
  "broderick's": '/ˈbɹɑdɹɪks/',
  "brogue": "/ˈbɹoʊɡ/",
  "brownian": "/ˈbɹaʊniən/",
  "bruiser": "/ˈbɹuzɝ/",
  "bruschetta": "/bɹuˈskɛtə/",
  "bryde": "/ˈbɹʊdə/",
  "bubblegum": "/ˈbəbəɫˌɡəm/",
  "budgie": "/ˈbədʒi/",
  "buffet": "/bəˈfeɪ/",
  "bulgur": "/ˈbəɫɡɝ/",
  "bulleted": "/ˈbʊɫətəd/",
  "bullfights": '/ˈbʊɫˌfaɪts/',
  "bullkelp": "/ˈbʊɫˌkɛɫp/",
  "bullwhip": "/ˈbəɫwɪp/",
  "bungle": "/ˈbəŋɡəɫ/",
  "bungled": "/ˈbəŋɡəɫd/",
  "bungling": "/ˈbəŋɡɫɪŋ/",
  "bunkbed": "/ˈbəŋkˌbɛd/",
  "busybody": "/ˈbɪziˌbɑdi/",
  "busybodies": "/ˈbɪziˌbɑdiz/",
  "butterfinger": "/ˈbətɝˌfɪŋɡɝ/",
  "byzantine": "/ˈbɪzənˌtin/",
  "c++": "/ˈsiˌpɫəsˈpɫəs/",
  "c#": "/ˌsiˈʃɑɹp/",
  "cæsar": "/ˈsizɝ/",
  "cacao": "/kəˈkaʊ/",
  "cads": '/ˈkædz/',
  "cabo": "/ˈkɑboʊ/",
  "café": "/kæˈfeɪ/",
  "cahokia": "/kəˈhoʊkiə/",
  "cahokian": "/kəˈhoʊkiən/",
  "caitlyn": "/ˈkeɪtɫɪn/",
  "calculational": "/ˌkæɫkjuˈɫeɪʃənəɫ/",
  "caliban": "/ˈkæɫəbæn/",
  "callout": "/ˈkɑɫaʊt/",
  "calm": "/ˈkɑm/",
  "caltech": "/ˌkæɫˈtɛk/",
  "calve": "/ˈkæv/",
  "camelia": "/kəˈmɪɫjə/",
  "camellia": "/kəˈmɪɫjə/",
  "camera": "/ˈkæmɹə/",
  "cameroonian": "/ˌkæməˈɹuniən/",
  "camo": "/ˈkæmoʊ/",
  "camphor": "/ˈkæmfɝ/",
  "cancelation": "/ˌkænsəˈɫeɪʃən/",
  "cancun": "/ˌkænˈkun/",
  "candide": "/kɑnˈdid/",
  "canoodle": "/kəˈnudəɫ/",
  "canoodling": "/kəˈnudəɫɪŋ/",
  "cantillate": "/ˈkæntəˌɫeɪt/",
  "cantillation": "/ˌkæntəˈɫeɪʃən/",
  "capacitive": "/kəˈpæsətɪv/",
  "cappuccino": "/ˌkæˌpəˈtʃinoʊ/",
  "capri": "/kæˈpɹi/",
  "capsicum": "/ˈkæpsəkəm/",
  "caramel": "/ˈkɑɹməɫ/",
  "caramelize": "/ˈkɑɹməˌɫaɪz/",
  "caramelized": "/ˈkɑɹməˌɫaɪzd/",
  "cardinality": "/kɑɹdɪˈnæɫɪti/",
  "cardioid": "/ˈkɑɹdiɔɪd/",
  "cardiometabolic": "/ˈkɑɹdioʊˌmɛtəˈbɑɫɪk/",
  "career": "/ˌkəɹˈɪɹ/",
  "carabiner": "/ˌkɛɹəˈbinɝ/",
  "carlsbad": "/ˈkɑɹɫzbæd/",
  "carotenoid": "/kəˈɹɑtənɔɪd/",
  "cartographer": "/ˌkɑɹˈtɑɡɹəfɝ/",
  "cartographic": "/ˌkɑɹtəˈɡɹæfɪk/",
  "cartographical": "/ˌkɑɹtəˈɡɹæfɪkəɫ/",
  "cartography": "/ˌkɑɹˈtɑɡɹəfi/",
  "cartoonish": "/kɑɹˈtunɪʃ/",
  "cartouche": "/kɑɹˈtuʃ/",
  "cartouches": "/kɑɹˈtuʃəz/",
  "cassina": "/kəˈsinə/",
  "castilian": "/kæˈstɪɫjən/",
  "catalpa": "/kəˈtæɫpə/",
  "catan": "/kəˈtɑn/",
  "catastrophically": "/ˌkætəˈstɹɑfɪkɫi/",
  "catatonic": "/ˌkætəˈtɑnɪk/",
  "catchphrase": "/ˈkætʃˌfɹeɪz/",
  "caterwauled": "/ˈkætɝwɑɫd/",
  "cauchy": "/koʊˈʃi/",
  "caught": "/ˈkɔt/",
  "caulk": "/ˈkɔk/",
  "causality": "/ˌkɔˈzæɫɪti/",
  "cause": "/ˈkɔz/",
  "caused": "/ˈkɔzd/",
  "causes": "/ˈkɔzɪz/",
  "causeway": "/ˈkɔzˌweɪ/",
  "causing": "/ˈkɔzɪŋ/",
  "caustic": "/ˈkɔstɪk/",
  "caution": "/ˈkɔʃən/",
  "cautioned": "/ˈkɔʃənd/",
  "cavatelli": "/kɑvəˈtɛɫi/",
  "caveat": "/ˈkæviˌɑt/",
  "caveats": "/ˈkæviˌɑts/",
  "cavemen": "/ˈkeɪvˌmɛn/",
  "cavorted": "/kəˈvɔɹtəd/",
  "cedilla": "/səˈdɪɫə/",
  "celebratory": "/ˈsɛɫəbɹətɔɹi/",
  "céline": "/səˈɫin/",
  "censorious": "/sɛnˈsɔɹiəs/",
  "censuring": "/ˈsɛnʃɝɪŋ/",
  "centenaries": "/sɛnˈtɛnəɹiz/",
  "centenary": "/sɛnˈtɛnəɹi/",
  "centrality": "/sɛnˈtɹæɫɪti/",
  "centric": "/ˈsɛntɹɪk/",
  "centripetal": "/sɛnˈtɹɪpətəɫ/",
  "centurion": "/sɛnˈtʃʊɹiən/",
  "ceremonially": "/ˌsɛɹəˈmoʊniəɫi/",
  "cerulean": "/səˈɹuɫiən/",
  "cézanne": "/sɛˈzɑn/",
  "chalet": "/ʃæˈɫeɪ/",
  "chalets": "/ʃæˈɫeɪz/",
  "chalk": "/ˈtʃɔk/",
  "chamomile": "/ˈkæməˌmiɫ/",
  "chancel": "/ˈtʃænsəɫ/",
  "chandra": "/ˈtʃɑndɹə/",
  "changeling": "/ˈtʃeɪndʒɫɪŋ/",
  "chanteuse": "/ʃænˈtuz/",
  "chaotically": "/keɪˈɑtɪkɫi/",
  "chaperoned": "/ˌʃæpɝˈoʊnd/",
  "chaperoning": "/ˌʃæpɝˈoʊnɪŋ/",
  "chatbot": "/ˈtʃætbɔt/",
  "chatgpt": "/ˈtʃætˈdʒiˈpiˈti/",
  "chatterley": "/ˈtʃætɝɫi/",
  "chattiness": "/ˈtʃætinəs/",
  "checkable": "/ˈtʃɛkəbəɫ/",
  "checkbox": "/ˈtʃɛkbɑks/",
  "cheekiness": "/ˈtʃikinəs/",
  "cheesiness": "/ˈtʃizinəs/",
  "cheeto": "/ˈtʃitoʊ/",
  "cheetos": "/ˈtʃitoʊz/",
  "chickpea": "/ˈtʃɪkˌpi/",
  "chihuahua": "/ˌtʃəˈwɑwə/",
  "chihuly": "/tʃəˈhuɫi/",
  "chipmunk": "/ˈtʃɪpˌməŋk/",
  "chipmunks": "/ˈtʃɪpˌməŋks/",
  "chiton": "/ˈkaɪtən/",
  "chloë": "/ˈkɫoʊi/",
  "chloé": "/ˈkɫoʊi/",
  "chocolatey": "/ˈtʃɔkɫəti/",
  "choker": "/ˈtʃoʊkɝ/",
  "choosey": "/ˈtʃusi/",
  "chordal": "/ˈkɔɹdəɫ/",
  "crabgrass": "/ˈkɹæbɡɹæs/",
  "cradled": "/ˈkɹeɪdəɫd/",
  "craftsperson": "/ˈkɹæfsˈpɝsən/",
  "craning": "/ˈkɹeɪnɪŋ/",
  "cravat": "/kɹəˈvæt/",
  "crichton": "/ˈkɹaɪtən/",
  "crimefighter": "/ˈkɹaɪmˌfaɪtɝ/",
  "crimefighting": "/ˈkɹaɪmˌfaɪtɪŋ/",
  "crinkle": "/ˈkɹɪnkəɫ/",
  "crinkled": "/ˈkɹɪnkəɫd/",
  "crinkling": "/ˈkɹɪnkɫɪŋ/",
  "crispier": "/ˈkɹɪspiɝ/",
  "crispiness": "/ˈkɹɪspinəs/",
  "crispr": "/ˈkɹɪspɝ/",
  "crumpling": "/ˈkɹəmpəɫɪŋ/",
  "crunchier": "/ˈkɹəntʃiɝ/",
  "cryonic": "/kɹaɪˈɑnɪk/",
  "cryptocurrencies": "/ˈkɹɪptoʊˌkɝənsiz/",
  "cryptocurrency": "/ˈkɹɪptoʊˌkɝənsi/",
  "cryptographer": "/kɹɪpˈtɑɡɹəfɝ/",
  "cryptographic": "/ˈkɹɪptoʊˈɡɹæfɪk/",
  "crystalize": "/ˈkɹɪstəˌɫaɪz/",
  "crystalized": "/ˈkɹɪstəˌɫaɪzd/",
  "crystalizing": "/ˈkɹɪstəˌɫaɪzɪŋ/",
  "chromatic": "/kɹoʊˈmætɪk/",
  "chromebook": "/ˈkɹoʊmˌbʊk/",
  "cinephile": "/ˈsɪnəˌfaɪɫ/",
  "circe": "/ˈsɝsi/",
  "circumnavigated": "/ˌsɝkəmˈnævəˌɡeɪtəd/",
  "cisgender": "/ˌsɪsˈdʒɛndɝ/",
  "cisgendered": "/ˌsɪsˈdʒɛndɝd/",
  "civilizing": "/ˈsɪvəˌɫaɪzɪŋ/",
  "civvy": "/ˈsɪvi/",
  "civvies": "/ˈsɪviz/",
  "clambake": "/ˈkɫæmˌbeɪk/",
  "classifier": "/ˈkɫæsəˌfaɪɝ/",
  "clawlike": "/ˈkɫɔˌɫaɪk/",
  "cleverest": "/ˈkɫɛvɝəst/",
  "cliché": "/kɫiˈʃeɪ/",
  "clichéd": "/kɫiˈʃeɪd/",
  "clichés": "/kɫiˈʃeɪz/",
  "clique": "/ˈkɫɪk/",
  "clitoris": "/ˈkɫɪtɝɪs/",
  "clouseau": "/ˌkɫuˈsoʊ/",
  "clownish": "/ˈkɫaʊnɪʃ/",
  "clumped": "/ˈkɫəmpt/",
  "clunkiness": "/ˈkɫənkinəs/",
  "co-worker": "/ˈkoʊˌwɝkɝ/",
  "co-workers": "/ˈkoʊˌwɝkɝz/",
  "coachella": "/koʊˈtʃɛɫə/",
  "coates": "/ˈkoʊts/",
  "cocreator": "/ˈkoʊkɹiˈeɪtɝ/",
  "codebreaking": "/ˈkoʊdˌbɹeɪkɪŋ/",
  "codename": "/ˈkoʊdˌneɪm/",
  "codependent": "/koʊdiˈpɛndənt/",
  "codex": "/ˈkoʊˌdɛks/",
  "codices": "/ˈkoʊdəsiz/",
  "codirect": "/ˌkoʊdəˈɹɛkt/",
  "coffee": "/ˈkɔfi/",
  "coffee's": "/ˈkɔfiz/",
  "cog": "/ˈkɑɡ/",
  "cognate": "/ˈkɑɡneɪt/",
  "collaborative": "/kəˈɫæbɹətɪv/",
  "collaboratively": "/kəˈɫæbɹətɪvɫi/",
  "colloquialism": "/kəˈɫoʊkwiəˌɫɪzəm/",
  "colonizing": "/ˈkɑɫəˌnaɪzɪŋ/",
  "colorado": "/ˌkɑɫɝˈɑdoʊ/",
  "columbian": "/kəˈɫəmbiən/",
  "combinator": "/ˈkɑmbɪneɪtɝ/",
  "combinatorial": "/ˌkɑmbɪnəˈtɔɹiəɫ/",
  "combinatoric": "/ˌkɑmbənəˈtɔɹɪk/",
  "combinatorics": "/ˌkɑmbənəˈtɔɹɪks/",
  "combustible": "/kəmˈbəstəbəɫ/",
  "combweed": "/ˈkoʊmˌwid/",
  "comfier": "/ˈkəmfiɝ/",
  "comingle": "/koʊˈmɪŋɡəɫ/",
  "commiserated": "/kəˈmɪsɝˌeɪtəd/",
  "communiqué": "/kəmˌjunəˈkeɪ/",
  "communique": "/kəmˌjunəˈkeɪ/",
  "communiques": "/kəmˌjunɪˈkeɪz/",
  "compendious": "/kəmˈpɛndiəs/",
  "composite": "/kəmˈpɑzət/",
  "compostable": "/kəmˈpoʊstəbəɫ/",
  "computation": "/ˌkɑmpjuˈteɪʃən/",
  "concavity": "/kənˈkævəti/",
  "conceptualization": '/kənˈsɛptʃuəɫɪˌzeɪʃən/',
  "conceptualize": '/kənˈsɛptʃuəˌɫaɪz/',
  "conceptualized": '/kənˈsɛptʃuəˌɫaɪzd/',
  "conceptualizes": '/kənˈsɛptʃuəˌɫaɪzɪz/',
  "conceptualizing": '/kənˈsɛptʃuəˌɫaɪzɪŋ/',
  "conduct": "/ˈkɑnˌdəkt/",
  "confederate": "/kənˈfɛdɝət/",
  "conference ": "/ˈkɑnfɹəns/",
  "configurable": "/kənˈfɪɡjɝəbəɫ/",
  "confit": "/koʊnˈfi/",
  "conflated": "/kənˈfɫeɪtəd/",
  "conflating": "/kənˈfɫeɪtɪŋ/",
  "confound": "/kənˈfaʊnd/",
  "conga": "/ˈkɑŋɡə/",
  "congratulate": "/kənˈɡɹædʒəˌɫeɪt/",
  "congratulated": "/kənˈɡɹædʒəˌɫeɪtɪd/",
  "congratulating": "/kənˈɡɹædʒəˌɫeɪtɪŋ/",
  "congratulation": "/kənˌɡɹædʒəˈɫeɪʃən/",
  "congratulations": "/kənˌɡɹædʒəˈɫeɪʃənz/",
  "congratulatory": "/kənˈɡɹædʒəɫəˌtɔɹi/",
  "congregating": "/ˈkɑŋɡɹəˌɡeɪtɪŋ/",
  "congruency": "/kənˈɡɹuənsi/",
  "congruencies": "/kənˈɡɹuənsiz/",
  "congruent": "/kənˈɡɹuənt/",
  "conjectured": "/kənˈdʒɛkʃɝd/",
  "conjectural": "/kənˈdʒɛkʃɝəɫ/",
  "conjugating": "/ˈkɑndʒuˌɡeɪtɪŋ/",
  "conlang": "/ˈkɑnɫæŋ/",
  "conlanger": "/ˈkɑnɫæŋɝ/",
  "conlanging": "/ˈkɑnɫæŋɪŋ/",
  "conquistador": "/kənˈkistədɔɹ/",
  "consensual": "/kənˈsɛnʃuəɫ/",
  "consensually": "/kənˈsɛnʃuəɫɫi/",
  "consequence": "/ˈkɑnsəˌkwəns/",
  "conservatory": '/kənˈsɝvəˌtɔɹi/',
  "consignee": "/ˌkɑnsaɪˈni/",
  "construct": "/kənˈstɹəkt/",
  "consumables": "/kənˈsuməbəɫz/",
  "contemporarily": "/kənˌtɛmpəˈɹɛɹəɫi/",
  "contemptuously": '/kənˈtɛmptʃuəsɫi/',
  "contoured": "/ˈkɑnˌtuɝd/",
  "contours": "/ˈkɑnˌtuɝz/",
  "contralto": "/kənˈtɹɑɫtoʊ/",
  "convalescing": "/ˌkɑnvəˈɫɛsɪŋ/",
  "convert": "/kənˈvɝt/",
  "coöperation": "/ˌkwɑpɝˈeɪʃən/",
  "cootie": "/ˈkuti/",
  "copepod": "/ˈkoʊpəˌpɑd/",
  "coppola": "/ˈkoʊpəɫə/",
  "copse": "/ˈkɑps/",
  "copulated": "/ˈkɑpjəˌɫeɪtɪd/",
  "copulating": "/ˈkɑpjəˌɫeɪtɪŋ/",
  "coquettish": "/koʊˈkɛtɪʃ/",
  "coral": "/ˈkoɹəɫ/",
  "coriander": "/ˈkɔɹiˌændɝ/",
  "cormac": "/ˈkɔɹmæk/",
  "cornflake": "/ˈkɔɹnˌfɫeɪk/",
  "coronavirus": "/kəˈɹoʊnəˌvaɪɹəs/",
  "corporeal": "/ˌkɔɹˈpɔɹiəɫ/",
  "cortana": "/kɔɹˈtɑnə/",
  "cortex": "/ˈkɔɹˌtɛks/",
  "corvid": "/ˈkɔɹvɪd/",
  "cosine": "/ˈkoʊˌsaɪn/",
  "cosmological": "/ˌkɑsməˈɫɑdʒəkəɫ/",
  "cosmologist": "/kɑsˈmɑɫədʒɪst/",
  "cosplay": "/ˈkɑzpɫeɪ/",
  "cosplayed": "/ˈkɑzpɫeɪd/",
  "cost": "/ˈkɔst/",
  "costed": "/ˈkɔstɪd/",
  "costly": "/ˈkɔstɫi/",
  "cotangent": "/ˌkoʊˈtændʒənt/",
  "cottontail": "/ˈkɑtənˌteɪɫ/",
  "cough": "/ˈkɔf/",
  "coughing": "/ˈkɔfɪŋ/",
  "counteract": "/ˌkaʊntɝˈækt/",
  "counterargument": "/ˈkaʊntɝˌɑɹɡjəmənt/",
  "counterexample": "/ˈkaʊnɝɪɡzˌæmpəɫ/",
  "counterexamples": "/ˈkaʊnɝɪɡzˌæmpəɫz/",
  "counterintuitive": "/ˌkaʊntɝˌɪnˈtuətɪv/",
  "countertendency": "/ˈkaʊntɝˈtɛndənsi/",
  "coursework": "/ˈkɔɹsˌwɝk/",
  "covid": "/ˈkoʊvɪd/",
  "covid-19": "/ˌkoʊvɪdˌnaɪnˈtin/",
  "cowrite": "/ˈkoʊˌɹaɪt/",
  "cowritten": "/ˈkoʊɹɪtən/",
  "cowry": "/ˈkaʊɹi/",
  "coyote": "/kaɪˈoʊti/",
  "css": "/ˈsiˈɛsˈɛs/",
  "creaminess": "/ˈkɹiminəs/",
  "cred": "/ˈkɹɛd/",
  "creepier": "/ˈkɹipɪɝ/",
  "creepily": "/ˈkɹipəɫi/",
  "cretan": "/ˈkɹitən/",
  "crispiest": "/ˈkɹɪspɪəst/",
  "critically": "/ˈkɹɪtɪkɫi/",
  "criticise": "/ˈkɹɪtɪˌsaɪz/",
  "criticised": "/ˈkɹɪtɪˌsaɪzd/",
  "croaked": "/ˈkɹoʊkt/",
  "crockpot": "/ˈkɹɑkˌpɑt/",
  "crossfit": "/ˈkɹɑsfɪt/",
  "crowdfund": "/ˈkɹaʊdˌfənd/",
  "crowdfunded": "/ˈkɹaʊdˌfəndəd/",
  "crowdsource": "/ˈkɹaʊdˌsɔɹs/",
  "crowdsourced": "/ˈkɹaʊdˌsɔɹst/",
  "crowdsourcing": "/ˈkɹaʊdˌsɔɹsɪŋ/",
  "cryptography": "/kɹɪpˈtɑɡɹəfi/",
  "cryptozoology": "/ˌkɹɪptoʊzuˈɑɫədʒi/",
  "cubie": "/ˈkjubi/",
  "culinary": "/ˈkəɫɪˌnɛɹi/",
  "cuneiform": "/kjuˈniəˌfɔɹm/",
  "cupped": "/ˈkəpt/",
  "curate": "/ˈkjʊɹeɪt/",
  "curated": "/ˈkjʊɹeɪtəd/",
  "curating": "/ˈkjʊɹeɪtɪŋ/",
  "curation": "/kjʊɹˈeɪʃən/",
  "curdle": "/ˈkɝdəɫ/",
  "curdled": "/ˈkɝdəɫd/",
  "curlew": "/ˈkɝɫu/",
  "current": "/ˈkɝənt/",
  "cursive": "/ˈkɝsɪv/",
  "cusses": "/ˈkəsəz/",
  "customization": "/ˌkəstəməˈzeɪʃən/",
  "cutting-edge": "/ˈkətɪŋˌɛdʒ/",
  "cyanobacteria": "/ˌsaɪənoʊbækˈtɪɹiə/",
  "cyanobacterium": "/ˌsaɪənoʊbækˈtɪɹiəm/",
  "cybersecurity": "/ˈsaɪbɝsɪkˈjʊɹəti/",
  "cybill": "/ˈsɪbəɫ/",
  "cyclic": "/ˈsɪkɫɪk/",
  "cyclical": "/ˈsɪkɫɪkəɫ/",
  "d&d": "/ˈdiənˈdi/",
  "dalí": "/dɑˈɫi/",
  "dalit": "/ˈdɑɫɪt/",
  "dalmation": "/dæɫˈmeɪʃən/",
  "damnit": "/ˈdæmɪt/",
  "danceable": "/ˈdænsəbəɫ/",
  "dapple": "/ˈdæpəɫ/",
  "dappled": "/ˈdæpəɫd/",
  "darnold": "/ˈdɑɹnəɫd/",
  "datasphere": "/ˈdætəˌsfɪɹ/",
  "davante": "/dəˈvɑnteɪ/",
  "dawdled": "/ˈdɔdəɫd/",
  "dba": "/ˈdiˈbiˈeɪ/",
  "de": "/də/",
  "deadpanned": "/ˈdɛdˌpænd/",
  "dealbreaker": "/ˈdiɫbɹeɪkɝ/",
  "debauch": "/dəˈbɔtʃ/",
  "debauched": "/dəˈbɔtʃt/",
  "debuccalization": "/diˌbəkəɫəˈzeɪʃən/",
  "decadal": "/ˈdɛkədəɫ/",
  "decarbonize": "/diˈkɑɹbənaɪz/",
  "deceives": "/dɪˈsivz/",
  "decibel": "/ˈdɛsəbəɫ/",
  "decipherable": "/dəˈsaɪfɝəbəɫ/",
  "decipherment": "/diˈsaɪfɝmɛnt/",
  "decipherments": "/diˈsaɪfɝmɛnts/",
  "deckbuilder": "/ˈdɛkbɪɫdɝ/",
  "deckbuilding": "/ˈdɛkbɪɫdɪŋ/",
  "decolonization": "/diˌkɑɫənɪˈzeɪʃən/",
  "decolonize": "/diˈkɑɫəˌnaɪz/",
  "decolonized": "/diˈkɑɫəˌnaɪzd/",
  "decolonizing": "/diˈkɑɫəˌnaɪzɪŋ/",
  "deconstructed": "/ˌdikənˈstɹəktɪd/",
  "decouple": "/diˈkəpəɫ/",
  "decoupled": "/diˈkəpəɫd/",
  "decoy": "/ˈdikɔɪ/",
  "decrypt": "/diˈkɹɪpt/",
  "decrypted": "/diˈkɹɪptəd/",
  "decryption": "/diˈkɹɪptʃən/",
  "dedekind": "/ˈdeɪdɪkɪnd/",
  "de-emphasize": "/diˈɛmfəˌsaɪz/",
  "de-emphasizes": "/diˈɛmfəˌsaɪzəs/",
  "de-emphasizing": "/diˈɛmfəˌsaɪzɪŋ/",
  "de-escalate": "/diˈɛskəˌɫeɪt/",
  "de-escalated": "/diˈɛskəˌɫeɪtɪd/",
  "de-escalating": "/diˈɛskəˌɫeɪtɪŋ/",
  "deepfake": "/ˈdipˈfeɪk/",
  "defaming": "/dɪˈfeɪmɪŋ/",
  "defcon": "/ˈdɛfˌkɑn/",
  "defecate": "/ˈdɛfəkeɪt/",
  "defecated": "/ˈdɛfəkeɪtəd/",
  "defile": "/dəˈfaɪɫ/",
  "defiling": "/dəˈfaɪɫɪŋ/",
  "definability": "/dəˌfaɪnəˈbɪɫəti/",
  "deforested": "/dɪˈfɔɹəstəd/",
  "deformable": "/ˌdiˈfɔɹməbəɫ/",
  "degrowth": "/ˌdiˈɡɹoʊθ/",
  "dehydrating": "/dɪˈhaɪdɹeɪtɪŋ/",
  "deirdre": "/ˈdɪɹdɹi/",
  "déjà": "/ˈdeʒa/",
  "delectably": "/dɪˈɫɛktəbɫi/",
  "delegitimize": "/diɫəˈdʒɪtəˌmaɪz/",
  "delegitimizing": "/diɫəˈdʒɪtəˌmaɪzɪŋ/",
  "deliciously": "/dɪˈɫɪʃəsɫi/",
  "delimit": "/dɪˈɫɪmɪt/",
  "delimited": "/dɪˈɫɪmɪtəd/",
  "deltoid": "/ˈdɛɫtɔɪd/",
  "demarcate": "/ˈdimɑɹˌkeɪt/",
  "demarcated": "/ˈdimɑɹˌkeɪtəd/",
  "demarcating": "/ˈdimɑɹˌkeɪtɪŋ/",
  "dementia": "/dɪˈmɛnʃə/",
  "demotic": "/dəˈmɑtɪk/",
  "dendrite": "/ˈdɛndɹaɪt/",
  "dengue": '/ˈdɛŋ/',
  "denialism": "/dɪˈnaɪəɫɪzm/",
  "denier": "/dɪˈnaɪɝ/",
  "depeche": "/dəˈpɛʃ/",
  "deprecation": "/ˌdɛpɹəˈkeɪʃən/",
  "desai": "/dɛˈsaɪ/",
  "d'état": "/deɪˈtɑ/",
  "detach": "/diˈtætʃ/",
  "detritus": "/dɪˈtɹaɪtəs/",
  "devo": "/ˈdivoʊ/",
  "devoice": "/ˌdiˈvɔɪs/",
  "devoiced": "/ˌdiˈvɔɪst/",
  "devolving": "/dɪˈvɑɫvɪŋ/",
  "deworm": "/ˌdiˈwɝm/",
  "dewormed": "/ˌdiˈwɝmd/",
  "deworming": "/ˌdiˈwɝmɪŋ/",
  "dexterous": "/ˈdɛkstəɹəs/",
  "día": "/ˈdiɑ/",
  "diachrony": "/ˈdaɪəˌkɹəni/",
  "diaereses": "/daɪˈɛɹəsiz/",
  "diaeresis": "/daɪˈɛɹəsɪs/",
  "diagramming": "/ˈdaɪəˌɡɹæmɪŋ/",
  "diatom": "/ˈdaɪətɑm/",
  "dichromacy": "/daɪˈkɹoʊməsi/",
  "dichromat": "/ˈdaɪkɹoʊˌmæt/",
  "dichromatic": "/ˌdaɪkɹoʊˈmætɪk/",
  "diderot": "/ˈdidəˌɹoʊ/",
  "dierdre": "/ˈdɪɹdɹə/",
  "dieter": "/ˈdaɪətɝ/",
  "different": "/ˈdɪfɹənt/",
  "differentiable": "/ˌdɪfɝˈɛnʃəbəɫ/",
  "differentiability": "/ˌdɪfɝˌɛnʃəˈbɪɫɪti/",
  "differentiator": "/ˌdɪfɝˈɛnʃiˌeɪtɝ/",
  "differently": "/ˈdɪfɹəntɫi/",
  "digitizer": "/ˈdɪdʒəˌtaɪzɝ/",
  "dihedral": "/ˌdaɪˈhidɹəɫ/",
  "dilettante": "/ˈdɪɫəˌtɑnt/",
  "diluted": "/dəˈɫutəd/",
  "dimethyl": "/daɪˈmɛθəɫ/",
  "dimwitted": "/ˈdɪmwɪtəd/",
  "dingbat": "/ˈdɪŋbæt/",
  "dingoes": "/ˈdɪŋɡoʊz/",
  "dinoflagellate": "/ˌdaɪnoʊˈfɫædʒəɫət/",
  "diogenes": "/daɪˈɑdʒəniz/",
  "dion": "/ˈdiˌɔn/",
  "diorama": "/ˌdaɪəˈɹɑmə/",
  "diphthongs": "/ˈdɪfθɔŋz/",
  "diple": "/ˈdɪpəɫ/",
  "direct": "/dəˈɹɛkt/",
  "directed": "/dəˈɹɛktəd/",
  "directing": "/dəˈɹɛktɪŋ/",
  "direction": "/dɝˈɛkʃən/",
  "directions": "/dɝˈɛkʃənz/",
  "director": "/dəˈɹɛktɝ/",
  "dirigible": "/dəˈɹɪdʒəbəɫ/",
  "disarrayed": "/ˌdɪsəˈɹeɪd/",
  "disassembly": "/ˌdɪsəˈsɛmbɫi/",
  "disbeliever": "/dɪsbəˈɫivɝ/",
  "discontinuous": "/ˌdɪskənˈtɪnjuəs/",
  "disembowel": "/ˌdɪsəmˈbaʊɫ/",
  "disemboweled": "/ˌdɪsəmˈbaʊɫd/",
  "disemboweling": "/ˌdɪsəmˈbaʊɫɪŋ/",
  "disentangling": "/ˌdɪsənˈtæŋɡɫɪŋ/",
  "dishware": "/ˈdɪʃwɛɹ/",
  "disincentivize": "/ˌdɪsɪnˈsɛntɪvaɪz/",
  "disincentivizing": "/ˌdɪsɪnˈsɛntɪvaɪzɪŋ/",
  "dismissively": "/dɪsˈmɪsɪvɫi/",
  "disproving": "/dɪsˈpɹuvɪŋ/",
  "disrupter": "/dɪsˈɹəptɝ/",
  "dissection": "/daɪˈsɛkʃən/",
  "dissociating": "/dɪˈsoʊʃieɪtɪŋ/",
  "dissociative": "/dɪˈsoʊʃəˌtɪv/",
  "districting": '/ˈdɪstɹɪktɪŋ/',
  "disyllabic": "/ˈdaɪsəˈɫæbɪk/",
  "ditzy": "/ˈdɪtsi/",
  "diverged": "/dəˈvɝdʒd/",
  "divergence": "/dəˈvɝdʒəns/",
  "djinn": "/ˈdʒɪn/",
  "documentarian": "/dɑkjumɛnˈtɛɹiən/",
  "documentation": "/ˌdɑkjəmənˈteɪʃən/",
  "dodecahedra": "/ˌdoʊdɛkəˈhidɹə/",
  "dodecahedron": "/ˌdoʊdɛkəˈhidɹən/",
  "dodgy": "/ˈdɑdʒi/",
  "doer": "/ˈduɝ/",
  "doggerland": "/ˈdɑɡɝɫənd/",
  "dogpound": "/ˈdɔɡpaʊnd/",
  "doodling": "/ˈdudɫɪŋ/",
  "doorframe": "/ˈdɔɹˌfɹeɪm/",
  "doorstop": "/ˈdɔɹstɑp/",
  "doppelgänger": "/ˈdɑpəɫɡæŋɝ/",
  "doppelganger": "/ˈdɑpəɫɡæŋɝ/",
  "dorothy": "/ˈdɔɹθi/",
  "dosed": "/ˈdoʊst/",
  "dostoyevsky": "/dɑstiˈɛvski/",
  "dotage": "/ˈdoʊtədʒ/",
  "doublet": "/ˈdəbɫət/",
  "doughty": "/ˈdaʊti/",
  "downloadable": "/ˌdaʊnˈɫoʊdəbəɫ/",
  "draconian": "/dɹəˈkoʊniən/",
  "dragonfly": "/ˈdɹæɡənfɫaɪ/",
  "dragonfruit": "/ˈdɹæɡənˌfɹut/",
  "dragoon": "/dɹəˈɡun/",
  "dragooned": "/dɹəˈɡund/",
  "dramatized": "/ˈdɹɑməˌtaɪzd/",
  "dreamily": "/ˈdɹiməɫi/",
  "dreaminess": "/ˈdɹiminəs/",
  "dredger": "/ˈdɹɛdʒɝ/",
  "drizzled": "/ˈdɹɪzəɫd/",
  "drolly": "/ˈdɹoʊɫi/",
  "dropback": "/ˈdɹɑpˌbæk/",
  "dropdown": "/ˈdɹɑpdaʊn/",
  "dua": "/ˈduə/",
  "dubliner": "/ˈdəbɫənɝ/",
  "dudes": "/ˈdudz/",
  "due": "/ˈdu/",
  "duet": "/duˈɛt/",
  "duets": "/duˈɛts/",
  "duey": "/ˈdui/",
  "dulaney": "/ˈduɫəni/",
  "dulany": "/duˈɫɔni/",
  "dulay": "/ˈduɫeɪ/",
  "duley": "/ˈduɫi/",
  "duling": "/ˈduɫɪŋ/",
  "dulong": "/ˈduɫɔŋ/",
  "dulude": "/ˈduˌɫud/",
  "dunces": "/ˈdənsəz/",
  "duolingo": "/ˈduoʊˈɫɪŋɡoʊ/",
  "duplicated": "/ˈdupɫɪˌkeɪtɪd/",
  "duplicates": "/ˈdupɫəˌkeɪts/",
  "duplication": "/ˌdupɫəˈkeɪʃən/",
  "durall": "/ˈduɹəɫ/",
  "duration": "/dʊˈɹeɪʃən/",
  "durations": "/dʊˈɹeɪʃənz/",
  "durell": "/ˈduɹəɫ/",
  "durene": "/ˈduɹin/",
  "durick": "/ˈduɹɪk/",
  "duris": "/ˈduɹɪs/",
  "durocher": "/ˈduɹəkɝ/",
  "duron": "/ˈduɹən/",
  "duross": "/ˈduɹəs/",
  "dusky": "/ˈdəski/",
  "düsseldorf": "/ˈdusəɫˌdɔɹf/",
  "duty": "/ˈduti/",
  "dynamical": "/daɪˈnæmɪkəɫ/",
  "dynamicist": "/daɪˈnæməsɪst/",
  "dysphoria": "/dɪsˈfɔɹiə/",
  "dystopia": "/dɪsˈtoʊpiə/",
  "dystopian": "/dɪsˈtoʊpiən/",
  "e.g.": "/ˌiˈdʒi/",
  "ear": "/ˈɪɹ/",
  "earbud": "/ˈɪɹˌbəd/",
  "eardrum": "/ˈɪɹdɹəm/",
  "earlobe": "/ˈɪɹˌɫoʊb/",
  "earthmover": "/ˈɝθˌmuvɝ/",
  "ebbed": "/ˈɛbd/",
  "echoless": "/ˈɛkoʊɫəs/",
  "ecommerce": "/ˌiˈkɑmɝs/",
  "ecotourism": "/ˌikoʊˈtɝɪzəm/",
  "ecumenism": "/ɛˈkjuməˌnɪzəm/",
  "edgelord": "/ˈɛdʒˌɫɔɹd/",
  "effaced": "/ɪˈfeɪst/",
  "effect": "/ɪˈfɛkt/",
  "effected": "/ɪˈfɛktɪd/",
  "effecting": "/ɪˈfɛktɪŋ/",
  "effective": "/ɪˈfɛktɪv/",
  "effectively": "/ɪˈfɛktɪvɫi/",
  "effectiveness": "/ɪˈfɛktɪvnəs/",
  "effects": "/ɪˈfɛkts/",
  "efficacy": "/ˈɛfɪkəsi/",
  "effing": "/ˈɛfɪŋ/",
  "eilish": "/ˈaɪɫɪʃ/",
  "eire": "/ˈɛɹ/",
  "either": "/ˈiðɝ/",
  "ejective": "/iˈdʒɛktɪv/",
  "elamite": "/ˈiɫəˌmaɪt/",
  "élan": "/eɪˈɫɑn/",
  "electroencephalography": "/əˌɫɛktɹoʊɛnsɛfəˈɫɑɡɹəfi/",
  "electronica": "/ˌɪˌɫɛkˈtɹɑnɪkə/",
  "electrophysiology": "/əˌɫɛktɹoʊfɪsiˈɑɫədʒi/",
  "eleven": "/iˈɫɛvən/",
  "eleventh": "/iˈɫɛvənθ/",
  "elide": "/ɪˈɫaɪd/",
  "elite": "/ɪˈɫit/",
  "elites": "/ɪˈɫits/",
  "elitism": "/ɪˈɫitɪzəm/",
  "elitist": "/ɪˈɫitɪst/",
  "elitists": "/ɪˈɫitɪsts/",
  "elliptic": "/iˈɫɪptɪk/",
  "eloped": '/ɪˈɫoʊpt/',
  "elrond": "/ˈɛɫɹɑnd/",
  "elucidating": "/ɪˈɫusəˌdeɪtɪŋ/",
  "elucidation": "/ɪˌɫusəˈdeɪʃən/",
  "elven": "/ˈɛɫvən/",
  "email": "/ˈimeɪɫ/",
  "emailed": "/ˈimeɪɫd/",
  "emailing": "/ˈimeɪɫɪŋ/",
  "emails": "/ˈimeɪɫz/",
  "emerge": "/iˈmɝdʒ/",
  "emerged": "/iˈmɝdʒd/",
  "emergence": "/ɪˈmɝdʒəns/",
  "emergencies": "/ɪˈmɝdʒənsiz/",
  "emergency": "/ɪˈmɝdʒənsi/",
  "emerges": "/iˈmɝdʒəz/",
  "emergent": "/ɪˈmɝdʒənt/",
  "emerging": "/iˈmɝdʒɪŋ/",
  "emirate": "/ˈɛmɝət/",
  "emoji": "/iˈmoʊdʒi/",
  "emote": "/iˈmoʊt/",
  "emoted": "/iˈmoʊtəd/",
  "emotion": "/ɪˈmoʊʃən/",
  "emotional": "/ɪˈmoʊʃənəɫ/",
  "emotionalism": "/ɪˈmoʊʃənəˌɫɪzəm/",
  "emotionally": "/ɪˈmoʊʃənəɫi/",
  "emotionless": "/ɪˈmoʊʃənɫəs/",
  "emotions": "/ɪˈmoʊʃənz/",
  "emotive": "/ɪˈmoʊtɪv/",
  "empathetically": "/ˌɛmpəˈθɛtɪkɫi/",
  "empathizing": "/ˈɛmpəˌθaɪzɪŋ/",
  "emulsify": "/iˈməɫsɪfaɪ/",
  "emulsified": "/iˈməɫsɪfaɪd/",
  "enameling": "/ɪˈnæməɫɪŋ/",
  "encoder": "/ɛnˈkoʊdɝ/",
  "encoders": "/ɛnˈkoʊdɝz/",
  "encodes": "/ɛnˈkoʊdz/",
  "encrustation": "/ɛnkɹəsˈteɪʃən/",
  "endometriosis": "/ˌɛndoʊˌmitɹiˈoʊsɪs/",
  "endoplasmic": "/ˌɛndoʊˈpɫæsmɪk/",
  "endurance": "/ɪnˈdɝəns/",
  "endure": "/ɪnˈdʊɹ/",
  "endured": "/ɪnˈdʊɹd/",
  "endures": "/ɪnˈdʊɹz/",
  "enduring": "/ɪnˈdʊɹɪŋ/",
  "enduser": "/ˈɛndˌjuzɝ/",
  "endusers": "/ˈɛndˌjuzɝz/",
  "engelbart": "/ˈɛŋɡəɫˌbɑɹt/",
  "enigmas": "/ɪˈnɪɡməz/",
  "enjoy": "/ɪnˈdʒɔɪ/",
  "enjoyable": "/ɪnˈdʒɔɪəbəɫ/",
  "enjoyably": "/ɪnˈdʒɔɪəbɫi/",
  "enjoyed": "/ɪnˈdʒɔɪd/",
  "enjoying": "/ɪnˈdʒɔɪɪŋ/",
  "enjoyment": "/ɪnˈdʒɔɪmənt/",
  "enjoyments": "/ɪnˈdʒɔɪmənts/",
  "enjoys": "/ɪnˈdʒɔɪz/",
  "enkidu": "/ˈɛnkidu/",
  "enthralling": "/ɛnˈθɹɔɫɪŋ/",
  "entomological": "/ˌɛntəməˈɫɑdʒɪkəɫ/",
  "entomologically": "/ˌɛntəməˈɫɑdʒɪkɫi/",
  "entropic": "/ɛnˈtɹoʊpɪk/",
  "enunciation": "/iˌnənsiˈeɪʃən/",
  "envelopment": "/ɛnˈvɛɫəpmənt/",
  "environment": '/ɪnˈvaɪɝmənt/',
  "environments": '/ɪnˈvaɪɝmənts/',
  "environmental": '/ɪnˌvaɪɹəˈmɛntəɫ/',
  "enya": "/ˈɛnjə/",
  "equalities": "/ɪˈkwɑɫətiz/",
  "equilateral": "/ˌikwɪˈɫætɝəɫ/",
  "erasure": "/ɪˈɹeɪʃɝ/",
  "erdős": "/ˈɛɹdəʃ/",
  "erectus": "/əˈɹɛktəs/",
  "erg": "/ˈɝɡ/",
  "erode": "/ɪˈɹoʊd/",
  "erupt": "/ɪˈɹəpt/",
  "escargot": "/ɛskɑɹˈɡoʊ/",
  "esperanto": "/ˌɛspɝˈɑntoʊ/",
  "espresso": "/ɛsˈpɹɛˌsoʊ/",
  "espressos": "/ɛsˈpɹɛˌsoʊz/",
  "espy": "/ɪˈspaɪ/",
  "estranged": "/ɪˈstɹeɪndʒd/",
  "ethno": "/ˈɛθnoʊ/",
  "ethnologist": "/ɛθˈnɑɫədʒɪst/",
  "ethnoreligious": "/ˌɛθnoʊɹiˈɫɪdʒəs/",
  "etymologist": "/ˌɛtɪˈmɑɫədʒɪst/",
  "euclidean": "/juˈkɫɪdiən/",
  "eugene": "/juˈdʒin/",
  "eugenicist": "/juˈdʒɛnəsɪst/",
  "eukaryote": "/juˈkɛɹiət/",
  "eukaryotic": "/ˌjukɛɹiˈɑtɪk/",
  "euro": "/ˈjɝˌoʊ/",
  "eurocentric": "/ˌjuɹoʊˈsɛntɹɪk/",
  "eurocentrism": "/ˌjuɹoʊˈsɛntɹɪzəm/",
  "eurogame": "/ˈjuɹoʊɡeɪm/",
  "euros": "/ˈjɝˌoʊz/",
  "euskara": "/jusˈkɑɹə/",
  "evacuate": "/iˈvækjəˌweɪt/",
  "evangelizing": "/iˈvændʒəˌɫaɪzɪŋ/",
  "every": '/ˈɛvɹi/',
  "everyman": "/ˈɛvɹiˌmæn/",
  "even": "/ˈivən/",
  "eventually": "/ɪˈvɛntʃwəɫi/",
  "evolutionarily": "/ˌɛvəˌɫuʃəˈnɛɹiəɫi/",
  "exactness": "/ɪɡˈzæktnəs/",
  "excretes": '/ɪksˈkɹits/',
  "excreting": "/ɪksˈkɹitɪŋ/",
  "excruciatingly": "/ˌɛksˈkɹuʃiˌeɪtɪŋɫi/",
  "exceptionalism": "/ɪkˈsɛpʃənəɫɪzəm/",
  "exfoliating": "/ɛksˈfoʊɫieɪtɪŋ/",
  "exhibitive": "/ɪkˈsɪbətɪv/",
  "existentialism": "/ˌɛɡˌzɪsˈtɛnʃəɫɪzəm/",
  "existentialist": "/ˌɛɡˌzɪsˈtɛnʃəɫɪst/",
  "exoplanet": "/ˈɛksoʊˌpɫænət/",
  "expansiveness": "/ɪkˈspænsəvnəs/",
  "experimentalism": "/ɪkˌspɛɹɪˈmɛntəɫɪzəm/",
  "exploitable": "/ɛksˈpɫɔɪtəbəɫ/",
  "exploitative": "/ɛkspɫɔɪˈteɪtɪv/",
  "explorable": "/ɪksˈpɫɔɹəbəɫ/",
  "explorables": "/ɪksˈpɫɔɹəbəɫz/",
  "exponential": "/ˌɛkspəˈnɛnʃəɫ/",
  "exponentially": "/ˌɛkspəˈnɛnʃəɫi/",
  "expository": "/ɛkˈspɑzəˌtoɹi/",
  "expressiveness": "/ɪksˈpɹɛsɪvnɛs/",
  "extensibility": "/ɛkˌstɛnsəˈbɪɫɪti/",
  "extensible": "/ɪkˈstɛnsəbəɫ/",
  "externalities": "/ˌɛkstɝˈnæɫətiz/",
  "externality": "/ˌɛkstɝˈnæɫəti/",
  "extortionate": "/ɛkˈstɔɹʃənət/",
  "extractive": "/ˌɛkˈstɹæktəv/",
  "extractor": "/ɪkˈstɹæktɝ/",
  "extrajudicial": "/ˌɛkstɹədʒuˈdɪʃəɫ/",
  "extraordinaire": "/ɛkˌstɹɔɹdɪˈnɛɹ/",
  "extraordinary": "/ˌɛkstɹˈɔɹdəˌnɛɹi/",
  "eyre": "/ˈɛɹ/",
  "f#": "/ˌɛfˈʃɑɹp/",
  "f'd": '/ˈɛft/',
  "f***ing": "/ˈɛfɪŋ/",
  "factorial": "/fækˈtɔɹiəɫ/",
  "façade": "/fəˈsɑd/",
  "faerie": "/ˈfɛɹi/",
  "fall": "/ˈfɔɫ/",
  "fallen": "/ˈfɔɫən/",
  "falling": "/ˈfɔɫɪŋ/",
  "falsehood": "/ˈfɔɫsˌhʊd/",
  "falsehoods": "/ˈfɔɫsˌhʊdz/",
  "familiarizing": "/fəˈmɪɫjɝˌaɪzɪŋ/",
  "fanbase": "/ˈfænbeɪs/",
  "fanciness": "/ˈfænsinəs/",
  "fandom": "/ˈfændəm/",
  "fanfiction": "/ˈfænˈfɪkʃən/",
  "fanged": "/ˈfæŋd/",
  "fantastical": "/fænˈtæstɪkəɫ/",
  "faring": "/ˈfɛɹɪŋ/",
  "farted": "/ˈfɑɹtɪd/",
  "fasciitis": "/ˌfæʃiˈaɪtəs/",
  "fast-paced": "/ˈfæstˈpeɪst/",
  "faun": "/ˈfɔn/",
  "faux": "/ˈfɔ/",
  "faustian": "/ˈfaʊstiən/",
  "favorite": "/ˈfeɪvɹət/",
  "favorites": "/ˈfeɪvɹəts/",
  "fawned": "/ˈfɔnd/",
  "fearmonger": "/ˈfɪɹˌmɑŋɡɝ/",
  "febrile": "/ˈfɛbɹaɪɫ/",
  "fecund": "/ˈfɛkənd/",
  "fedorov": "/ˈfɛdɝɑv/",
  "ferment": "/fɝˈmɛnt/",
  "feting": "/ˈfeɪtɪŋ/",
  "fetishistic": "/ˌfɛtəˈʃɪstɪk/",
  "feynman": "/ˈfaɪnmən/",
  "fiancé": "/fiˈɑnseɪ/",
  "fiancée": "/fiˈɑnseɪ/",
  "fiancee": "/fiˈɑnseɪ/",
  "fiat": "/ˈfiət/",
  "fiche": "/ˈfiʃ/",
  "fidelity": "/ˌfɪˈdɛɫəti/",
  "fiennes": "/ˈfaɪnz/",
  "fifths": "/ˈfɪfθs/",
  "fight's": '/ˈfaɪts/',
  "figuratively": "/ˈfɪɡjɝətɪvɫi/",
  "filmgoer": "/ˈfɪɫmˌɡoʊɝ/",
  "financial": "/fəˈnænʃəɫ/",
  "financial's": "/fɪˈnænʃəɫz/",
  "financially": "/fəˈnænʃəɫi/",
  "financials": "/fəˈnænʃəɫz/",
  "financialization": "/fəˌnænʃəɫɪˈzeɪʃən/",
  "finland": "/ˈfɪnɫənd/",
  "firehose": "/ˈfaɪɝˌhoʊz/",
  "firelight": "/ˈfaɪɝˌɫaɪt/",
  "firepit": "/ˈfaɪɝˌpɪt/",
  "firmament": "/ˈfɝməmənt/",
  "firsthand": "/ˈfɝstˈhænd/",
  "fisheye": "/ˈfɪʃˌaɪ/",
  "fishnet": "/ˈfɪʃnɛt/",
  "fizzed": "/ˈfɪzd/",
  "fizzing": "/ˈfɪzɪŋ/",
  "flappy": "/ˈfɫæpi/",
  "flavour": "/ˈfɫeɪvɝ/",
  "fleabag": "/ˈfɫiˌbæɡ/",
  "fleuron": "/ˈfɫɝɑn/",
  "flexagon": "/ˈfɫɛksəˌɡɑn/",
  "flexor": "/ˈfɫɛksɝ/",
  "flicked": "/ˈfɫɪkt/",
  "flimsier": "/ˈfɫɪmziɝ/",
  "flirty": "/ˈfɫɝti/",
  "flub": "/ˈfɫəb/",
  "flubbed": "/ˈfɫəbd/",
  "fmri": "/ˈɛfˈɛmˈɑɹˈaɪ/",
  "focussing": "/ˈfoʊkəsɪŋ/",
  "foetus": "/ˈfitəs/",
  "foie": "/ˈfwɑ/",
  "folklorist": "/ˈfoʊkˌɫɔɹɪst/",
  "footstool": "/ˈfʊtˌstuɫ/",
  "foraged": "/ˈfɔɹɪdʒd/",
  "forager": "/ˈfɔɹədʒɝ/",
  "forbear": "/fɔɹˈbɛɹ/",
  "forbidden": "/fɝˈbɪdən/",
  "foreskin": "/ˈfɔɹˌskɪn/",
  "foreshore": "/ˈfɔɹʃɔɹ/",
  "formatted": "/ˈfɔɹˌmætəd/",
  "formulae": "/ˈfɔɹmjəˌɫi/",
  "fornicate": "/ˈfɔɹnəˌkeɪt/",
  "fornicated": "/ˈfɔɹnəˌkeɪtəd/",
  "fornicating": "/ˈfɔɹnəˌkeɪtɪŋ/",
  "foretaste": "/ˈfɔɹˌteɪst/",
  "foretastes": "/ˈfɔɹˌteɪsts/",
  "forte": "/ˈfɔɹˌteɪ/",
  "fortition": "/ˌfɔɹˈtɪʃən/",
  "fortran": "/ˈfɔɹtɹæn/",
  "49ers": "/ˈfɔɹtiˈnaɪnɝz/",
  "fossilization": "/ˌfɑsəɫəˈzeɪʃən/",
  "fossilizing": "/ˈfɑsəˌɫaɪzɪŋ/",
  "foster": "/ˈfɔstɝ/",
  "foster's": "/ˈfɔstɝz/",
  "fostered": "/ˈfɔstɝd/",
  "fostering": "/ˈfɔstɝɪŋ/",
  "fosters": "/ˈfɔstɝz/",
  "fourteen": "/ˈfɔɹˈtin/",
  "fourteens": "/ˈfɔɹˈtinz/",
  "fourteenth": "/ˈfɔɹˈtinθ/",
  "frappucino": "/ˌfɹæpəˈtʃinoʊ/",
  "frat": "/ˈfɹæt/",
  "freakish": "/ˈfɹikəʃ/",
  "freakishly": "/ˈfɹikəʃɫi/",
  "freethinker": "/ˈfɹiˈθɪnkɝ/",
  "freethinking": "/ˈfɹiˈθɪnkɪŋ/",
  "frenetically": "/fɹəˈnɛtɪkɫi/",
  "frequent": "/ˈfɹikwənt/",
  "fretboard": "/ˈfɹɛtˌbɔɹd/",
  "freyja": "/ˈfɹeɪə/",
  "fricative": "/ˈfɹɪkətɪv/",
  "fricatives": "/ˈfɹɪkətɪvz/",
  "friendless": "/ˈfɹɛndɫəs/",
  "frisbee": "/ˈfɹɪzbi/",
  "frisbie": "/ˈfɹɪzbi/",
  "frisby": "/ˈfɹɪzbi/",
  "frisian": "/ˈfɹɪʒən/",
  "frites": "/ˈfɹit/",
  "froggy": "/ˈfɹɑɡi/",
  "frontman": "/ˈfɹəntˌmæn/",
  "frontwoman": "/ˈfɹəntˌwʊmən/",
  "fruitfully": "/ˈfɹutfəɫi/",
  "fuca": "/ˈfjuˌkə/",
  "fulminated": "/ˈfʊɫməˌneɪtəd/",
  "fundraised": "/ˈfəndɹeɪzd/",
  "funereal": "/fjuˈnɪɹiəɫ/",
  "furl": "/ˈfɝɫ/",
  "furled": "/ˈfɝɫd/",
  "furthermore": "/ˌfɝðɝˈmɔɹ/",
  "gaiety": "/ˈɡeɪɪti/",
  "galadriel": "/ɡəˌɫædɹiˈɛɫ/",
  "galápagos": "/ɡəˈɫɑpəɡoʊs/",
  "galapagos": "/ɡəˈɫɑpəɡoʊs/",
  "galaxian": "/ɡəˈɫæksiən/",
  "gallimaufry": "/ˌɡæɫəˈmɑfɹi/",
  "gamergate": "/ˈɡeɪmɝˌɡeɪt/",
  "gamified": "/ˈɡeɪməfaɪd/",
  "gamify": "/ˈɡeɪməfaɪ/",
  "garcía": "/ɡɑɹˈsiə/",
  "garrett's": '/ˈɡɛɹɪts/',
  "gaslit": "/ˈɡæsɫɪt/",
  "gastronomical": "/ˌɡæstɹəˈnɑməkəɫ/",
  "gastropub": "/ˈɡæstɹoʊˌpəb/",
  "gasworks": "/ˈɡæswɝks/",
  "gatorade": "/ˈɡeɪtɝˌeɪd/",
  "gawain": "/ɡəˈweɪn/",
  "gawp": "/ˈɡɔp/",
  "g'day": "/ɡəˈdeɪ/",
  "gdp": "/ˈdʒiˈdiˈpi/",
  "geddy": "/ˈɡɛdi/",
  "gelatinize": "/dʒəˈɫætənaɪz/",
  "gelatinized": "/dʒəˈɫætənaɪzd/",
  "generalizable": "/ˌdʒɛnɝəˈɫaɪzəbəɫ/",
  "generis": "/ˈdʒɛnɝəs/",
  "genomic": "/dʒəˈnoʊmɪk/",
  "genomics": "/dʒəˈnoʊmɪks/",
  "genomicist": "/dʒəˈnoʊməsɪst/",
  "genuine": "/ˈdʒɛnjəwən/",
  "genuinely": "/ˈdʒɛnjəwənɫi/",
  "geochemical": "/ˈdʒioʊˈkɛməkəɫ/",
  "geoglyph": "/ˈdʒioʊɡɫɪf/",
  "geometer": "/dʒiˈɑmətɝ/",
  "geophysicist": "/dʒioʊˈfɪzɪsɪst/",
  "geopolitics": "/ˌdʒioʊˈpɑɫəˌtɪks/",
  "geoscientist": "/dʒioʊˈsaɪəntɪst/",
  "gestalt": "/ɡəˈstɑɫt/",
  "gestated": "/ˈdʒɛsteɪtəd/",
  "gestating": "/ˈdʒɛsteɪtɪŋ/",
  "gestural": "/ˈdʒɛstʃɝəɫ/",
  "giantess": "/ˈdʒaɪəntəs/",
  "gigantism": "/dʒaɪˈɡæntɪzəm/",
  "gilgamesh": "/ˈɡɪɫɡəmɛʃ/",
  "gilmour": "/ˈɡɪɫmoɹ/",
  "girded": "/ˈɡɝdəd/",
  "givewell": "/ˈɡɪvˌwɛɫ/",
  "gizmodo": "/ɡɪzˈmoʊdoʊ/",
  "gladiatorial": "/ˌɡɫædəˈtoʊɹiəɫ/",
  "glascow": "/ˈɡɫæskoʊ/",
  "glaswegian": "/ɡɫæsˈwidʒən/",
  "gleick": "/ˈɡɫaɪk/",
  "glimpsing": "/ˈɡɫɪmpsɪŋ/",
  "globule": "/ˈɡɫɑbjuɫ/",
  "gloop": "/ˈɡɫup/",
  "glottalization": "/ˌɡɫɑtəɫəˈzeɪʃən/",
  "gluey": "/ˈɡɫui/",
  "glug": "/ˈɡɫəɡ/",
  "gluing": "/ˈɡɫuɪŋ/",
  "gluon": "/ˈɡɫuɑn/",
  "glute": "/ˈɡɫut/",
  "glyph": "/ˈɡɫɪf/",
  "glyphs": "/ˈɡɫɪfs/",
  "go-ahead": "/ˈɡoʊəˌhɛd/",
  "go-go": "/ˈɡoʊˌɡoʊ/",
  "go-gos": "/ˈɡoʊˌɡoʊz/",
  "go-go's": "/ˈɡoʊˌɡoʊz/",
  "gobbler": "/ˈɡɑbɫɝ/",
  "gobblers": "/ˈɡɑbɫɝz/",
  "godlike": "/ˈɡɑdɫaɪk/",
  "goldendoodle": "/ˈɡoʊɫdəndudəɫ/",
  "gondor": "/ˈɡɑndɔɹ/",
  "gonna": "/ˈɡənə/",
  "gonzález": "/ɡənˈzɑɫəz/",
  "good-bye": "/ɡɪdˈbaɪ/",
  "goofiness": "/ˈɡufinɛs/",
  "gop": "/dʒiˌoʊˈpi/",
  "gorse": "/ˈɡɔɹs/",
  "gosling": "/ˈɡɑzɫɪŋ/",
  "gossiped": "/ˈɡɑsəpt/",
  "gossiping": "/ˈɡɑsəpɪŋ/",
  "gourmand": "/ɡʊɹˈmɑnd/",
  "gourmet": "/ˌɡɔɹˈmeɪ/",
  "gödel": "/ˈɡɝdəɫ/",
  "gödel's": "/ˈɡɝdəɫz/",
  "gramophone": "/ˈɡɹæməˌfoʊn/",
  "grammarian": "/ɡɹəˈmɛɹiən/",
  "grammars": '/ˈɡɹæmɝz/',
  "grandeur": "/ˈɡɹændʒɝ/",
  "gras": "/ˈɡɹɑ/",
  "gratitude": '/ˈɡɹætəˌtud/',
  "gravitas": "/ˈɡɹævəˌtɑs/",
  "graviton": "/ˈɡɹævətɑn/",
  "grayscale": "/ˈɡɹeɪˌskeɪɫ/",
  "grazie": "/ˈɡɹɑtsi/",
  "greta": "/ˈɡɹɛtə/",
  "gretta": "/ˈɡɹɛtə/",
  "greyscale": "/ˈɡɹeɪˌskeɪɫ/",
  "grift": "/ˈɡɹɪft/",
  "grifter": "/ˈɡɹɪftɝ/",
  "grifters": "/ˈɡɹɪftɝz/",
  "grifts": "/ˈɡɹɪfts/",
  "grocery": "/ˈɡɹoʊsɹi/",
  "grok": "/ˈɡɹɑk/",
  "grooved": "/ˈɡɹuvd/",
  "groupoid": "/ˈɡɹupɔɪd/",
  "groupthink": "/ˈɡɹupˌθɪŋk/",
  "growling": "/ˈɡɹaʊɫɪŋ/",
  "guernica": "/ˈɡwɛɹnɪkə/",
  "gumball": "/ˈɡəmˌbɔɫ/",
  "gunk": "/ˈɡənk/",
  "gustave": "/ˈɡustɑv/",
  "guyanese": "/ˌɡaɪəˈnis/",
  "gyllenhaal": "/ˈɡɪɫənhɑɫ/",
  "gymnasts": "/ˈdʒɪmnəsts/",
  "gyre": "/ˈdʒaɪɝ/",
  "h2o": "/ˈeɪtʃˈtuˈoʊ/",
  "häagen-dazs": "/ˈhɑɡənˌdɑs/",
  "habituate": "/həˈbɪtʃueɪt/",
  "habituation": "/həˌbɪtʃuˈeɪʃən/",
  "hacky": "/ˈhæki/",
  "hadrian": "/ˈheɪdɹiən/",
  "haha": "/ˈhɑˈhɑ/",
  "halen": "/ˈheɪɫən/",
  "halicarnassus": "/ˌhæɫəkɑɹˈnæsəs/",
  "hampshire": "/ˈhæmpʃɝ/",
  "handlebarred": "/ˈhændəɫˌbɑɹd/",
  "handmaiden": "/ˈhændˌmeɪdən/",
  "handoff": "/ˈhændɑf/",
  "handwash": "/ˈhændwɑʃ/",
  "hanging": "/ˈhæŋɪŋ/",
  "hangings": "/ˈhæŋɪŋz/",
  "hangout": "/ˈhæŋˌaʊt/",
  "hangouts": "/ˈhæŋˌaʊts/",
  "hangover": "/ˈhæŋˌoʊvɝ/",
  "hangovers": "/ˈhæŋˌoʊvɝz/",
  "hank's": '/ˈhæŋks/',
  "haptics": "/ˈhæptɪks/",
  "harappan": "/hɑˈɹɑpən/",
  "harding's": '/ˈhɑɹdɪŋz/',
  "harmonically": "/hɑɹˈmɑnɪkɫi/",
  "hasp": "/ˈhæsp/",
  "hatchling": "/ˈhætʃɫɪŋ/",
  "hawed": "/ˈhɔd/",
  "hazily": "/ˈheɪzəɫi/",
  "headcase": "/ˈhɛdkeɪs/",
  "headlamp": "/ˈhɛdˌɫæmp/",
  "headspace": "/ˈhɛdˌspeɪs/",
  "heartbreaker": "/ˈhɑɹtˌbɹeɪkɝ/",
  "heathland": "/ˈhiθɫənd/",
  "hedgerow": "/ˈhɛdʒˌɹoʊ/",
  "heisenberg": "/ˈhaɪzənbɝɡ/",
  "heliocentric": "/ˌhiɫioʊˈsɛntɹɪk/",
  "hellbent": "/ˈhɛɫbɛnt/",
  "hellbound": "/ˈhɛɫbaʊnd/",
  "helsinki": "/hɛɫˈsɪŋki/",
  "hemimastigote": "/ˌhɛmiˈmæstəˌɡoʊt/",
  "heracles": "/ˈhɛɹəkɫiz/",
  "herculaneum": "/ˌhɝkjəˈɫeɪniəm/",
  "hercule": "/ˈhɝkjuɫ/",
  "herder": "/ˈhɝdɝ/",
  "here": "/ˈhɪɹ/",
  "hermione": "/hɝˈmaɪəni/",
  "hermite": "/hɝˈmit/",
  "hero": "/ˈhɪɹoʊ/",
  "herodotus": "/ˌhɛɹəˈdɑtəs/",
  "hertzfeld": "/ˈhɝtsfɛɫd/",
  "hexaflexagon": "/ˌhɛksəˈfɫɛksəɡɑn/",
  "hibernating": "/ˈhaɪbɝˌneɪtɪŋ/",
  "hieronymus": "/haɪˈɹɑnəməs/",
  "highlife": "/ˈhaɪˌɫaɪf/",
  "highlighter": "/ˈhaɪˌɫaɪtɝ/",
  "high-rise": "/ˈhaɪˌɹaɪz/",
  "high-rises": "/ˈhaɪˌɹaɪzəz/",
  "hippy": "/ˈhɪpi/",
  "hispaniola": "/hɪˌspɑˈnjoʊɫə/",
  "hm": "/ˈhm̩/",
  "hmm": "/ˈhm̩ː/",
  "hmmm": "/ˈhm̩ː/",
  "hoardability": "/ˌhɔɹdəˈbɪɫəti/",
  "hobbes": "/ˈhɑbz/",
  "hod": "/ˈhɑd/",
  "hofstadter": "/ˈhɑfstædɝ/",
  "hollings": '/ˈhɑɫɪŋz/',
  "homebodies": "/ˈhoʊmˌbɑdiz/",
  "homebody": "/ˈhoʊmˌbɑdi/",
  "homebrew": "/ˈhoʊmbɹu/",
  "homefield": "/ˈhoʊmˈfiɫd/",
  "homeomorphic": "/ˌhoʊmiəˈmɔɹfɪk/",
  "homeschool": "/ˈhoʊmˈskuɫ/",
  "homeschooled": "/ˈhoʊmˈskuɫd/",
  "homeschooling": "/ˈhoʊmˈskuɫɪŋ/",
  "hominin": "/ˈhɑmənən/",
  "homogecene": "/həˈmɑdʒəsin/",
  "homogenize": "/həˈmɑdʒəˌnaɪz/",
  "homogenizing": "/həˈmɑdʒəˌnaɪzɪŋ/",
  "homology": "/həˈmɑɫədʒi/",
  "homunculi": "/hoʊˈməŋkjuˌɫaɪ/",
  "homunculus": "/hoʊˈməŋkjuɫəs/",
  "honeycrisp": "/ˈhəniˌkɹɪsp/",
  "hooved": "/ˈhuvd/",
  "horsehair": "/ˈhɔɹsˌhɛɹ/",
  "hothead": "/ˈhɑthɛd/",
  "houseplant": "/ˈhaʊsˌpɫænt/",
  "html": "/ˈeɪtʃˈtiˈɛmˈɛɫ/",
  "http": "/ˈeɪtʃˈtiˈtiˈpi/",
  "https": "/ˈeɪtʃˈtiˈtiˈpiˈɛs/",
  "humanlike": "/ˈhjumənɫaɪk/",
  "hundred": "/ˈhəndɹəd/",
  "hunted": "/ˈhəntɪd/",
  "hurricane": "/ˈhɝəˌkeɪn/",
  "hurtling": "/ˈhɝtəɫɪŋ/",
  "hutterite": "/ˈhətɝaɪt/",
  "huygens": "/ˈhɔɪdʒənz/",
  "hybridity": "/haɪˈbɹɪdəti/",
  "hydrangea": "/haɪˈdɹeɪndʒə/",
  "hydrating": "/ˈhaɪˌdɹeɪtɪŋ/",
  "hypercompetitive": "/ˈhaɪpɝkəmˈpɛtətɪv/",
  "hyperdiverse": "/ˈhaɪpɝdaɪˈvɝs/",
  "hyperfocus": "/ˌhaɪpɝˈfoʊkəs/",
  "hypergraph": "/ˈhaɪpɝˌɡɹæf/",
  "hyperrational": "/ˌhaɪpɝˈɹæʃənəɫ/",
  "hypersane": "/ˈhaɪpɝˈseɪn/",
  "hypersanity": "/ˈhaɪpɝˈsænəti/",
  "hyperspecific": "/ˌhaɪpɝspəˈsɪfɪk/",
  "hyperventilate": "/ˌhaɪpɝˈvɛnəˌɫeɪt/",
  "hyperventilated": "/ˌhaɪpɝˈvɛnəˌɫeɪtəd/",
  "hyperventilating": "/ˌhaɪpɝˈvɛnəˌɫeɪtɪŋ/",
  "hypotenuse": "/haɪˈpɑtənus/",
  "hysteresis": "/hɪstɝˈisəs/",
  "hz": '/ˈhɝts/',
  "iambic": "/aɪˈæmbɪk/",
  "icelander": "/ˈaɪsɫəndɝ/",
  "ick": "/ˈɪk/",
  "icky": "/ˈɪki/",
  "iconicity": "/ˌaɪkəˈnɪsəti/",
  "icosahedron": "/ˌaɪkɑsəˈhidɹən/",
  "icosahedra": "/ˌaɪkɑsəˈhidɹə/",
  "ideate": "/ˈaɪdieɪt/",
  "identities": "/aɪˈdɛnɪtiz/",
  "identity": "/aɪˈdɛnɪti/",
  "idiolect": "/ˈɪdioʊɫɛkt/",
  "idk": "/ˈaɪˈdiˈkeɪ/",
  "idolization": "/ˈaɪdəˌɫəzˈeɪʃən/",
  "i.e.": "/ˌaɪˈi/",
  "ie": "/ˌaɪˈi/",
  "ii": "/ˈtu/",
  "iii": "/ˈθɹi/",
  "illuminate": "/ˌɪˈɫuməˌneɪt/",
  "illustrative": '/ˌɪɫəˈstɹeɪtɪv/',
  "imbalanced": "/ɪmˈbæɫənst/",
  "imbecile": "/ˈɪmbəsəɫ/",
  "immersive": "/ɪˈmɝsəv/",
  "immersing": "/ɪˈmɝsɪŋ/",
  "immiserate": "/ɪˈmɪsɝˌeɪt/",
  "immiseration": "/ɪˌmɪsɝˈeɪʃən/",
  "immodest": "/ɪˈmɑdəst/",
  "immodestly": "/ɪˈmɑdəstɫi/",
  "immunocompromised": "/ɪˌmjunoʊˈkɑmpɹəmaɪzd/",
  "impactful": "/ɪmˈpæktfəɫ/",
  "imperishable": "/ɪmˈpɛɹɪʃəbəɫ/",
  "impermeable": "/ɪmˈpɝmiəbəɫ/",
  "impermanence": "/ˌɪmˈpɝmənəns/",
  "impermanent": "/ˌɪmˈpɝmənənt/",
  "imperturbable": "/ɪmpɝˈtɝbəbəɫ/",
  "implausibility": "/ɪmˌpɫɔzəˈbɪɫəti/",
  "implosive": "/ɪmˈpɫoʊsɪv/",
  "impress": "/ɪmˈpɹɛs/",
  "inaccuracies": "/ˌɪˈnækjɝˌəsiz/",
  "inadequate": "/ˌɪˈnædəkwət/",
  "inanity": "/ɪˈnænəti/",
  "inasmuch": "/ˈɪnæzˌmətʃ/",
  "inauthentic": "/ɪnəˈθɛnɪk/",
  "inauthenticly": "/ɪnəˈθɛnɪkɫi/",
  "incan": "/ˈɪnkən/",
  "incandescence": "/ˌɪnkænˈdɛsəns/",
  "incentivize": "/ɪnˈsɛntəvaɪz/",
  "incentivized": "/ɪnˈsɛntəvaɪzd/",
  "incentivizing": "/ɪnˈsɛntəvaɪzɪŋ/",
  "incestuous": '/ˌɪnˈsɛstʃuəs/',
  "indecipherable": "/ˌɪndəˈsaɪfɝəbəɫ/",
  "indelicacy": "/ɪnˈdɛɫəkəsi/",
  "indescribably": "/ˌɪndɪsˈkɹaɪbəbɫi/",
  "indeterminism": "/ɪndɪˈtɝməˌnɪzəm/",
  "indirection": "/ɪndɝˈɛkʃən/",
  "inelegant": "/ɪnˈɛɫɪɡənt/",
  "inelegantly": "/ɪnˈɛɫɪɡəntɫi/",
  "ineluctability": "/ɪniˌɫəktəˈbɪɫəti/",
  "ineluctable": "/ɪniˈɫəktəbəɫ/",
  "ineluctably": "/ɪniˈɫəktəbɫi/",
  "inestimable": "/ɪnˈɛstəməbəɫ/",
  "infamously": "/ˈɪnfəməsɫi/",
  "infinities": "/ˌɪnˈfɪnɪtiz/",
  "infinitude": "/ɪnˈfɪnətud/",
  "infinitum": "/ˌɪnfəˈnaɪtəm/",
  "inflect": "/ɪnˈfɫɛkt/",
  "influencer": "/ˈɪnfɫuənsɝ/",
  "infrastructure": "/ˈɪnfɹəˌstɹəktʃɝ/",
  "ingalls": "/ˈɪŋɡəɫz/",
  "ingrain": "/ˌɪnˈɡɹeɪn/",
  "innovating": "/ˈɪnəˌveɪtɪŋ/",
  "innovator's": "/ˈɪnəˌveɪtɝz/",
  "inquiries": "/ˈɪnkwəɹiz/",
  "inquiry": "/ˈɪnkwəɹi/",
  "ins": "/ˈɪnz/",
  "insectoid": "/ɪnˈsɛktɔɪd/",
  "insensate": "/ɪnˈsɛnˌseɪt/",
  "inside": "/ˌɪnˈsaɪd/",
  "insignificance": "/ˌɪnsɪɡˈnɪfɪkəns/",
  "insignificant": "/ˌɪnsɪɡˈnɪfɪkənt/",
  "instantaneous": "/ˌɪnstənˈteɪniəs/",
  "institute": "/ˈɪnstɪˌtut/",
  "insubordinate": "/ˌɪnsəˈbɔɹdənət/",
  "insurrectionary": "/ɪnsɝˈɛkʃənɛɹi/",
  "intaglio": "/ˌɪnˈtæɫjoʊ/",
  "intangibility": "/ɪntændʒəˈbɪɫəti/",
  "intensifier": "/ɪnˈtɛnsəˌfaɪɝ/",
  "intentionality": "/ɪntɛnʃəˈnæɫɪti/",
  "interchanged": "/ˌɪnɝˈtʃeɪndʒd/",
  "interdental": "/ˌɪntɝˈdɛntəɫ/",
  "interdimensional": "/ɪntɝdɪˈmɛnʃənəɫ/",
  "interfuse": "/ˌɪntɝˈfjus/",
  "interfused": "/ˌɪntɝˈfjusd/",
  "intergalactic": "/ˌɪntɝɡəˈɫæktɪk/",
  "interglacial": "/ˌɪntɝˈɡɫeɪʃəɫ/",
  "interlocked": '/ˌɪntɝˈɫɑkt/',
  "internalities": "/ˌɪntɝˈnæɫətiz/",
  "internality": "/ˌɪntɝˈnæɫəti/",
  "internalizing": "/ˌɪnˈtɝnəˌɫaɪzɪŋ/",
  "interrogative": "/ˌɪntɝˈɑɡətɪv/",
  "intersectional": "/ɪntɝˈsɛkʃənəɫ/",
  "intervocalically": "/ˌɪntɝvoʊˈkæɫəkɫi/",
  "intransitive": "/ˌɪnˈtɹænsətɪv/",
  "intransitively": "/ˌɪnˈtɹænsətɪvɫi/",
  "intuit": "/ˌɪnˈtuɪt/",
  "intuited": "/ˌɪnˈtuɪtəd/",
  "invectives": "/ˌɪnˈvɛktɪvz/",
  "invention": '/ˌɪnˈvɛnʃən/',
  "inverse": "/ˈɪnvɝs/",
  "invertebrate": "/ˌɪnˈvɝtəbɹət/",
  "inviolableness": "/ˌɪnˈvaɪəɫəbəɫnəs/",
  "inviolability": "/ɪnˌvaɪəɫəˈbɪɫɪti/",
  "inviolably": "/ˌɪnˈvaɪəɫəbɫi/",
  "ios": "/ˌaɪoʊˈɛs/",
  "iqs": "/ˈaɪkˈjuz/",
  "ironware": "/ˈaɪɝnwɛɹ/",
  "irreconcilable": "/ɪˌɹɛkənˈsaɪɫəbəɫ/",
  "irreducible": "/ɪɹiˈdusəbəɫ/",
  "isohedron": "/ˌaɪsoʊˈhidɹən/",
  "isohedra": "/ˌaɪsoʊˈhidɹə/",
  "italiano": '/ɪˌtɑɫiˈɑnoʊ/',
  "italicize": "/ɪˈtæɫəˌsaɪz/",
  "italicized": "/ɪˈtæɫəˌsaɪzd/",
  "iterate": "/ˈɪtɝeɪt/",
  "iterated": "/ˈɪtɝeɪtəd/",
  "iterates": "/ˈɪtɝeɪts/",
  "iterating": "/ˈɪtɝeɪtɪŋ/",
  "jacquard": "/ˈdʒækɑɹd/",
  "jacqui": "/ˈdʒæki/",
  "jaelan": "/ˈdʒeɪɫən/",
  "jägermeister": "/ˈjɑɡɝˌmaɪstɝ/",
  "jagged": "/ˈdʒæɡəd/",
  "jalapeno": "/ˌhɑɫəˈpeɪnjoʊ/",
  "jalapeño": "/ˌhɑɫəˈpeɪnjoʊ/",
  "jalen": "/ˈdʒeɪɫən/",
  "jaydon": "/ˈdʒeɪdən/",
  "jaxon": "/ˈdʒæksən/",
  "jedi": "/ˈdʒɛdaɪ/",
  "jemisin": "/ˈdʒɛməsɪn/",
  "jewel": "/ˈdʒuɫ/",
  "jeweler": "/ˈdʒuɫɝ/",
  "jeweler's": "/ˈdʒuɫɝz/",
  "jewelers": "/ˈdʒuɫɝz/",
  "jewelry": "/ˈdʒuɫɹi/",
  "jewels": "/ˈdʒuɫz/",
  "jezebel": "/ˈdʒɛzəbɛɫ/",
  "jiggly": "/ˈdʒɪɡɫi/",
  "jingling": "/ˈdʒɪŋɡɫɪŋ/",
  "jokey": "/ˈdʒoʊki/",
  "jotting": "/ˈdʒɑtɪŋ/",
  "jpeg": "/ˈdʒeɪˌpɛɡ/",
  "jpg": "/ˈdʒeɪˌpɛɡ/",
  "juiced": "/ˈdʒust/",
  "juicier": "/ˈdʒusjɝ/",
  "juicing": "/ˈdʒusɪŋ/",
  "julio": "/ˈhuɫioʊ/",
  "junkee": "/ˈdʒəŋki/",
  "jutted": "/ˈdʒətəd/",
  "kaanapali": "/ˌkɑnəˈpɑɫi/",
  "kaikoura": "/ˌkaɪˈkɝə/",
  "kaitlyn": "/ˈkeɪtɫən/",
  "kakani": "/ˌkɑˈkɑni/",
  "kalaloch": "/kəˈɫeɪɫɑk/",
  "kaleidocycle": "/kəˈɫaɪdəˌsaɪkəɫ/",
  "kandinsky": "/kænˈdɪnski/",
  "kardashian": "/kɑɹˈdæˌʃiən/",
  "karloff": "/ˈkɑɹɫɑf/",
  "kathryn": "/ˈkæθɹən/",
  "kathryne": "/ˈkæθɹən/",
  "kauai": "/kɑˈwɑi/",
  "kayleigh": "/ˈkeɪɫi/",
  "kelce": "/ˈkɛɫsi/",
  "kept": "/ˈkɛpt/",
  "ketamine": "/ˈkɛtəmin/",
  "kevlar": "/ˈkɛvɫɑɹ/",
  "keyboardist": "/ˈkibɔɹdɪst/",
  "khipu": "/ˈkipu/",
  "khoisan": "/ˈkɔɪˌsɑn/",
  "kickball": "/ˈkɪkˌbɔɫ/",
  "kickboxer": "/ˈkɪkˌbɑksɝ/",
  "kickboxing": "/ˈkɪkˌbɑksɪŋ/",
  "kickstart": "/ˈkɪkˌstɑɹt/",
  "kickstarted": "/ˈkɪkˌstɑɹtəd/",
  "kickstarting": "/ˈkɪkˌstɑɹtɪŋ/",
  "kinda": "/ˈkaɪndə/",
  "kindhearted": "/ˌkaɪndˈhɑɹtəd/",
  "kinging": '/ˈkɪŋɪŋ/',
  "kingon": "/ˈkɪŋˌɔn/",
  "kingsway": '/ˈkɪŋzweɪ/',
  "kingswell": '/ˈkɪŋzwɛɫ/',
  "kink": "/ˈkɪŋk/",
  "kiswahili": "/ˌkiswɑˈhiɫi/",
  "kleptocracy": "/kɫɛpˈtɑkɹəsi/",
  "km": "/ˈkɪɫəˌmitɝ/",
  "knavery": "/ˈneɪvɝi/",
  "kneader": "/ˈnidɝ/",
  "kneeled": "/ˈniɫd/",
  "knew": "/ˈnu/",
  "knowable": "/ˈnoʊəbəɫ/",
  "knossos": "/ˈnɑsəs/",
  "kodachrome": "/ˈkoʊdəkɹoʊm/",
  "kombucha": "/kɑmˈbutʃə/",
  "kong's": '/ˈkɔŋz/',
  "kongsberg": '/ˈkɔŋzbɝɡ/',
  "kongsberg's": '/ˈkɔŋzbɝɡz/',
  "krakatoa": "/ˌkɹækəˈtoʊə/",
  "kublai": "/ˈkubɫə/",
  "kudrow": "/ˈkʊdɹoʊ/",
  "kuiper": "/ˈkaɪpɝ/",
  "kurzweil": "/ˈkɝzwaɪɫ/",
  "kushite": "/ˈkəʃaɪt/",
  "labia": "/ˈɫeɪbiə/",
  "labial": "/ˈɫeɪbiəɫ/",
  "labiodental": "/ˈɫeɪbioʊˈdɛntəɫ/",
  "labradoodle": "/ˈɫæbɹədudəɫ/",
  "lagrange": "/ɫəˈɡɹeɪndʒ/",
  "lahaina": "/ɫəˈhaɪnə/",
  "lakebed": "/ˈɫeɪkˌbɛd/",
  "lamination": "/ˌɫæməˈneɪʃən/",
  "language": '/ˈɫæŋɡwɪdʒ/',
  "languages": '/ˈɫæŋɡwɪdʒɪz/',
  "lanternfish": "/ˈɫæntɝnˌfɪʃ/",
  "largemouth": "/ˈɫɑɹdʒˌmaʊθ/",
  "larky": "/ˈɫɑɹki/",
  "las": "/ɫɑs/",
  "lasagne": "/ɫəˈzɑnjə/",
  "laserdisc": "/ˈɫeɪzɝˌdɪsk/",
  "laterals": "/ˈɫætɝəɫz/",
  "latinize": "/ˈɫætənaɪz/",
  "latinized": "/ˈɫætənaɪzd/",
  "latke": "/ˈɫɑtkə/",
  "laudably": "/ˈɫɔdəbɫi/",
  "laughably": "/ˈɫæfəbɫi/",
  "lauper": "/ˈɫɑpɝ/",
  "lavonte": "/ˌɫəˈvɑnteɪ/",
  "law": "/ˈɫɔ/",
  "lazily": "/ˈɫeɪzəˌɫi/",
  "lead": "/ˈɫid/",
  "lebesgue": "/ɫəˈbɛɡ/",
  "leftfield": "/ˌɫɛftˈfiɫd/",
  "legit": "/ɫəˈdʒɪt/",
  "leisure": "/ˈɫiʒɝ/",
  "lengthier": "/ˈɫɛŋθiɝ/",
  "les": "/ˈɫɛs/",
  "levelheaded": "/ˌɫɛvəɫˈhɛdəd/",
  "leverage": "/ˈɫɛvɹɪdʒ/",
  "leverages": "/ˈɫɛvɹɪdʒəz/",
  "lexicography": "/ˌɫɛksəˈkɑɡɹəfi/",
  "lgbtq+": "/ˈɛɫˈdʒiˈbiˈtiˈkjuˈpɫəs/",
  "liberal": "/ˈɫɪbɹəɫ/",
  "liberals": "/ˈɫɪbɹəɫz/",
  "liberty": "/ˈɫɪbɝti/",
  "librarian": "/ɫaɪˈbɹɛɹˌiən/",
  "librarians": "/ɫaɪˈbɹɛɹˌiənz/",
  "libraries": "/ˈɫaɪbɹɛɹˌiz/",
  "library": "/ˈɫaɪbɹɛɹˌi/",
  "library's": "/ˈɫaɪbɹɛɹˌiz/",
  "licit": "/ˈɫɪsət/",
  "lidar": "/ˈɫaɪdɑɹ/",
  "lieu": "/ˈɫu/",
  "lifeform": "/ˈɫaɪfˌfɔɹm/",
  "ligature": "/ˈɫɪɡətʃɝ/",
  "lightless": "/ˈɫaɪtɫəs/",
  "lightyear": "/ˈɫaɪtˌjiɹ/",
  "lingerie": "/ˌɫɑnʒɝˈeɪ/",
  "linguicide": "/ˈɫɪnɡwəˌsaɪd/",
  "liquify": "/ˈɫɪkwəfaɪ/",
  "liquified": "/ˈɫɪkwəfaɪd/",
  "lissome": "/ˈɫɪsəm/",
  "lived": "/ˈɫɪvd/",
  "livestream": "/ˈɫaɪvˌstɹim/",
  "livestreamed": "/ˈɫaɪvˌstɹimd/",
  "llm": "/ˌɛɫˌɛɫˈɛm/",
  "llms": "/ˌɛɫˌɛɫˈɛmz/",
  "loanword": "/ˈɫoʊnˌwɝd/",
  "located": "/ˈɫoʊˌkeɪtəd/",
  "locution": "/ɫoʊˈkjuʃən/",
  "lodge": "/ˈɫɑdʒɝ/",
  "loki": "/ˈɫoʊki/",
  "lonelier": "/ˈɫoʊnɫiɝ/",
  "longcor": '/ɫoʊŋˈkɔɹ/',
  "long-island": "/ˌɫɔŋˈaɪɫənd/",
  "long-overdue": "/ˈɫɔŋˌoʊvɝˈdu/",
  "longacre": "/ˈɫɔŋˌeɪkɝ/",
  "lookup": "/ˈɫʊkˌəp/",
  "loosest": "/ˈɫusəst/",
  "loosey": "/ˈɫusi/",
  "lothlórien": "/ˌɫoʊθˈɫɔɹiən/",
  "lothlorien": "/ˌɫoʊθˈɫɔɹiən/",
  "lott's": '/ˈɫɑts/',
  "lounged": "/ˈɫaʊndʒd/",
  "lovability": "/ˌɫəvəˈbɪɫɪti/",
  "loveable": "/ˈɫəvəbəɫ/",
  "lovelorn": "/ˈɫəvɫɔɹn/",
  "lowercase": "/ˈɫoʊɝˈkeɪs/",
  "lucre": "/ˈɫukɝ/",
  "ludic": "/ˈɫudɪk/",
  "luminosity": "/ˌɫuməˈnɑsəti/",
  "lungful": "/ˈɫəŋfəɫ/",
  "lurid": "/ˈɫʊɹɪd/",
  "lushootseed": "/ɫəˈʃutsed/",
  "lutein": "/ˈɫutiən/",
  "luxuriate": "/ɫəɡˈʒɝiˌeɪt/",
  "luxuriated": "/ɫəɡˈʒɝiˌeɪtəd/",
  "luxuriating": "/ɫəɡˈʒɝiˌeɪtɪŋ/",
  "lynnette": "/ɫəˈnɛt/",
  "macabre": "/məˈkɑbɹə/",
  "macaron": "/ˌmɑkəˈɹoʊn/",
  "machias": "/məˈkaɪəs/",
  "machu": "/ˈmɑtʃu/",
  "macroscale": "/ˈmæˌkɹoʊˌskeɪɫ/",
  "macroscopic": "/ˌmækɹəˈskɑpɪk/",
  "macular": "/ˈmækjuɫɝ/",
  "maharajah": "/ˌmɑhɑˈɹɑdʒɑ/",
  "mainlined": "/ˈmeɪnˌɫaɪnd/",
  "majuscule": "/ˈmædʒəˌskjʊɫ/",
  "makah": "/mɑˈkɑ/",
  "makeout": "/ˈmeɪkˈaʊt/",
  "makeover": "/ˈmeɪkoʊvɝ/",
  "makeovers": "/ˈmeɪkoʊvɝz/",
  "makepeace": "/ˈmeɪkˌpis/",
  "malarky": "/məˈɫɑɹki/",
  "mammogram": "/ˈmæməˌɡɹæm/",
  "mandelbrot": "/ˈmændəɫˌbɹoʊ/",
  "manicule": "/ˈmænɪkjuɫ/",
  "marginalia": "/ˌmɑɹdʒəˈneɪɫjə/",
  "marmite": "/ˈmɑɹmaɪt/",
  "marseille": "/mɑɹˈseɪ/",
  "martingale": "/ˈmɑɹtɪnˌɡeɪɫ/",
  "márquez": "/ˈmɑɹkɛz/",
  "masher": "/ˈmæʃɝ/",
  "mashup": "/ˈmæʃˌəp/",
  "masque": "/ˈmæsk/",
  "masterclass": "/ˈmæstɝˌkɫæs/",
  "matcha": "/ˈmɑtʃə/",
  "maté": "/ˈmɑteɪ/",
  "maths": "/ˈmæθs/",
  "matryoshka": "/ˌmɑtɹiˈoʊʃkə/",
  "matryoshkas": "/ˌmɑtɹiˈoʊʃkəz/",
  "matt's": '/ˈmæts/',
  "matured": "/məˈtʃʊɹd/",
  "maugham": "/ˈmɔm/",
  "mauritius": "/mɔˈɹɪʃəs/",
  "mauve": "/ˈmoʊv/",
  "mayor": "/ˈmɛɹ/",
  "mazama": "/məˈzæmə/",
  "mazel": "/ˈmɑzəɫ/",
  "mbari": "/ɛmˈbɑɹi/",
  "mcbeal": "/məkˈbiɫ/",
  "mcclure": "/məˈkɫʊɹ/",
  "mcgarrett": "/məkˈɡɛɹət/",
  "mechanizing": "/ˈmɛkəˌnaɪzɪŋ/",
  "mediaeval": "/mɪˈdivəɫ/",
  "medievalist": "/mɪˈdivəɫɪst/",
  "meditated": "/ˈmɛdəˌteɪtəd/",
  "megadrought": "/ˈmɛɡəˌdɹaʊt/",
  "megafauna": "/ˈmɛɡəˌfɔnə/",
  "megalomaniacal": "/ˌmɛɡəɫoʊməˈnaɪəkəɫ/",
  "megastar": "/ˈmɛɡəˌstɑɹ/",
  "melancholia": "/ˌmɛɫənˈkoʊɫiə/",
  "melange": "/meɪˈɫɑnʒ/",
  "mélange": "/meɪˈɫɑnʒ/",
  "melisma": "/məˈɫɪzmə/",
  "melismata": "/məˈɫɪzmətə/",
  "melismatic": "/ˌmɛɫəsˈmætɪk/",
  "memes": "/ˈmimz/",
  "memorizable": "/ˌmɛmɝˈaɪzəbəɫ/",
  "menopausal": "/ˌmɛnəˈpɑzəɫ/",
  "mercantilism": "/ˈmɝkəntəˌɫɪzəm/",
  "merch": "/ˈmɝtʃ/",
  "merlot": "/mɝˈɫoʊ/",
  "merlots": "/mɝˈɫoʊz/",
  "meroitic": "/mɛɹɔˈɪtɪk/",
  "merriment": "/ˈmɛɹimənt/",
  "mesic": "/ˈmɛsɪk/",
  "meso": "/ˈmɛzoʊ/",
  "mesoamerica": "/ˌmɛzoʊəˈmɛɹəkə/",
  "mesoamerican": "/ˌmɛzoʊəˈmɛɹəkən/",
  "messaged": "/ˈmɛsədʒd/",
  "messiness": "/ˈmɛsinəs/",
  "meta": "/ˈmɛtə/",
  "metagenomic": "/ˈmɛtədʒəˈnoʊmɪk/",
  "metalinguistic": "/ˈmɛtəɫɪŋˈɡwɪstɪk/",
  "metamathematician": "/ˈmɛtəˌmæθəməˈtɪʃən/",
  "metamathematics": "/ˈmɛtəˌmæθˈmætɪks/",
  "metamerism": "/məˈtæməˌɹɪzəm/",
  "metaphoric": "/mɛtəˈfɔɹɪk/",
  "metropolises": "/məˈtɹɑpəɫəsəz/",
  "mic": "/ˈmaɪk/",
  "microbiome": "/ˈmaɪˌkɹoʊˈbaɪˌoʊm/",
  "microfinance": "/ˈmaɪˌkɹoʊˌfaɪˌnæns/",
  "microscale": "/ˈmaɪˌkɹoʊˌskeɪɫ/",
  "microservice": "/ˈmaɪkɹoʊˌsɝvəs/",
  "microservices": "/ˈmaɪkɹoʊˌsɝvəsəz/",
  "microsoft": "/ˈmaɪkɹəsɔft/",
  "microstate": "/ˈmaɪˌkɹoʊˌsteɪt/",
  "microvascular": "/ˌmaɪˌkɹoʊˈvæskjəɫɝ/",
  "midden": "/ˈmɪdən/",
  "midi": "/ˈmɪdi/",
  "midpoints": "/ˈmɪdˌpɔɪnts/",
  "midtempo": "/ˌmɪdˈtɛmpoʊ/",
  "midthigh": "/ˌmɪdˈθaɪ/",
  "migrator": "/ˈmaɪˌɡɹeɪtɝ/",
  "mindshare": "/ˈmaɪndˌʃɛɹ/",
  "mineralogist": "/ˌmɪnɝˈɑɫədʒɪst/",
  "mineralogists": "/ˌmɪnɝˈɑɫədʒɪsts/",
  "minima": "/ˈmɪnəmə/",
  "minimart": "/ˈmɪniˌmɑɹt/",
  "minimization": "/ˌmɪnəməˈzeɪʃən/",
  "minimoog": "/ˈmɪniˌmuɡ/",
  "minos": "/ˈmaɪnoʊs/",
  "minotaur": "/ˈmɪnətoɹ/",
  "minutely": "/maɪˈnutɫi/",
  "mirthless": "/ˈmɝθɫəs/",
  "misanthropic": "/mɪsənˈθɹɑpɪk/",
  "misattribute": "/mɪsəˈtɹɪbjut/",
  "misattributes": "/mɪsəˈtɹɪbjuts/",
  "misbehave": "/ˌmɪsbiˈheɪv/",
  "misc": "/ˈmɪsk/",
  "misdirection": "/mɪsdɝˈɛkʃən/",
  "misfired": "/mɪsˈfaɪɝd/",
  "misfiring": "/ˈmɪsˌfaɪɹɪŋ/",
  "miso": "/ˈmisoʊ/",
  "misogynist": "/mɪˈsɑdʒɪnɪst/",
  "misogynistic": "/məˌsɑdʒəˈnɪstɪk/",
  "misogyny": "/mɪˈsədʒɪni/",
  "missouri": "/məˈzɝi/",
  "misstep": "/ˈmɪstɛp/",
  "mistranslation": "/ˌmɪstɹænˈsɫeɪʃən/",
  "misunderstanding": "/ˌmɪsˌəndɝˈstændɪŋ/",
  "milepost": "/ˈmaɪɫˌpoʊst/",
  "millionths": "/ˈmɪɫjənθs/",
  "millipede": "/ˈmɪɫəpid/",
  "milquetoast": "/ˈmɪɫkˌtoʊst/",
  "mixable": "/ˈmɪksəbəɫ/",
  "mixologist": "/mɪkˈsɑɫədʒɪst/",
  "mjölnir": "/ˈmjoʊɫnɪɹ/",
  "mjolnir": "/ˈmjoʊɫnɪɹ/",
  "moa": "/ˈmoʊə/",
  "moai": "/ˈmoʊaɪ/",
  "mobius": "/ˈmoʊbɪəs/",
  "möbius": "/ˈmoʊbɪəs/",
  "mochi": "/ˈmoʊtʃi/",
  "mockup": "/ˈmɑkˌəp/",
  "modeler": "/ˈmɑdəɫɝ/",
  "modelled": "/ˈmɑdəɫd/",
  "modifiable": "/mɑdɪˈfaɪəbəɫ/",
  "modularity": "/ˌmɑdʒəˈɫɛɹɪti/",
  "modulating": "/ˈmɔdʒjuɫeɪtɪŋ/",
  "momenta": "/moʊˈmɛntə/",
  "moneychanger": "/ˈməniˌtʃeɪndʒɝ/",
  "moneylender": "/ˈməniˌɫɛndɝ/",
  "mongrel": "/ˈmɑŋɡɹəɫ/",
  "mono": "/ˈmɑnoʊ/",
  "monoculture": "/ˈmɑnoʊˌkəɫtʃɝ/",
  "monolingualism": "/ˌmɑnoʊˈɫɪŋɡwəɫɪzəm/",
  "monophthong": "/ˈmɑnoʊˈθɔŋ/",
  "monosodium": "/ˈmɑnoʊˈsoʊdiəm/",
  "monosyllabic": "/ˈmɑnoʊsəˈɫæbɪk/",
  "moolah": "/ˈmuɫɑ/",
  "mooted": "/ˈmutəd/",
  "morass": "/mɝˈæs/",
  "moronic": "/mɔˈɹɑnɪk/",
  "morpheme": "/ˈmɔɹfim/",
  "morphia": "/ˈmɔɹfiə/",
  "mossy": "/ˈmɔsi/",
  "most": "/ˈmoʊst/",
  "motored": "/ˈmoʊtɝd/",
  "motormouth": "/ˈmoʊtɝˌmaʊθ/",
  "motormouthed": "/ˈmoʊtɝˌmaʊθt/",
  "mowing": "/ˈmoʊɪŋ/",
  "mown": "/ˈmoʊn/",
  "mpg": "/ˈmaɪɫzpɝˈɡæɫən/",
  "mph": "/ˈmaɪɫzpɝˈaʊɝ/",
  "mudlark": "/ˈmədɫɑɹk/",
  "muertos": "/ˈmwɛɹtoʊs/",
  "multicellular": "/ˌməɫtaɪˈsɛɫjəɫɝ/",
  "multidimensional": "/ˌməɫtidɪˈmɛnʃənəɫ/",
  "multigenerational": "/ˈməɫtiˌdʒɛnɝˈeɪʃənəɫ/",
  "multilingualism": "/ˌməɫtaɪˈɫɪŋwəɫɪzəm/",
  "multimodal": "/ˌməɫtaɪˈmoʊdəɫ/",
  "multiplicative": "/ˌməɫtəˈpɫɪkətɪv/",
  "multisensory": "/ˌməɫtaɪˈsɛnsɝi/",
  "multistep": "/ˈməɫtiˌstɛp/",
  "multisyllabic": "/ˌməɫtisəˈɫæbɪk/",
  "multitudinous": "/ˌməɫtəˈtudənəs/",
  "multiverse": "/ˈməɫtɪˌvɝs/",
  "murmuration": "/mɝmɝˈeɪʃən/",
  "museum": "/mjuˈziəm/",
  "museums": "/mjuˈziəmz/",
  "muskrats": '/ˈməsˌkɹæts/',
  "mycenean": "/ˌmaɪsəˈniən/",
  "mystery": "/ˈmɪstɹi/",
  "mythologize": "/mɪˈθɑɫədʒaɪz/",
  "mythologized": "/mɪˈθɑɫədʒaɪzd/",
  "mythologizing": "/mɪˈθɑɫədʒaɪzɪŋ/",
  "nabatea": "/ˌnæbəˈtiə/",
  "nabatean": "/ˌnæbəˈtiən/",
  "nacho": "/ˈnɑˌtʃoʊ/",
  "nachos": "/ˈnɑˌtʃoʊz/",
  "naïve": "/ˌnaɪˈiv/",
  "naïvely": "/nɑˈivɫi/",
  "naïvete": "/nɑˌivəˈteɪ/",
  "namaste": "/ˈnəməˌsteɪ/",
  "nanobot": "/ˈnænoʊbɑt/",
  "nanocomputer": "/ˈnænoʊkəmˌpjutɝ/",
  "nanotube": "/ˈnænoʊˌtub/",
  "narnia": "/ˈnɑɹˌniə/",
  "narrative": "/ˈnɛɹətɪv/",
  "narratives": "/ˈnɛɹətɪvz/",
  "narratively": "/ˈnɛɹətɪvɫi/",
  "nasturtium": "/nəˈstɝʃəm/",
  "natch": "/ˈnætʃ/",
  "naughtiest": "/ˈnɔtiɪst/",
  "nauseam": "/ˈnɑziəm/",
  "navratilova": "/nævˌɹətɪˈɫoʊvə/",
  "nazca": "/ˈnæzkə/",
  "neah": "/ˈniə/",
  "neandertal": "/niˈændɝˌtɔɫ/",
  "neath": "/ˈniθ/",
  "nebulae": "/ˈnɛbjəɫə/",
  "née": "/ˈneɪ/",
  "needlecraft": "/ˈnidəɫˌkɹæft/",
  "neither": "/ˈniðɝ/",
  "nestlé": "/ˈnɛsɫi/",
  "nemeses": "/ˈnɛməsiz/",
  "neoliberalism": "/ˌnioʊˈɫɪbɝəɫɪzəm/",
  "neolitic": "/ˌnioʊˈɫɪtɪk/",
  "nepo": "/ˈnɛpoʊ/",
  "neptune": "/ˈnɛpˌtun/",
  "neural": "/ˈnʊɹəɫ/",
  "neuralgia": "/nɝˈæɫdʒə/",
  "neurobiological": "/ˈnʊˌɹoʊˌbaɪəˈɫɑdʒɪkəɫ/",
  "neurobiologist": "/ˈnʊˌɹoʊbaɪˈɑɫədʒɪst/",
  "neuroelectrical": "/ˌnuɹoʊiˈɫɛktɹəkəɫ/",
  "neurogenetics": "/ˈnʊˌɹoʊdʒəˈnɛtɪks/",
  "neuropathway": "/ˈnʊˌɹoʊˈpæθˌweɪ/",
  "neuropathy": "/ˌnʊˈɹɑpəθi/",
  "neurophysiology": "/ˌnʊɹoʊˌfɪziˈɑɫədʒi/",
  "neurophysiological": "/ˌnʊɹoʊˌfɪziəˈɫɑdʒəkəɫ/",
  "neurophysiologically": "/ˌnʊɹoʊˌfɪziəˈɫɑdʒəkɫi/",
  "neuropsychologist": "ˈnʊˌɹoʊsaɪˈkɑɫədʒəst//",
  "neuropsychology": "/ˈnʊˌɹoʊsaɪˈkɑɫədʒi/",
  "neuroscience": "/ˈnʊɹoʊˌsaɪəns/",
  "neuroscientist": "/ˈnʊɹoʊˌsaɪəntɪst/",
  "neurotoxin": "/ˈnɝoʊˌtɑksən/",
  "neurotransmitter": "/ˌnɝoʊˈtɹænsmɪtɝ/",
  "new": "/ˈnu/",
  "new-orleans": "/nuˈɔɹɫinz/",
  "newark": "/ˈnuɝk/",
  "newark's": "/ˈnuɝks/",
  "news": "/ˈnuz/",
  "newsflash": "/ˈnuzfɫæʃ/",
  "newsflashes": "/ˈnuzfɫæʃəz/",
  "next": "/ˈnɛkst/",
  "ngo": "/ˈɛnˈdʒiˈoʊ/",
  "ngos": "/ˈɛnˈdʒiˈoʊz/",
  "nicobar": "/ˈnɪkoʊbɑɹ/",
  "nightcap": "/ˈnaɪtkæp/",
  "nighty": "/ˈnaɪti/",
  "nihilist": "/ˈnaɪəˌɫɪst/",
  "nihilistic": "/ˌnaɪəˈɫɪstɪk/",
  "nihilo": "/ˈniəɫoʊ/",
  "niña": "/ˈninjə/",
  "niño": "/ˈninjoʊ/",
  "nitrite": "/ˈnaɪtɹaɪt/",
  "nitrous": "/ˈnaɪtɹəs/",
  "niven": "/ˈnɪvən/",
  "njigba": "/ənˈdʒɪɡbə/",
  "nobly": "/ˈnoʊbɫi/",
  "noir": "/ˈnwɑɹ/",
  "noisiness": "/ˈnɔɪzinɛs/",
  "nonconsensual": "/ˌnɑnkənˈsɛnʃuəɫ/",
  "nonconsensually": "/ˌnɑnkənˈsɛnʃuəɫɫi/",
  "nonlinear": "/ˈnɑnˈɫɪˌniɝ/",
  "nonorientable": "/ˌnɑnɔɹiˈɛntəbəɫ/",
  "nonpareil": "/ˌnɑnpəˈɹɛɫ/",
  "noodled": "/ˈnudəɫd/",
  "noodling": "/ˈnudəɫɪŋ/",
  "northumbria": "/nɔɹθˈəmbɹiə/",
  "nosferatu": "/ˌnosfɝˈɑtu/",
  "nostalgically": "/nəˈstæɫdʒɪkɫi/",
  "nought": "/ˈnɔt/",
  "novae": "/ˈnoʊvi/",
  "np-complete": "/ˈɛnˈpikəmˈpɫit/",
  "np-hard": "/ˈɛnˈpiˈhɑɹd/",
  "npm": "/ˈɛnˈpiˈɛm/",
  "nubia": "/ˈnubiə/",
  "nubian": "/ˈnubiən/",
  "nui": "/ˈnui/",
  "nupeng": "/ˈnupɛŋ/",
  "nurdle": "/ˈnɝdəɫ/",
  "nute": "/ˈnut/",
  "obelisk": "/ˈɑbəˌɫɪsk/",
  "obfuscated": "/ˈɑbfəˌskeɪtəd/",
  "obscura": "/əbˈskjʊɹə/",
  "obsolete": "/ˌɑbsəˈɫit/",
  "obsoleted": "/ˌɑbsəˈɫitəd/",
  "obsoleting": "/ˌɑbsəˈɫitɪŋ/",
  "obstruent": "/ˈɑbstɹuənt/",
  "occultist": "/əˈkəɫtɪst/",
  "octonion": "/ɑkˈtoʊniən/",
  "octothorpe": "/ˈɑktəˌθɔɹp/",
  "o'er": "/ˈɔɹ/",
  "oeuvre": "/ˈʊvɹə/",
  "offside": "/ˌɑfˈsaɪd/",
  "ol": "/ˈoʊɫ/",
  "olmec": "/ˈoʊɫmɛk/",
  "omicron": "/ˈoʊməkɹɑn/",
  "omniperiodic": "/ˈɑmniˌpɪɹiˈɑdɪk/",
  "one-on-one": "/ˈwənɑnˈwən/",
  "oneness": "/ˈwənnɪs/",
  "online": "/ˈɔnˈɫaɪn/",
  "onomatopoeia": "/ˌɑnəmɑtəˈpiə/",
  "onomatopoeic": "/ˌɑnəmɑtəˈpiɪk/",
  "onside": "/ˈɑnsaɪd/",
  "ontologies": "/ɑnˈtɑɫədʒiz/",
  "oort": "/ˈoɹt/",
  "openai": "/ˈoʊpənˈeɪˈaɪ/",
  "operand": "/ˈɑpɝænd/",
  "operands": "/ˈɑpɝændz/",
  "opposable": "/əˈpoʊzəbəɫ/",
  "opsin": "/ˈɑpsən/",
  "optionally": "/ˈɑpʃənəɫi/",
  "oracular": "/ɔˈɹækjuˌɫɝ/",
  "orangutan": "/əˈɹæŋətæn/",
  "orbifold": "/ˈɔɹbəˌfoʊɫd/",
  "orbifolds": "/ˈɔɹbəˌfoʊɫdz/",
  "orbitofrontal": "/ˌɔɹbɪtəˈfɹəntəɫ/",
  "ordinal": "/ˈoɹdənəɫ/",
  "oregon": "/ˈoɹəɡən/",
  "orgiastic": "/ˌɔɹdʒiˈæstɪk/",
  "orientable": "/ɔɹiˈɛntəbəɫ/",
  "origami": "/ˌɔɹəˈɡɑˌmi/",
  "origin": "/ˈoɹədʒən/",
  "ornithologist": "/ˌɔɹnɪˈθɑɫədʒɪst/",
  "orthopaedic": "/ˌɔɹθəˈpidɪk/",
  "oscillogram": "/əˈsɪɫəˌɡɹæm/",
  "osiris": "/oʊˈsaɪɹəs/",
  "ottawa": "/ˈɑtəˌwə/",
  "outbuilding": "/ˈaʊtˌbɪɫdɪŋ/",
  "outcompete": "/ˈaʊdtkəmˈpit/",
  "outcompeted": "/ˈaʊdtkəmˈpitəd/",
  "outcompeting": "/ˈaʊdtkəmˈpitɪŋ/",
  "outcrop": "/ˈaʊtˌkɹɑp/",
  "outlast": "/ˌaʊtˈɫæst/",
  "outman": "/ˌaʊtˈmæn/",
  "outplay": "/ˌaʊtˈpɫeɪ/",
  "outplayed": "/ˌaʊtˈpɫeɪ/",
  "outplaying": "/ˌaʊtˈpɫeɪɪŋ/",
  "ovaltine": "/ˈoʊvəɫtin/",
  "ovenproof": "/ˈəvənpɹuf/",
  "overachieve": "/ˌoʊvɝəˈtʃiv/",
  "overachieved": "/ˌoʊvɝəˈtʃivd/",
  "overachieving": "/ˌoʊvɝəˈtʃivɪŋ/",
  "overact": "/ˌoʊvɝˈækt/",
  "overacted": "/ˌoʊvɝˈæktɪd/",
  "overacts": "/ˌoʊvɝˈækts/",
  "overall": "/ˌoʊvɝˈɔɫ/",
  "overambitious": "/ˌoʊvɝæmˈbɪʃəs/",
  "overarching": "/ˌoʊvɝˈɑɹtʃɪŋ/",
  "overbearing": "/ˈoʊvɝˈbɛɹɪŋ/",
  "overbilled": "/ˌoʊvɝˈbɪɫd/",
  "overbilling": "/ˌoʊvɝˈbɪɫɪŋ/",
  "overbook": "/ˌoʊvɝˈbʊk/",
  "overbooked": "/ˌoʊvɝˈbʊkt/",
  "overbooking": "/ˌoʊvɝˈbʊkɪŋ/",
  "overbooks": "/ˌoʊvɝˈbʊks/",
  "overbuilding": "/ˌoʊvɝˈbɪɫdɪŋ/",
  "overbuy": "/ˌoʊvɝˈbaɪ/",
  "overcharge": "/ˌoʊvɝˈtʃɑɹdʒ/",
  "overcharges": "/ˌoʊvɝˈtʃɑɹdʒɪz/",
  "overcome": "/ˌoʊvɝˈkəm/",
  "overcomes": "/ˌoʊvɝˈkəmz/",
  "overcoming": "/ˈoʊvɝˈkəmɪŋ/",
  "overconsumption": "/ˌoʊvɝkənˈsəmpʃən/",
  "overcrowded": "/ˌoʊvɝˈkɹaʊdɪd/",
  "overcrowding": "/ˌoʊvɝˈkɹaʊdɪŋ/",
  "overdamping": "/ˌoʊvɝˈdæmpɪŋ/",
  "overdependence": "/ˌoʊvɝdɪˈpɛndəns/",
  "overdependent": "/ˌoʊvɝdɪˈpɛndənt/",
  "overdid": "/ˌoʊvɝˈdɪd/",
  "overdo": "/ˌoʊvɝˈdu/",
  "overdoing": "/ˌoʊvɝˈduɪŋ/",
  "overdone": "/ˌoʊvɝˈdən/",
  "overdraw": "/ˌoʊvɝˈdɹɔ/",
  "overdress": "/ˌoʊvɝˈdɹɛs/",
  "overdrew": "/ˌoʊvɝˈdɹu/",
  "overeager": "/ˌoʊvɝˈiɡɝ/",
  "overeat": "/ˌoʊvɝˈit/",
  "overfill": "/ˌoʊvɝˈfɪɫ/",
  "overfishing": "/ˌoʊvɝˈfɪʃɪŋ/",
  "overflowing": "/ˌoʊvɝˈfɫoʊɪŋ/",
  "overflows": "/ˌoʊvɝˈfɫoʊz/",
  "overfund": "/ˌoʊvɝˈfənd/",
  "overfunded": "/ˌoʊvɝˈfəndɪd/",
  "overfunding": "/ˌoʊvɝˈfəndɪŋ/",
  "overgenerous": "/ˌoʊvɝˈdʒɛnɝəs/",
  "overgrazed": "/ˌoʊvɝˈɡɹeɪzd/",
  "overgrazing": "/ˌoʊvɝˈɡɹeɪzɪŋ/",
  "overhear": "/ˌoʊvɝˈhiɹ/",
  "overheard": "/ˌoʊvɝˈhɝd/",
  "overhears": "/ˌoʊvɝˈhiɹz/",
  "overheat": "/ˌoʊvɝˈhit/",
  "overheated": "/ˌoʊvɝˈhitɪd/",
  "overheating": "/ˌoʊvɝˈhitɪŋ/",
  "overheats": "/ˌoʊvɝˈhits/",
  "overline": "/ˈoʊvɝˌɫaɪn/",
  "overlining": "/ˈoʊvɝˌɫaɪnɪŋ/",
  "overlooked": "/ˌoʊvɝˈɫʊkt/",
  "overlooking": "/ˌoʊvɝˈɫʊkɪŋ/",
  "overlooks": "/ˌoʊvɝˈɫʊks/",
  "overnight": "/ˌoʊvɝˈnaɪt/",
  "overnite": "/ˌoʊvɝˈnaɪt/",
  "overpay": "/ˌoʊvɝˈpeɪ/",
  "overpaying": "/ˌoʊvɝˈpeɪɪŋ/",
  "overpayment": "/ˌoʊvɝˈpeɪmənt/",
  "overpayments": "/ˌoʊvɝˈpeɪmənts/",
  "overpolluting": "/ˌoʊvɝpəˈɫutɪŋ/",
  "overpriced": "/ˌoʊvɝˈpɹaɪst/",
  "overproduce": "/ˈoʊvɝpɹəˈdus/",
  "overqualified": "/ˌoʊvɝˈkwɑɫəˌfaɪd/",
  "overqualify": "/ˌoʊvɝˈkwɑɫɪˌfaɪ/",
  "overreach": "/ˌoʊvɝˈɹitʃ/",
  "overreached": "/ˌoʊvɝˈɹitʃt/",
  "overreaches": "/ˌoʊvɝˈɹitʃɪz/",
  "overreaching": "/ˌoʊvɝˈɹitʃɪŋ/",
  "overregulate": "/ˌoʊvɝˈɹɛɡjəˌɫeɪt/",
  "overregulates": "/ˌoʊvɝˈɹɛɡjəˌɫeɪts/",
  "overreliance": "/ˌoʊvɝɹɪˈɫaɪəns/",
  "overrepresent": "/ˌoʊvɝˌɹɛpɹəˈzɛnt/",
  "overrepresented": "/ˌoʊvɝˌɹɛpɹəˈzɛntɪd/",
  "overriding": "/ˌoʊvɝˈɹaɪdɪŋ/",
  "overruling": "/ˌoʊvɝˈɹuɫɪŋ/",
  "overrunning": "/ˌoʊvɝˈɹənɪŋ/",
  "oversaw": "/ˌoʊvɝˈsɔ/",
  "oversee": "/ˌoʊvɝˈsi/",
  "overseeing": "/ˌoʊvɝˈsiɪŋ/",
  "overseen": "/ˌoʊvɝˈsin/",
  "overseer": "/ˈoʊvɝˈsiɝ/",
  "oversees": "/ˌoʊvɝˈsiz/",
  "oversell": "/ˌoʊvɝˈsɛɫ/",
  "overselling": "/ˌoʊvɝˈsɛɫɪŋ/",
  "overshoot": "/ˌoʊvɝˈʃut/",
  "overshooting": "/ˌoʊvɝˈʃutɪŋ/",
  "overshot": "/ˌoʊvɝˈʃɑt/",
  "oversimplification": "/ˌoʊvɝˌsɪmpɫɪfɪˈkeɪʃən/",
  "overspend": "/ˌoʊvɝˈspɛnd/",
  "overspending": "/ˌoʊvɝˈspɛndɪŋ/",
  "overspends": "/ˌoʊvɝˈspɛndz/",
  "overspent": "/ˈoʊvɝˈspɛnt/",
  "overstaff": "/ˌoʊvɝˈstæf/",
  "overstaffed": "/ˌoʊvɝˈstæft/",
  "overstate": "/ˌoʊvɝˈsteɪt/",
  "overstated": "/ˌoʊvɝˈsteɪtɪd/",
  "overstep": "/ˌoʊvɝˈstɛp/",
  "overstepped": "/ˌoʊvɝˈstɛpt/",
  "overstepping": "/ˌoʊvɝˈstɛpɪŋ/",
  "overstimulating": "/ˌoʊvɝˈstɪmjəˌɫeɪtɪŋ/",
  "overstuff": "/ˌoʊvɝˈstəf/",
  "overstuffed": "/ˌoʊvɝˈstəft/",
  "overt": "/oʊˈvɝt/",
  "overtake": "/ˌoʊvɝˈteɪk/",
  "overtaken": "/ˌoʊvɝˈteɪkən/",
  "overtakes": "/ˌoʊvɝˈteɪks/",
  "overtaking": "/ˌoʊvɝˈteɪkɪŋ/",
  "overtax": "/ˌoʊvɝˈtæks/",
  "overthink": "/ˌoʊvɝˈθɪnk/",
  "overthrow": "/ˌoʊvɝˈθɹoʊ/",
  "overthrowing": "/ˌoʊvɝˈθɹoʊɪŋ/",
  "overthrows": "/ˌoʊvɝˈθɹoʊz/",
  "overturn": "/ˌoʊvɝˈtɝn/",
  "overturned": "/ˌoʊvɝˈtɝnd/",
  "overturning": "/ˌoʊvɝˈtɝnɪŋ/",
  "overturns": "/ˌoʊvɝˈtɝnz/",
  "overvalue": "/ˌoʊvɝˈvæɫju/",
  "overvalued": "/ˌoʊvɝˈvæɫjud/",
  "ozempic": "/oʊˈzɛmpək/",
  "ozette": "/oʊˈzɛt/",
  "paella": "/pɑˈɛjə/",
  "pairwise": "/ˈpɛɹwaɪz/",
  "pakora": "/pəˈkɔɹə/",
  "palatal": "/ˈpæɫətəɫ/",
  "palatalization": "/ˈpæɫətəɫɪˌzeɪʃən/",
  "paleobiologist": "/ˈpeɪɫioʊbaɪˈɑɫədʒɪst/",
  "paleobotanist": "/ˈpeɪɫioʊˈbɑtənɪst/",
  "paleolithic": "/ˌpeɪɫioʊˈɫɪθɪk/",
  "paleontological": "/ˌpeɪɫiəntəˈɫɑdʒikəɫ/",
  "palindrome": "/ˈpæɫəndɹoʊm/",
  "pallor": "/ˈpæɫɝ/",
  "palm": "/ˈpɑm/",
  "pangaea": "/pænˈdʒiə/",
  "pangolin": "/ˈpæŋɡoʊɫɪn/",
  "pansexual": "/ˌpænˈsɛkʃuəɫ/",
  "paperboy": "/ˈpeɪpɝˌbɔɪ/",
  "paperboy's": "/ˈpeɪpɝˌbɔɪz/",
  "paperboys": "/ˈpeɪpɝˌbɔɪz/",
  "paperclip": "/ˈpeɪpɝˌkɫɪp/",
  "paperclips": "/ˈpeɪpɝˌkɫɪps/",
  "papercraft": "/ˈpeɪpɝˌkɹæft/",
  "papoose": "/pæˈpus/",
  "paraboloid": "/pəˈɹæbəˌɫɔɪd/",
  "parachutist": "/ˈpɛɹəˌʃutɪst/",
  "paragliding": "/ˈpɛɹəˌɡɫaɪdɪŋ/",
  "paramore": "/ˈpɛɹəˌmɔɹ/",
  "paramour": "/ˈpɛɹəˌmɔɹ/",
  "parasocial": "/ˌpɛɹəˈsoʊʃəɫ/",
  "particular": "/pɝˈtɪkjəɫɝ/",
  "particularly": "/pɝˈtɪkjəɫɝɫi/",
  "passersby": "/ˈpæsɝzˌbaɪ/",
  "pasty": "/ˈpæsti/",
  "patchiness": "/ˈpætʃinəs/",
  "pauseless": "/ˈpɔzɫɪs/",
  "pavlova": "/pɑvˈɫoʊvə/",
  "paywall": "/ˈpeɪwɑɫ/",
  "pecan": "/pəˈkɑn/",
  "pecorino": "/pɛkəˈɹinoʊ/",
  "pecked": "/ˈpɛkt/",
  "pedantically": "/pəˈdæntɪkɫi/",
  "pedophile": "/ˈpɛdoʊfaɪɫ/",
  "pedophiles": "/ˈpɛdoʊfaɪɫz/",
  "pegasi": "/ˈpɛɡəˌsaɪ/",
  "peloponnese": "/ˈpɛɫəpəˌniz/",
  "penmanship": "/ˈpɛnmənˌʃɪp/",
  "pentagonal": "/pɛnˈtæɡənəɫ/",
  "pentameter": "/pɛnˈtæmətɝ/",
  "penurious": "/ˌpənˈjɝiəs/",
  "perceivable": "/pɝˈsivəbəɫ/",
  "percolation": "/ˌpɝkəˈɫeɪʃən/",
  "percontation": "/pɝkənˈteɪʃən/",
  "perihelion": "/ˌpɛɹəˈhiɫjən/",
  "periodontist": "/ˌpɛɹioʊˈdɑntɪst/",
  "periwinkle": "/ˈpɛɹiwɪnkəɫ/",
  "permafrost": "/ˈpɝməˌfɹɔst/",
  "persimmon": "/pɝˈsɪmən/",
  "persnickety": "/pɝˈsnɪkəti/",
  "perspectival": "/pɝˈspɛktəvəɫ/",
  "perspectivalism": "/pɝˈspɛktəvəˌɫɪzəm/",
  "perspectivist": "/pɝˈspɛktɪvɪst/",
  "pessimistically": "/ˌpɛsəˈmɪstɪkɫi/",
  "pesto": "/ˈpɛstoʊ/",
  "petard": "/pəˈtɑɹd/",
  "petawatt": "/ˈpɛtəˌwɑt/",
  "petri": "/ˈpitɹi/",
  "phaistos": "/ˈfɛstoʊs/",
  "pharaoh": "/ˈfɛɹoʊ/",
  "pharyngeal": "/fəˈɹɪndʒiəɫ/",
  "phaser": "/ˈfeɪzɝ/",
  "philologist": "/fɪˈɫɑɫədʒɪst/",
  "philology": "/fɪˈɫɑɫədʒi/",
  "philosophize": "/fəˈɫɑsəfaɪz/",
  "philosophizing": "/fəˈɫɑsəfaɪzɪŋ/",
  "pho": "/ˈfə/",
  "phonebook": "/ˈfoʊnbʊk/",
  "phonetician": "/ˌfoʊnəˈtɪʃən/",
  "phonologies": "/fəˈnɑɫəˌdʒiz/",
  "phonotactics": "/foʊnoʊˈtæktɪks/",
  "phosphide": "/ˈfɑsfaɪd/",
  "phosphine": "/ˈfɑsfin/",
  "photo": "/ˈfoʊtoʊ/",
  "photorealistic": "/ˈfoʊtoʊˌɹiəˈɫɪstɪk/",
  "photoreceptor": "/ˈfoʊtoʊɹisˌɛptɝ/",
  "photosensitive": "/ˌfoʊˌtoʊˈsɛnsətɪv/",
  "photoshoot": "/ˈfoʊtoʊˌʃut/",
  "photosynthesize": "/ˌfoʊtoʊˈsɪnθəsaɪz/",
  "photosynthesizer": "/ˌfoʊtoʊˈsɪnθəsaɪzɝ/",
  "photosynthetic": "/ˌfoʊtoʊsɪnˈθɛtɪk/",
  "phrasal": "/ˈfɹeɪsəɫ/",
  "phyliss": "/ˈfɪɫəs/",
  "phylogeny": "/fəˈɫɑdʒəni/",
  "phylogenies": "/fəˈɫɑdʒəniz/",
  "physicality": "/ˌfɪsəˈkæɫəti/",
  "physically": "/ˈfɪzɪkɫi/",
  "phytonutrient": "/ˈfaɪtoʊˌnutɹɪənt/",
  "pg": "/ˈpiˈdʒi/",
  "piano": "/piˈænoʊ/",
  "piano's": "/piˈænoʊz/",
  "pianos": "/piˈænoʊz/",
  "pickleball": "/ˈpɪkəɫbɔɫ/",
  "picture": "/ˈpɪkʃɝ/",
  "picture's": "/ˈpɪkʃɝz/",
  "pictured": "/ˈpɪkʃɝd/",
  "pictures": "/ˈpɪkʃɝz/",
  "pictures'": "/ˈpɪkʃɝz/",
  "picturesque": "/ˈpɪkʃɝəsk/",
  "pidgin": "/ˈpɪdʒən/",
  "piemaker": "/ˈpaɪˌmeɪkɝ/",
  "pigtail": "/ˈpɪɡˌteɪɫ/",
  "pika": "/ˈpaɪkə/",
  "pinup": "/ˈpɪnˌəp/",
  "pippa": "/ˈpɪpə/",
  "piranha": "/pɝˈɹɑnə/",
  "pitiful": "/ˈpɪtəfəɫ/",
  "pixelate": "/ˈpɪksəˌɫeɪt/",
  "pixelated": "/ˈpɪksəˌɫeɪtəd/",
  "pixelating": "/ˈpɪksəˌɫeɪtɪŋ/",
  "pjs": "/ˈpiˌdʒeɪz/",
  "placeholder": "/ˈpɫeɪsˌhoʊɫdɝ/",
  "planetesimal": "/ˌpɫænəˈtɛsəməɫ/",
  "plantain": "/ˈpɫænteɪn/",
  "plantar": "/ˈpɫæntɝ/",
  "plasticity": "/pɫæˈstɪsəti/",
  "plasticky": "/ˈpɫæstɪki/",
  "platitudinal": "/ˌpɫætəˈtudənəɫ/",
  "playable": "/ˈpɫeɪəbəɫ/",
  "playability": "/pɫeɪəˈbɪɫɪti/",
  "playtest": "/ˈpɫeɪtɛst/",
  "playthrough": "/ˈpɫeɪjθɹu/",
  "pleasuring": "/ˈpɫɛʒɝɪŋ/",
  "pliability": "/pɫaɪəˈbɪɫɪti/",
  "plutarch": "/ˈpɫutɑɹk/",
  "plutocracy": "/pɫuˈtɑkɹəsi/",
  "plutocratic": "/ˌpɫutoʊˈkɹætɪk/",
  "pogrom": "/pəˈɡɹɑm/",
  "poignance": "/ˈpɔɪnjəns/",
  "poincaré": "/ˌpɔɪŋkəˈɹeɪ/",
  "pointillism": "/ˈpɔɪntəˌɫɪzəm/",
  "pollinator": "/ˈpɑɫəˌneɪtɝ/",
  "polychromatic": "/ˌpɑɫiˌkɹəˈmætɪk/",
  "polygons": "/ˈpɑɫɪˌɡɑnz/",
  "polyhedra": "/ˌpɑˌɫiˈhidɹə/",
  "polyhedral": "/ˌpɑˌɫiˈhidɹəɫ/",
  "polymath": "/ˈpɑɫiˌmæθ/",
  "pommes": "/ˈpoʊmz/",
  "pompeii": "/ˌpɑmˈpeɪ/",
  "ponged": "/ˈpɔŋd/",
  "poor": "/ˈpɔɹ/",
  "poor-spirited": "/ˈpɔɹˈspɪɹɪtɪd/",
  "poor-spiritedness": "/ˈpɔɹˈspɪɹɪtɪdnəs/",
  "poor's": "/ˈpɔɹz/",
  "poorbaugh": "/ˈpɔɹbɔ/",
  "poore": "/ˈpɔɹ/",
  "poorer": "/ˈpɔɹɝ/",
  "poorest": "/ˈpɔɹɪst/",
  "poorhouse": "/ˈpɔɹˌhaʊs/",
  "poorly": "/ˈpɔɹɫi/",
  "poorman": "/ˈpɔɹmən/",
  "poors": "/ˈpɔɹz/",
  "popes": "/ˈpoʊps/",
  "poppable": "/ˈpɑpəbəɫ/",
  "popularizes": "/ˈpɑpjəɫɝˌaɪzəz/",
  "porosity": "/pəˈɹɑsəti/",
  "porpoising": "/ˈpɔɹpəsɪŋ/",
  "portamento": "/ˌpɔɹtəˈmɛntoʊ/",
  "posca": "/ˈpoʊskə/",
  "positivity": "/pɑzəˈtɪvɪti/",
  "postalveolar": "/ˈpoʊstæɫˈviəɫɝ/",
  "postapocalyptic": "/ˌpoʊstəˌpɑkəˈɫɪptɪk/",
  "postdoc": "/ˈpoʊstˌdɑk/",
  "postmen": "/ˈpoʊsˌmɛn/",
  "postseason": "/ˈpoʊstˈsizən/",
  "potato": "/pəˈteɪtoʊ/",
  "potatoe": "/pəˈteɪtoʊ/",
  "poutine": "/puˈtin/",
  "prayer": "/ˈpɹɛɹ/",
  "precess": "/ˈpɹisɛs/",
  "precessed": "/ˈpɹisɛst/",
  "precheck": "/ˈpɹitʃɛk/",
  "precise": "/pɹəˈsaɪs/",
  "precisely": "/pɹəˈsaɪsɫi/",
  "precision": "/pɹəˈsɪʒən/",
  "precut": "/ˌpɹiˈkət/",
  "predating": "/ˈpɹiˈdeɪtɪŋ/",
  "predominate": "/pɹɪˈdɑmənət/",
  "prefigure": "/ˌpɹiˈfɪɡjɝ/",
  "prefigured": "/ˌpɹiˈfɪɡjɝd/",
  "pregame": "/ˈpɹiˌɡeɪm/",
  "preheat": "/ˈpɹiˈhit/",
  "prehistory": "/ˌpɹiˈhɪstɝi/",
  "preindustrial": "/ˌpɹiɪnˈdəstɹiəɫ/",
  "prelapsarian": "/pɹiɫæpˈsɛɹiən/",
  "preload": "/ˌpɹiˈɫoʊd/",
  "preloaded": "/ˌpɹiˈɫoʊdəd/",
  "premiere": "/pɹəˈmɪɹ/",
  "première": "/pɹəˈmɪɹ/",
  "preorder": "/ˈpɹiˌɔɹdɝ/",
  "prepare": "/pɹəˈpɛɹ/",
  "prepared": "/pɹəˈpɛɹd/",
  "preparing": "/pɹəˈpɛɹɪŋ/",
  "preposition": "/ˌpɹɛpəˈsɪʃən/",
  "preprint": "/ˈpɹipɹɪnt/",
  "prescience": "/ˈpɹɛʃəns/",
  "prescient": "/ˈpɹɛʃənt/",
  "prescriptive": "/pɹəˈskɹɪptɪv/",
  "prosecco": "/pɹəˈsɛkoʊ/",
  "presenter": "/pɹɪˈzɛntɝ/",
  "presenters": "/pɹɪˈzɛntɝz/",
  "president": "/ˈpɹɛzəˌdənt/",
  "presupposed": "/ˌpɹisəˈpoʊzd/",
  "preterite": "/ˈpɹɛtɝət/",
  "preternatural": "/ˌpɹɛtɝˈnætʃɝəɫ/",
  "pretorian": "/pɹɪˈtɔɹiən/",
  "prettily": "/ˈpɹɪtəɫi/",
  "priestesses": "/ˈpɹistəsəz/",
  "primitives": "/ˈpɹɪmətɪvz/",
  "prioritization": "/pɹaɪɔɹətɪˈzeɪʃən/",
  "privilege": "/ˈpɹɪvɫədʒ/",
  "privileged": "/ˈpɹɪvɫədʒd/",
  "privileges": "/ˈpɹɪvɫədʒəz/",
  "privileging": "/ˈpɹɪvɫədʒɪŋ/",
  "probiotic": "/ˌpɹoʊbaɪˈɑtɪk/",
  "procure": "/pɹəkˈjʊɹ/",
  "product": "/ˈpɹɑˌdəkt/",
  "prof": "/ˈpɹɔf/",
  "proficient": "/pɹəˈfɪʃənt/",
  "prog": "/ˈpɹɑɡ/",
  "prognosticator": "/ˌpɹəɡˈnɑstəˌkeɪtɝ/",
  "programmatic": "/ˌpɹoʊɡɹəˈmætɪk/",
  "programmatically": "/ˌpɹoʊɡɹəˈmætəkɫi/",
  "progressivism": "/pɹəˈɡɹɛsɪvɪzəm/",
  "proliferance": "/pɹəˈɫɪfɝəns/",
  "promontory": "/ˈpɹɑmənˌtɔɹi/",
  "proofreader": "/ˈpɹufˌɹidɝ/",
  "proposer": "/pɹəˈpoʊzɝ/",
  "propositional": "/ˌpɹɑpəˈzɪʃənəɫ/",
  "propulsive": "/pɹəˈpəɫsɪv/",
  "prosodic": "/pɹəˈsɑdɪk/",
  "protégé": "/ˈpɹoʊtəˌʒeɪ/",
  "protégée": "/ˈpɹoʊtəˌʒeɪ/",
  "protestor": "/ˈpɹoʊtɛstɝ/",
  "protist": "/ˈpɹoʊtɪst/",
  "protract": "/pɹoʊˈtɹækt/",
  "protuberant": "/pɹoʊˈtubɝənt/",
  "provably": "/ˈpɹuvəbɫi/",
  "provocateur": "/pɹoʊˌvɑkəˈtɝ/",
  "provolone": "/ˌpɹoʊvəˈɫoʊni/",
  "prowled": "/ˈpɹaʊɫd/",
  "pseudonymous": "/suˈdɑnəməs/",
  "pseudoscientist": "/ˌsudoʊˈsaɪəntɪst/",
  "pshaw": "/pəˈʃɑ/",
  "psst": "/ˈpsst/",
  "psychoactive": "/ˌsaɪkoʊˈæktɪv/",
  "psycholinguist": "/ˌsaɪkoʊˈɫɪŋɡwɪst/",
  "psycholinguistics": "/ˌsaɪkoʊɫɪŋˈɡwɪstɪks/",
  "psychotropic": "/ˌsaɪkəˈtɹoʊpɪk/",
  "psyop": "/ˈsaɪɑp/",
  "puebloan": "/ˈpwɛbɫoʊən/",
  "puked": "/ˈpjukt/",
  "pullover": "/ˈpʊɫˌoʊvɝ/",
  "pulmonic": "/pəɫˈmɑnɪk/",
  "pulped": "/ˈpəɫpt/",
  "pulpy": "/ˈpəɫpi/",
  "pulsar": "/ˈpʊɫsɑɹ/",
  "pulsate": "/ˈpʊɫseɪt/",
  "punctate": '/ˈpəŋkˌteɪt/',
  "punjab": "/ˈpʊnˌdʒɑb/",
  "punjabi": "/ˌpʊnˈdʒɑbi/",
  "punted": "/ˈpəntəd/",
  "punxsutawney": "/ˌpəŋksəˈtɑˌni/",
  "puppetmaster": "/ˈpəpətˌmæstɝ/",
  "purépecha": "/puˈɹepetʃa/",
  "p'urhépecha": "/puˈɹepetʃa/",
  "purgative": "/ˈpɝɡətɪv/",
  "purport": "/pɝˈpɔɹt/",
  "puss": "/ˈpʊs/",
  "putting": "/ˈpʊtɪŋ/",
  "pyromania": "/ˌpaɪɹoʊˈmeɪniə/",
  "pyromaniac": "/ˌpaɪɹoʊˈmeɪniæk/",
  "pythagoras": "/pəˈθæɡəɹəs/",
  "q&a": "/ˌkjuənˈeɪ/",
  "qanon": "/ˈkjuəˌnɔn/",
  "quaalude": "/ˈkweɪɫud/",
  "quadratic": "/kwɑˈdɹætɪk/",
  "quadrilateral": "/ˌkwɑdɹəˈɫætɝəɫ/",
  "quadrilaterals": "/ˌkwɑdɹəˈɫætɝəɫz/",
  "quadroon": "/kwɑˈdɹun/",
  "quadruped": "/ˈkwɑdɹəpɛd/",
  "quale": "/ˈkwɑɫi/",
  "qualia": "/ˈkwɑɫiə/",
  "quanta": "/ˈkwɑntə/",
  "quantization": "/ˌkwɑntəˈzeɪʃən/",
  "quantize": "/ˈkwɑnˌtaɪz/",
  "quantized": "/ˈkwɑnˌtaɪzd/",
  "quantizer": "/ˈkwɑnˌtaɪzɝ/",
  "quarantined": "/ˈkwɔɹənˌtind/",
  "quarantines": "/ˈkwɔɹənˌtinz/",
  "quarantining": "/ˈkwɔɹənˌtinɪŋ/",
  "quarter": "/ˈkɔɹtɝ/",
  "quarter's": "/ˈkɔɹtɝz/",
  "quarterback": "/ˈkɔɹtɝˌbæk/",
  "quarterbacking": "/ˈkɔɹtɝˌbækɪŋ/",
  "quarterbacks": "/ˈkɔɹtɝˌbæks/",
  "quarterdeck": "/ˈkɔɹtɝˌdɛk/",
  "quarterfinal": "/ˈkɔɹtɝˈfaɪnəɫ/",
  "quarterly": "/ˈkɔɹtɝɫi/",
  "quarterman": "/ˈkɔɹtɝmən/",
  "quartermaster": "/ˈkɔɹtɝˌmæstɝ/",
  "quarters": "/ˈkɔɹtɝz/",
  "quarters'": "/ˈkɔɹtɝz/",
  "quarters's": "/ˈkɔɹtɝz/",
  "quartet": "/kɔɹˈtɛt/",
  "quartic": "/ˈkwoɹtɪk/",
  "quasi": "/ˈkwɑzi/",
  "quaternion": "/kwəˈtɝniən/",
  "quay": "/ˈki/",
  "qubit": "/ˈkjuˌbɪt/",
  "quechua": "/ˈkɛtʃəwə/",
  "queenstown": "/ˈkwinstaʊn/",
  "quinoa": "/ˈkinˌwɑ/",
  "quintic": "/ˈkwɪntɪk/",
  "quipu": "/ˈkipu/",
  "quirkiness": "/ˈkwɝkinəs/",
  "quoi": "/ˈkwɑ/",
  "quotidian": "/kwoʊˈtɪdiən/",
  "quran": "/kɔˈɹɑn/",
  "quranic": "/kɔˈɹɑnək/",
  "r&d": "/ˈɑɹənˈdi/",
  "r&r": "/ˈɑɹənˈɑɹ/",
  "racecourse": "/ˈɹeɪsˌkɔɹs/",
  "racehorses": "/ˈɹeɪsˌhɔɹsɪz/",
  "radian": "/ˈɹeɪdiən/",
  "radiocarbon": "/ˈɹeɪdiˌoʊˌkɑɹbən/",
  "rager": "/ˈɹeɪdʒɝ/",
  "ragnarok": "/ˈɹæɡnəˌɹɑk/",
  "rainforest": "/ˈɹeɪnˌfɔɹəst/",
  "raingear": "/ˈɹeɪnˌɡɪɹ/",
  "rajah": "/ˈɹɑdʒɑ/",
  "ramen": "/ˈɹɑmɛn/",
  "ramsdell": '/ˈɹæmzdəɫ/',
  "ramsden": '/ˈɹæmzdən/',
  "rapa": "/ˈɹɑpə/",
  "rapanui": "/ˌɹɑpɑˈnui/",
  "rastafarian": '/ɹɑstəˈfɑɹiən/',
  "rationalist": "/ˈɹæʃənəɫɪst/",
  "rattail": "/ˈɹætˌteɪɫ/",
  "re": "/ˈɹi/",  // useful as a prefix
  "read": '/ˈɹid/',
  "reading": "/ˈɹidɪŋ/",
  "realities": "/ˌɹiˈæɫətiz/",
  "reality": "/ˌɹiˈæɫəti/",
  "really": "/ˈɹɪɫi/",
  "reals": "/ˈɹiɫz/",
  "rearranges": "/ˌɹiɝˈeɪndʒəz/",
  "rearrangeable": "/ˌɹiɝˈeɪndʒəbəɫ/",
  "rebekah": "/ɹəˈbɛkə/",
  "recall": "/ˌɹiˈkɔɫ/",
  "recognizability": "/ɹɛkəɡnaɪzəˈbɪɫəti/",
  "recombinable": "/ɹikəmˈbaɪnəbəɫ/",
  "recombinant": "/ɹɪˈkɑmbənənt/",
  "recombined": "/ɹikəmˈbaɪnd/",
  "recombining": "/ɹikəmˈbaɪnɪŋ/",
  "recursion": "/ɹiˈkɝʒən/",
  "recursively": "/ˌɹiˈkɝsɪvɫi/",
  "reductionist": "/ɹiˈdəkʃənəst/",
  "reductive": "/ɹiˈdəktɪv/",
  "redzone": "/ˈɹɛdˌzoʊn/",
  "refectory": "/ɹɪfˈɛktəɹi/",
  "refereed": "/ˌɹɛfɝˈid/",
  "referential": "/ˌɹɛfɝˈɛntʃəɫ/",
  "reflectivity": "/ˌɹifɫɛkˈtɪvəti/",
  "refract": "/ɹəˈfɹækt/",
  "refracted": "/ɹəˈfɹæktəd/",
  "refracts": "/ɹəˈfɹækts/",
  "reframing": "/ɹiˈfɹeɪmɪŋ/",
  "refrigerating": "/ɹɪˈfɹɪdʒɝˌeɪtɪŋ/",
  "regolith": "/ˈɹɛɡoʊɫɪθ/",
  "regular": "/ˈɹɛɡjəɫɝ/",
  "regurgitated": "/ˌɹɪˈɡɝdʒəˌteɪtəd/",
  "regurgitation": "/ɹɪˌɡɝdʒəˈteɪʃən/",
  "reichsmark": "/ˈɹaɪksmɑɹk/",
  "reify": "/ˈɹiəfaɪ/",
  "reifies": "/ˈɹiəfaɪz/",
  "reimagine": "/ˌɹiəˈmædʒən/",
  "reimagining": "/ˌɹiəˈmædʒənɪŋ/",
  "relatable": "/ɹiˈɫeɪtəbəɫ/",
  "relict": "/ˈɹɛɫɪkt/",
  "renaissance": "/ˈɹɛnəsɑns/",
  "rend": "/ˈɹɛnd/",
  "replicant": "/ˈɹɛpɫəkənt/",
  "reprised": "/ɹɪˈpɹaɪzd/",
  "reproached": "/ɹiˈpɹoʊtʃt/",
  "repurposed": "/ˌɹiˈpɝpəst/",
  "requite": "/ˌɹɪˈkwaɪt/",
  "requited": "/ˌɹɪˈkwaɪtəd/",
  "rerecord": "/ˌɹiɹəˈkɔɹd/",
  "resistive": "/ɹiˈsɪstɪv/",
  "resounded": "/ɹiˈzaʊndəd/",
  "resume": "/ɹɪˈzum/",
  "resumes": "/ɹɪˈzumz/",
  "resumé": "/ˈɹɛzəˌmeɪ/",
  "resumés": "/ˈɹɛzəˌmeɪz/",
  "résumé": "/ˈɹɛzəˌmeɪ/",
  "résumés": "/ˈɹɛzəˌmeɪz/",
  "reticulum": "/ɹəˈtɪkjuɫəm/",
  "reticular": "/ɹɪˈtɪkjəɫɝ/",
  "retroflex": "/ˈɹɛtɹoʊˌfɫɛks/",
  "retrospectives": "/ˌɹɛtɹəˈspɛktɪvz/",
  "revelatory": "/ˈɹɛvəɫəˌtɔɹi/",
  "revenant": "/ˈɹɛvənənt/",
  "rewound": "/ɹiˈwaʊnd/",
  "rhombic": "/ˈɹɑmbɪk/",
  "rhomboid": "/ˈɹɑmbɔɪd/",
  "rhombus": "/ˈɹɑmbəs/",
  "rhombuses": "/ˈɹɑmbəsəz/",
  "rhotic": "/ˈɹoʊtɪk/",
  "rhoticity": "/ɹoʊˈtɪsəti/",
  "rhyolite": "/ˈɹaɪoʊˌɫaɪt/",
  "riche": "/ˈɹiʃ/",
  "rickshaw": "/ˈɹɪkʃɑ/",
  "rigour": "/ˈɹɪɡɝ/",
  "ringuette": "/ɹɪŋˈɛt/",
  "rinsed": "/ˈɹɪnst/",
  "risqué": "/ˌɹɪsˈkeɪ/",
  "ritualize": "/ˈɹɪtʃuwəˌɫaɪz/",
  "ritualized": "/ˈɹɪtʃuwəˌɫaɪzd/",
  "ritually": "/ˈɹɪtʃuəɫi/",
  "rivendell": "/ˈɹɪvənˌdɛɫ/",
  "riverine": "/ˈɹɪvɝˌaɪn/",
  "roadkill": "/ˈɹoʊdkɪɫ/",
  "robespierre": "/ˌɹoʊbzpiˈɛɹ/",
  "rocko": "/ˈɹɑkoʊ/",
  "rodinia": "/ɹoʊˈdɪniə/",
  "roguelike": "/ˈɹoʊɡˌɫaɪk/",
  "roguelite": "/ˈɹoʊɡˌɫaɪ/",
  "roleplay": "/ˈɹoʊɫpɫeɪ/",
  "rongorongo": "/ˈɹoʊŋɡoʊˈɹoʊŋɡoʊ/",
  "rosé": "/ˌɹoʊˈseɪ/",
  "ross": "/ˈɹɔs/",
  "ross'": "/ˈɹɔs/",
  "ross's": "/ˈɹɔsɪz/",
  "rotator": "/ˈɹoʊˌteɪtɝ/",
  "rotoscope": "/ˈɹoʊtəˌskoʊp/",
  "rotoscoping": "/ˈɹoʊtəˌskoʊpɪŋ/",
  "roulade": "/ɹuˈɫɑd/",
  "rowdiest": "/ˈɹaʊdiəst/",
  "rugrat": "/ˈɹəɡˌɹæt/",
  "rumba": "/ˈɹəmbə/",
  "rumpelstiltskin": "/ɹəmpəɫˈstɪɫtskɪn/",
  "runic": "/ˈɹunɪk/",
  "runthrough": "/ˈɹənθɹu/",
  "runthroughs": "/ˈɹənθɹuz/",
  "runtime": "/ˈɹəntaɪm/",
  "sabi": "/ˈsɑbi/",
  "sacralization": "/ˌsækɹəɫəˈzeɪʃən/",
  "sacralize": "/ˈsækɹəɫaɪz/",
  "sacralizing": "/ˈsækɹəɫaɪzɪŋ/",
  "safire": "/ˈsæfaɪɝ/",
  "saggy": "/ˈsæɡi/",
  "sahib": "/ˈsɑˌhɪb/",
  "sais": "/ˈseɪ/",
  "salal": "/səˈɫæɫ/",
  "salicylic": "/ˌsæɫəˈsɪɫɪk/",
  "salience": "/ˈseɪɫɪəns/",
  "salish": "/ˈseɪɫɪʃ/",
  "salivary": "/ˈsæɫəˌvɛɹi/",
  "sallow": "/ˈsæɫoʊ/",
  "salp": "/ˈsæɫp/",
  "sanctified": "/ˈsæŋktəfaɪd/",
  "santorini": "/ˌsæntəˈɹini/",
  "saquon": "/ˈseɪˌkwɑn/",
  "sardinian": "/sɑɹˈdɪniən/",
  "satchel": "/ˈsætʃəɫ/",
  "satiation": "/ˌseɪʃiˈeɪʃən/",
  "satirized": "/ˈsætɝˌaɪzd/",
  "satisfiability": "/ˌsætəsˌfaɪəˈbɪɫəti/",
  "satisfiable": "/ˌsætəsˈfaɪəbəɫ/",
  "saturday": "/ˈsætɝˌdeɪ/",
  "satyr": "/ˈsætɝ/",
  "satyric": "/seɪˈtɪɹɪk/",
  "sauté": "/sɔˈteɪ/",
  "sautéed": "/sɔˈteɪd/",
  "savanna": "/ˌsəˈvænə/",
  "savour": "/ˈseɪvɝ/",
  "savoured": "/ˈseɪvɝd/",
  "savoury": "/ˈseɪvɝi/",
  "sawshank": '/ˈsɔˌʃæŋk/',
  "sawtooth": "/ˈsɑtuθ/",
  "sawtoothed": "/ˈsɑtuθt/",
  "scalene": "/ˈskeɪɫin/",
  "scamp": "/ˈskæmp/",
  "scampi": "/ˈskæmpi/",
  "scariness": "/ˈskɛɹinəs/",
  "scavenged": "/ˈskævəndʒd/",
  "schematically": "/skɪˈmætɪkɫi/",
  "schizophrenic": "/ˌskɪtsəˈfɹɛnɪk/",
  "schnitzel": "/ˈʃnɪtsəɫ/",
  "schrödinger": "/ˈʃɹoʊdɪŋɝ/",
  "schrodinger": "/ˈʃɹoʊdɪŋɝ/",
  "scimitar": "/ˈsɪmətɝ/",
  "scofflaw": "/ˈskɑfɫɑ/",
  "scooch": "/ˈskutʃ/",
  "scooched": "/ˈskutʃt/",
  "scooching": "/ˈskutʃɪŋ/",
  "scotian": "/ˈskoʊʃən/",
  "scouse": "/ˈskaʊs/",
  "scratchcard": "/ˈskɹætʃˌkɑɹd/",
  "scratcher": "/ˈskɹætʃɝ/",
  "screwup": "/ˈskɹuəp/",
  "scriptorium": "/ˌskɹɪpˈtɔɹɪəm/",
  "scrolled": "/ˈskɹoʊɫd/",
  "scrubland": "/ˈskɹəbɫənd/",
  "scrutable": "/ˈskɹutəbəɫ/",
  "scry": "/ˈskɹaɪ/",
  "scurvy": "/ˈskɝvi/",
  "scuzzy": "/ˈskəzi/",
  "scuzzier": "/ˈskəziɝ/",
  "scuzziest": "/ˈskəziəst/",
  "seabird": "/ˈsiˌbɝd/",
  "seafaring": "/ˈsifɛɹɪŋ/",
  "seafloor": "/ˈsifɫɔɹ/",
  "séamus": "/ˈʃeɪməs/",
  "séance": "/ˈseɪɑns/",
  "secularize": "/ˈsɛkjəɫɝaɪz/",
  "sedaris": "/səˈdɛɹəs/",
  "seismograph": "/ˈsaɪzməɡɹæf/",
  "self-destruction": "/ˈsɛɫfdɪˈstɹəkʃən/",
  "semicolon": "/ˈsɛmikoʊɫən/",
  "semiquincentennial": "/ˌsɛmaɪˌkwɪnsɛnˈtɛniəɫ/",
  "semitransparent": "/ˈsɛmaɪtɹænˈspɛɹənt/",
  "sensorial": "/sɛnˈsoʊɹiəɫ/",
  "sentience": "/ˈsɛntʃəns/",
  "sentient": "/ˈsɛntʃənt/",
  "sentinelese": "/ˈsɛntənəˈɫiz/",
  "sequenced": "/ˈsikwənst/",
  "sequencer": "/ˈsikwənsɝ/",
  "serape": "/səˈɹɑpeɪ/",
  "serval": "/ˈsɝvəɫ/",
  "sesquisyllabic": "/ˈsɛskwəsəˈɫæbɪk/",
  "seventy": "/ˈsɛvənti/",
  "several": "/ˈsɛvɹəɫ/",
  "sexualize": "/ˈsɛkʃuəɫaɪz/",
  "sexualized": "/ˈsɛkʃuəɫaɪzd/",
  "shaman": "/ˈʃɑmən/",
  "shan't": "/ˈʃænt/",
  "shapeshift": "/ˈʃeɪpˌʃɪft/",
  "shapeshifted": "/ˈʃeɪpˌʃɪftɪd/",
  "shapeshifter": "/ˈʃeɪpˌʃɪftɝ/",
  "shapeshifting": "/ˈʃeɪpˌʃɪftɪŋ/",
  "shareable": "/ˈʃɛɹəbəɫ/",
  "shawm": "/ˈʃɔm/",
  "shawshank": "/ˈʃɔˌʃæŋk/",
  "shearwater": "/ˈʃɪɹˌwɔtɝ/",
  "shellacked": "/ˌʃɛˈɫækt/",
  "shh": "/ʃː/",
  "shhh": "/ʃː/",
  "shimmery": "/ˈʃɪmɝi/",
  "shimmied": "/ˈʃɪmid/",
  "shingled": "/ˈʃɪŋɡəɫd/",
  "shinjuku": "/ʃɪnˈdʒuku/",
  "shipwrecked": "/ˈʃɪpɹɛkt/",
  "shirtless": "/ˈʃɝtɫəs/",
  "shitpost": "/ˈʃɪtpoʊst/",
  "shitposter": "/ˈʃɪtpoʊstɝ/",
  "shoal": "/ˈʃoʊɫ/",
  "showtune": "/ˈʃoʊtun/",
  "sickled": "/ˈsɪkəɫd/",
  "sicko": "/ˈsɪkoʊ/",
  "sidebox": "/ˈsaɪdˌbɑks/",
  "signifier": "/ˈsɪɡnɪfaɪɝ/",
  "signup": "/ˈsaɪnˌəp/",
  "siloed": "/ˈsaɪɫoʊd/",
  "simile": "/ˈsɪməɫi/",
  "simpler": "/ˈsɪmpɫɝ/",
  "simulacra": "/sɪmjuˈɫækɹə/",
  "simulacrum": "/sɪmjuˈɫækɹəm/",
  "simultaneity": "/ˌsaɪməɫtəˈneɪəti/",
  "sinclair": "/sɪnˈkɫɛɹ/",
  "sinclaire": "/sɪnˈkɫɛɹ/",
  "singalong": "/ˈsɪŋəˌɫɑŋ/",
  "siphonophore": "/saɪˈfɑnəˌfɔɹ/",
  "sisi": "/ˈsisi/",
  "situating": "/ˈsɪtʃuˌeɪtɪŋ/",
  "situationship": "/ˌsɪtʃuˈeɪʃənˌʃɪp/",
  "skald": "/ˈskɑɫd/",
  "skier": "/ˈskiɝ/",
  "skillset": "/ˈskɪɫˌsɛt/",
  "skokomish": "/skəˈkoʊmɪʃ/",
  "skykomish": "/skaɪˈkoʊmɪʃ/",
  "slake": "/ˈsɫeɪk/",
  "slaked": "/ˈsɫeɪkt/",
  "slaking": "/ˈsɫeɪkɪŋ/",
  "slayed": "/ˈsɫeɪd/",
  "slink": "/ˈsɫɪŋk/",
  "slobbery": "/ˈsɫɑbɝi/",
  "sloth": "/ˈsɫɑθ/",
  "slothful": "/ˈsɫɑθfəɫ/",
  "slurped": "/ˈsɫɝpt/",
  "smilodon": "/ˈsmaɪɫədɑn/",
  "smoothie": "/ˈsmuði/",
  "smote": "/ˈsmoʊt/",
  "smudging": "/ˈsmədʒɪŋ/",
  "smush": "/ˈsmʊʃ/",
  "smushed": "/ˈsmʊʃt/",
  "snark": "/ˈsnɑɹk/",
  "snarky": "/ˈsnɑɹki/",
  "sneakernet": "/ˈsnikɝˌnɛt/",
  "snipping": "/ˈsnɪpɪŋ/",
  "sniveling": "/ˈsnɪvəɫɪŋ/",
  "snobbiest": "/ˈsnɑbiəst/",
  "snohomish": "/snəˈhoʊmɪʃ/",
  "snoqualmie": "/snəˈkwɑɫmi/",
  "snowmen": "/ˈsnoʊˌmɛn/",
  "snuggling": "/ˈsnəɡɫɪŋ/",
  "snuggly": "/ˈsnəɡɫi/",
  "sociolinguist": "/ˌsoʊsioʊˈɫɪnɡwɪst/",
  "sociolinguistic": "/ˌsoʊsioʊɫɪŋˈɡwɪstɪk/",
  "sociopolitical": "/ˈsoʊsioʊpəˈɫɪtəkəɫ/",
  "socketed": "/ˈsɑkətəd/",
  "soft": "/ˈsɔft/",
  "softball": "/ˈsɔftˌbɔɫ/",
  "soften": "/ˈsɔfən/",
  "softer": "/ˈsɔftɝ/",
  "softkey": "/ˈsɔftˌkeɪ/",
  "soirée": "/swɑˈɹeɪ/",
  "solipsism": "/ˈsoʊɫɪpˌsɪzəm/",
  "sombre": "/ˈsɑmbɝ/",
  "sonagram": "/ˈsɑnəˌɡɹæm/",
  "songbook": '/ˈsɔŋˌbʊk/',
  "songbooks": '/ˈsɔŋˌbʊks/',
  "songy": "/ˈsɔŋi/",
  "sonorant": "/səˈnɔɹənt/",
  "sonority": '/səˈnɔɹɪti/',
  "sorta": "/ˈsɔɹtə/",
  "soufflé": "/suˈfɫeɪ/",
  "soufflé": "/suˈfɫeɪ/",
  "soulmate": "/ˈsoʊɫˌmeɪt/",
  "soupçon": "/supˈsoʊn/",
  "sourced": "/ˈsɔɹst/",
  "sourdough": "/ˈsaʊɝˌdoʊ/",
  "sow": "/ˈsoʊ/",
  "spaceman": "/ˈspeɪsˌmæn/",
  "spacetime": "/ˈspeɪsˌtaɪm/",
  "speared": "/ˈspɪɹd/",
  "specialty": "/ˈspɛʃəɫti/",
  "spectrogram": "/ˈspɛktɹəˌɡɹæm/",
  "speculatively": "/ˈspɛkjəɫətɪvɫi/",
  "speedbump": "/ˈspidˌbəmp/",
  "spherical": "/ˈsfɪɹɪkəɫ/",
  "sphericality": "/ˌsfɪɹəˈkæɫəti/",
  "spherically": "/ˈsfɪɹəkɫi/",
  "spicily": "/ˈspaɪsəɫi/",
  "spiderweb": "/ˈspaɪdɝˌwɛb/",
  "spidey": "/ˈspaɪdi/",
  "spindly": "/ˈspɪndɫi/",
  "spiritless": "/ˈspɪɹətɫəs/",
  "splay": "/ˈspɫeɪ/",
  "splayed": "/ˈspɫeɪd/",
  "splaying": "/ˈspɫeɪɪŋ/",
  "spookiness": "/ˈspukinəs/",
  "spottiness": "/ˈspɑtinəs/",
  "springy": '/ˈspɹɪŋi/',
  "spritz": "/ˈspɹɪts/",
  "squarepants": "/ˈskwɛɹˌpænts/",
  "squiggly": "/ˈskwɪɡɫi/",
  "squirmy": "/ˈskwɝmi/",
  "squish": "/ˈskwɪʃ/",
  "squished": "/ˈskwɪʃt/",
  "stanchion": "/ˈstæntʃən/",
  "stargaze": "/ˈstɑɹɡeɪz/",
  "stargazed": "/ˈstɑɹɡeɪzd/",
  "stargazing": "/ˈstɑɹɡeɪzɪŋ/",
  "starkest": "/ˈstɑɹkəst/",
  "start-up": "/ˈstɑɹtəp/",
  "start-ups": "/ˈstɑɹtəps/",
  "startup": "/ˈstɑɹtəp/",
  "startups": "/ˈstɑɹtəps/",
  "statistically": "/stəˈtɪstɪkɫi/",
  "steampunk": "/ˈstimpənk/",
  "steamroll": "/ˈstimɹoʊɫ/",
  "steamrolled": "/ˈstimɹoʊɫd/",
  "stele": "/ˈstiɫi/",
  "stencil": "/ˈstɛnsəɫ/",
  "stentorian": "/stɛnˈtɔɹiən/",
  "step-by-step": "/ˈstɛpˌbaɪˈstɛp/",
  "stepkid": "/ˈstɛpkɪd/",
  "stereoscopic": "/ˈstɛɹioʊˈskɑpɪk/",
  "stifling": "/ˈstaɪfɫɪŋ/",
  "stirrer": "/ˈstɝɝ/",
  "stoat": "/ˈstoʊt/",
  "stockinged": "/ˈstɑkɪŋd/",
  "stoppable": "/ˈstɑpəbəɫ/",
  "storyboard": "/ˈstɔɹiˌbɔɹdəd/",
  "stolte": "/ˈstoʊɫti/",
  "strangulating": "/ˈstɹæŋɡjəˌɫeɪtɪŋ/",
  "strapless": "/ˈstɹæpɫəs/",
  "strategized": "/ˈstɹætədʒaɪzd/",
  "streetlight": "/ˈstɹitˌɫaɪt/",
  "strictness": "/ˈstɹɪktnəs/",
  "strikethrough": "/ˈstɹaɪkθɹu/",
  "stronger": "/ˈstɹɔŋɡɝ/",
  "strudel": "/ˈstɹudəɫ/",
  "stuart": "/ˈstuɝt/",
  "stuart's": "/ˈstuɝts/",
  "stuntwoman": "/ˈstəntˌwʊmən/",
  "subducted": "/səbˈdəktəd/",
  "subduction": "/səbˈdəkʃən/",
  "subfield": "/ˈsəbˌfiɫd/",
  "subgenre": "/ˈsəbˈʒɑnɹə/",
  "subheading": "/ˈsəbˌhɛdɪŋ/",
  "subjugation": "/ˌsəbdʒəˈɡeɪʃən/",
  "sublimate": "/ˈsəbɫəˌmeɪt/",
  "sublimated": "/ˈsəbɫəˌmeɪtəd/",
  "sublimating": "/ˈsəbɫəˌmeɪtɪŋ/",
  "submarine": "/ˌsəbməˈɹin/",
  "suboptimal": "/ˌsəbˈɑptəməɫ/",
  "subreddit": "/ˈsəbˈɹɛdɪt/",
  "subspecies": "/ˈsəbˌspiʃiz/",
  "substandard": "/ˌsəbˈstændɝd/",
  "substructure": "/ˈsəbˌstɹəktʃɝ/",
  "subsume": "/səbˈsum/",
  "subsumed": "/səbˈsumd/",
  "subterranean": "/ˌsəbtɝˈeɪniən/",
  "subtlest": "/ˈsətəɫəst/",
  "subtractive": "/səbˈtɹæktəv/",
  "subvariant": "/ˈsəbˈvɛɹiənt/",
  "succour": "/ˈsəkɝ/",
  "sudoku": "/suˈdoʊku/",
  "sulphuric": "/səɫˈfjʊɹɪk/",
  "sumerian": "/səˈmɛɹiən/",
  "sunburnt": "/ˈsənbɝnt/",
  "sunburst": "/ˈsənbɝst/",
  "sundress": "/ˈsənˌdɹɛs/",
  "sundresses": "/ˈsənˌdɹɛsəz/",
  "sunless": "/ˈsənɫəs/",
  "supercluster": "/ˈsupɝˌkɫəstɝ/",
  "supercolony": "/ˈsupɝˌkɑɫəni/",
  "supercontinent": "/ˈsupɝˌkɑntənənt/",
  "superfluous": "/ˈsupɝfɫuəs/",
  "supergroup": "/ˈsupɝˌɡɹup/",
  "superlatively": "/sʊˈpɝɫətɪvɫi/",
  "superposition": "/ˌsupɝpəˈzɪʃən/",
  "superpower": "/ˈsupɝˌpaʊɝ/",
  "superpowered": "/ˈsupɝˌpaʊɝd/",
  "superstardom": "/ˈsupɝˈstɑɹdəm/",
  "supersymmetry": "/ˈsupɝˈsɪmətɹi/",
  "supervillain": "/ˈsupɝˌvɪɫən/",
  "surefire": "/ˈʃʊɹˌfaɪɝ/",
  "surreal": "/sɝˈiəɫ/",
  "surrealist": "/sɝˈiəɫɪst/",
  "sustainably": "/səˈsteɪnəbɫi/",
  "svalbard": "/ˈsvɑɫbɑɹ/",
  "svengali": "/svɛŋˈɡɑɫi/",
  "swansea": "/ˈswɑnsi/",
  "sweetspot": "/ˈswitspɑt/",
  "switcheroo": "/swɪtʃɝˈu/",
  "syllogism": "/ˈsɪɫədʒɪzəm/",
  "symplectic": "/sɪmˈpɫɛktɪk/",
  "synchrony": "/ˈsɪŋkɹəni/",
  "synesthesia": "/ˌsɪnəsˈθiʒə/",
  "synonyms": '/ˈsɪnəˌnɪmz/',
  "synth": "/ˈsɪnθ/",
  "syringe": "/sɝˈɪndʒ/",
  "syrinx": "/ˈsɪɹɪnks/",
  "syrup": "/ˈsɝˌəp/",
  "syrupy": "/ˈsɝəpi/",
  "systematize": "/ˈsɪstəməˌtaɪz/",
  "systematized": "/ˈsɪstəməˌtaɪzd/",
  "szymon": "/ˈsaɪmən/",
  "t'challa": "/təˈtʃɑɫə/",
  "tabular": "/ˈtæbjuɫɝ/",
  "tackler": "/ˈtækɫɝ/",
  "tahitian": "/təˈhiʃən/",
  "tailbone": "/ˈteɪɫboʊn/",
  "takedown": "/ˈteɪkdaʊn/",
  "tangram": "/ˈtæŋɡɹæm/",
  "tangy": "/ˈtæŋi/",
  "tannin": "/ˈtænən/",
  "tanzania": "/ˌtænzəˈniə/",
  "tapioca": "/tæpiˈoʊkə/",
  "tarot": "/ˈtɛɹoʊ/",
  "tarboosh": "/ˈtaɹbuʃ/",
  "tastiest": "/ˈteɪstiəst/",
  "taxonomic": "/ˌtæksəˈnɑmɪk/",
  "taxonomically": "/ˌtæksəˈnɑmɪkɫi/",
  "taxonomist": "/ˌtækˈsɑnəmɪst/",
  "tbsp": "/ˈteɪbəɫˌspun/",
  "teahouse": "/ˈtihaʊs/",
  "technically": "/ˈtɛknɪkɫi/",
  "techy": "/ˈtɛki/",
  "teflon": "/ˈtɛfɫɑn/",
  "tegan": "/ˈtɛɡən/",
  "teleplay": "/ˈtɛɫəpɫeɪ/",
  "tempeh": "/ˈtɛmˌpeɪ/",
  "temperature": "/ˈtɛmpɝtʃɝ/",
  "temperatures": "/ˈtɛmpɝtʃɝz/",
  "template": "/ˈtɛmpɫət/",
  "tenderhearted": "/ˈtɛndɝˈhɑɹtəd/",
  "tendinitis": "/ˌtɛndəˈnaɪtəs/",
  "tendril": "/ˈtɛndɹəɫ/",
  "tented": "/ˈtɛntəd/",
  "tentpole": "/ˈtɛntˌpoʊɫ/",
  "terracotta": "/ˌtɛɹəˈkɑtə/",
  "terraform": "/ˈtɛɹəˌfɔɹm/",
  "terraformed": "/ˈtɛɹəˌfɔɹmd/",
  "terraforming": "/ˈtɛɹəˌfɔɹmɪŋ/",
  "terrarium": "/təˈɹɛɹiəm/",
  "tesseract": "/ˈtɛsɝækt/",
  "tetchy": "/ˈtɛtʃi/",
  "teton": "/ˈtiˌtɑn/",
  "tetrachromacy": "/ˌtɛtɹəˈkɹoʊməsi/",
  "tetrachromat": "/ˌtɛtɹəˈkɹoʊˌmæt/",
  "tetrachromatic": "/ˌtɛtɹəkɹoʊˈmætɪk/",
  "tetrahedra": "/ˌtɛtɹəˈhidɹə/",
  "tetrapod": "/ˈtɛtɹəˌpɑd/",
  "tetris": "/ˈtɛtɹəs/",
  "textural": "/ˈtɛkstʃɝəɫ/",
  "theatric": "/ˌθiˈætɹɪk/",
  "theatrics": "/ˌθiˈætɹɪks/",
  "thelonious": "/θəˈɫoʊniəs/",
  "theodolite": "/θiˈɑdoʊɫaɪt/",
  "theropod": "/ˈθɛɹəˌpɑd/",
  "thingamajig": "/ˈθɪŋəmədʒɪɡ/",
  "thingummy": "/ˈθɪŋɡəmi/",
  "this'd": "/ˈθɪsɪd/",
  "thongs": "/ˈθɔŋz/",
  "thorium": "/ˈθɔɹiəm/",
  "thousandth": "/ˈθaʊzənθ/",
  "thousandths": "/ˈθaʊzənθs/",
  "thousand-years-long": "/ˈθaʊzəndˌjɪɹzˈɫɔŋ/",
  "three-dimensional": "/ˌθɹidɪˈmɛnʃənəɫ/",
  "thrum": "/ˈθɹəm/",
  "thunk": '/ˈθəŋk/',
  "thumbhole": "/ˈθəmˌhoʊɫ/",
  "thurible": "/ˈθʊɹəbəɫ/",
  "thwack": "/ˈθwæk/",
  "thyme": "/ˈtaɪm/",
  "tidepool": "/ˈtaɪdˌpuɫ/",
  "tiebreaker": "/ˈtaɪˌbɹeɪkɝ/",
  "tikal": "/tiˈkɑɫ/",
  "tilapia": "/təˈɫɑpiə/",
  "tiling": "/ˈtaɪɫɪŋ/",
  "timekeeper": "/ˈtaɪmˌkipɝ/",
  "timescale": "/ˈtaɪmˌskeɪɫ/",
  "timey": "/ˈtaɪmi/",
  "tipi": "/ˈtipi/",
  "tissue": "/ˈtɪʃu/",
  "titicaca": "/ˌtɪtiˈkɑkə/",
  "tl;dr": "/ˈtiˈɛɫˈdiˈɑɹ/",
  "today's": "/təˈdeɪz/",
  "todays": "/təˈdeɪz/",
  "tolkien": "/ˈtoʊɫˌkin/",
  "tomato": "/təˈmeɪtoʊ/",
  "tomatoe": "/təˈmeɪtoʊ/",
  "tomatoes": "/təˈmeɪtoʊz/",
  "tomatos": "/təˈmeɪtoʊz/",
  "tomfoolery": "/ˌtɑmˈfuɫɝi/",
  "toolkit": "/ˈtuɫkɪt/",
  "toothbrush": "/ˈtuθˌbɹəʃ/",
  "tootsie": "/ˈtʊtsi/",
  "topological": "/ˌtɑpəˈɫɑdʒɪkəɫ/",
  "topologist": "/təˈpɑɫədʒɪst/",
  "torosaurus": "/ˌtoʊɹəˈsɔɹəs/",
  "torus": "/ˈtɔɹəs/",
  "totoro": "/ˈtoʊtɝoʊ/",
  "touche": "/tuˈʃeɪ/",
  "touchless": "/ˈtətʃɫəs/",
  "touchscreen": "/ˈtətʃˌskɹin/",
  "tourist": "/ˈtʊɹɪst/",
  "tourists": "/ˈtʊɹɪsts/",
  "tourney": "/ˈtʊɹni/",
  "tourneys": "/ˈtʊɹniz/",
  "tourniquet": "/ˈtɝˌnɪkət/",
  "tours": "/ˈtʊɹz/",
  "tov": "/ˈtɑv/",
  "townshend": "/ˈtaʊnsənd/",
  "tradespeople": "/ˈtɹeɪdzˌpipəɫ/",
  "trafficked": "/ˈtɹæfɪkt/",
  "tramps": "/ˈtɹæmps/",
  "trancelike": "/ˈtɹænsˌɫaɪk/",
  "transactional": "/tɹænˈzækʃənəɫ/",
  "transduce": "/tɹænsˈdus/",
  "transducer": "/tɹænsˈdusɝ/",
  "transept": "/ˈtɹænsɛpt/",
  "transformative": "/ˌtɹænsˈfɔɹməˌtɪv/",
  "transformatively": "/ˌtɹænsˈfɔɹməˌtɪvɫi/",
  "transient": "/ˈtɹænziənt/",
  "transitioned": "/tɹænˈzɪʃənd/",
  "transitive": "/ˈtɹænsətɪv/",
  "transitively": "/ˈtɹænsətɪvɫi/",
  "translate": "/ˈtɹænzɫeɪt/",
  "translated": "/ˈtɹænzɫeɪtɪd/",
  "transliteration": "/ˌtɹænsɫɪtɝˈeɪʃən/",
  "transmissible": "/tɹænsˈmɪsəbəɫ/",
  "transphobic": "/ˌtɹænsˈfoʊbɪk/",
  "transsexual": '/tɹænˈsɛkʃuəɫ/',
  "transsexuals": '/tɹænˈsɛkʃuəɫz/',
  "transversal": "/tɹænsˈvɝsəɫ/",
  "transversality": "/tɹænsvɝˈsæɫəti/",
  "transylvania": "/ˌtɹænsəɫˈveɪnjə/",
  "transylvanian": "/ˌtɹænsəɫˈveɪnjən/",
  "trapdoor": "/ˈtɹæpˈduɹ/",
  "trapezius": "/ˌtɹæˈpiziəs/",
  "trapezoid": "/ˈtɹæpəzɔɪd/",
  "trapezoids": "/ˈtɹæpəzɔɪdz/",
  "traumatic": "/tɹəˈmætɪk/",
  "traversal": "/tɹəˈvɝsəɫ/",
  "traversals": "/tɹəˈvɝsəɫz/",
  "traverse": "/tɹəˈvɝs/",
  "traverses": "/tɹəˈvɝsəz/",
  "trawl": "/ˈtɹɑɫ/",
  "trawled": "/ˈtɹɑɫd/",
  "trawling": "/ˈtɹɑɫɪŋ/",
  "treefern": "/ˈtɹiˌfɝn/",
  "trefoil": "/ˈtɹɛfɔɪɫ/",
  "tremolo": "/ˈtɹɛməɫoʊ/",
  "trespasser": "/ˈtɹɛspæsɝ/",
  "tressed": "/ˈtɹɛst/",
  "triage": "/ˈtɹiɑdʒ/",
  "triangulate": "/tɹaɪˈæŋɡjuˌɫeɪt/",
  "triangulated": "/tɹaɪˈæŋɡjuˌɫeɪtəd/",
  "triangulating": "/tɹaɪˈæŋɡjuˌɫeɪtɪŋ/",
  "trichromacy": "/tɹaɪˈkɹoʊməsi/",
  "trichromat": "/ˈtɹaɪkɹoʊˌmæt/",
  "trichromatic": "/ˌtɹaɪkɹoʊˈmætɪk/",
  "tricycle": "/ˈtɹaɪsɪkəɫ/",
  "tricycles": "/ˈtɹaɪsɪkəɫz/",
  "trigonometric": "/ˌtɹɪɡənəˈmɛtɹɪk/",
  "trillionaire": "/ˈtɹɪɫjənɛɹ/",
  "trillionth": "/ˈtɹɪɫjənθ/",
  "trisect": "/ˈtɹaɪsɛkt/",
  "trisected": "/ˈtɹaɪsɛktəd/",
  "trisecting": "/ˈtɹaɪsɛktɪŋ/",
  "trope": "/ˈtɹoʊp/",
  "tropism": "/ˈtɹoʊpɪzəm/",
  "trowel": "/ˈtɹaʊəɫ/",
  "troweled": "/ˈtɹaʊəɫd/",
  "troweling": "/ˈtɹaʊɫɪŋ/",
  "trowelled": "/ˈtɹaʊəɫd/",
  "trowelling": "/ˈtɹaʊɫɪŋ/",
  "tsp": "/ˈtiˌspun/",
  "tuatara": "/twɑˈtɑɹə/",
  "tube": "/ˈtub/",
  "tudor": "/ˈtudɝ/",
  "tudor's": "/ˈtudɝz/",
  "tuesday": "/ˈtuzˌdeɪ/",
  "tuesday's": "/ˈtuzˌdeɪz/",
  "tuesdays": "/ˈtuzˌdeɪz/",
  "tui": "/ˈtui/",
  "tuition": "/tuˈɪʃən/",
  "tukey": "/ˈtuki/",
  "tukwila": "/ˌtəkˈwɪɫə/",
  "tuley": "/ˈtuɫi/",
  "tumbledown": "/ˈtəmbəɫˌdaʊn/",
  "tumbleweed": "/ˈtəmbəɫˌwid/",
  "tumbling": "/ˈtəmbɫɪŋ/",
  "tuna": "/ˈtunə/",
  "tupelo": "/ˈtupəˌɫoʊ/",
  "turd": "/ˈtɝd/",
  "turek": "/ˈtuɹɪk/",
  "turenne": "/ˈtuɹɪn/",
  "turin": "/ˈtʊɹɪn/",
  "tusked": "/ˈtəskt/",
  "tutelage": "/ˈtutɪɫɪdʒ/",
  "tuten": "/ˈtutən/",
  "tweakable": "/ˈtwikəbəɫ/",
  "twelvth": "/ˈtwɛɫfθ/",
  "twenty-first": "/ˈtwɛniˈfɝst/",
  "twenty-five": "/ˈtwɛniˈfaɪv/",
  "twenty-four": "/ˈtwɛniˈfɔɹ/",
  "twenty-one": "/ˈtwɛniˈwən/",
  "twenty-three": "/ˈtwɛniˈθɹi/",
  "twenty-two": "/ˈtwɛniˈtu/",
  "twerp": "/ˈtwɝp/",
  "twistor": "/ˈtwɪstɝ/",
  "type-a": "/ˈtaɪpˈeɪ/",
  "typescript": "/ˈtaɪpˌskɹɪpt/",
  "typesetter": "/ˈtaɪpˌsɛtɝ/",
  "typically": "/ˈtɪpɪkɫi/",
  "typographic": "/ˌtaɪpəˈɡɹæfɪk/",
  "typos": "/ˈtaɪpoʊz/",
  "tyrannosaur": "/təˈɹɑnəsɔɹ/",
  "tyrannosaurid": "/təˈɹɑnəsɔɹəd/",
  "tyus": "/ˈtaɪus/",
  "tzu": "/ˈtsu/",
  "udder": "/ˈədɝ/",
  "ugaritic": "/uɡɝˈɪtɪk/",
  "uh-oh": "/ˈʔəˌʔoʊ/",
  "uh-huh": "/ʔəːˈhəː/",
  "uh-uh": "/ˈʔəʔʔə/",
  "ultralight": "/ˈəɫtɹəˌɫaɪt/",
  "umlaut": "/ˈumɫaʊt/",
  "unbidden": "/ənˈbɪdən/",
  "unbreathable": "/ənˈbɹiðəbəɫ/",
  "unconformities": "/ˌənkənˈfɔɹmətiz/",
  "unconformity": "/ˌənkənˈfɔɹməti/",
  "uncountably": "/ənˈkaʊntəbɫi/",
  "unctad": '/ˈəŋkˌtæd/',
  "unctuous": '/ˈəŋtʃuəs/',
  "undeciphered": "/əndəˈsaɪfɝd/",
  "underappreciated": "/ˌəndɝəˈpɹiʃiˌeɪtɪd/",
  "undergird": "/ˌəndɝˈɡɝd/",
  "undergirds": "/ˌəndɝˈɡɝdz/",
  "underscore": "/ˈəndɝˌskɔɹ/",
  "understaffed": "/ˌəndɝˈstæft/",
  "understaffing": "/ˌəndɝˈstæfɪŋ/",
  "understated": "/ˌəndɝˈsteɪtɪd/",
  "underthrew": "/ˈəndɝˌθɹu/",
  "underthrow": "/ˈəndɝˌθɹoʊ/",
  "underthrown": "/ˈəndɝˌθɹoʊn/",
  "underwater": "/əndɝˈwɔtɝ/",
  "underwork": "/ˈəndɝˈwɝk/",
  "underworked": "/ˈəndɝˈwɝkt/",
  "undiscernible": "/ˌəndɪˈsɝnəbəɫ/",
  "unequally": "/əˈnikwəɫi/",
  "unfunny": "/ˌənˈfəni/",
  "unknotting": "/ˌənˈnɑtɪŋ/",
  "unicode": "/ˈjunəkoʊd/",
  "unimaginably": "/ˌənɪˈmædʒɪnəbɫi/",
  "universalist": "/ˌjunəˈvɝsəɫɪst/",
  "unlearned": "/ənˈɫɝnd/",
  "unquenchable": "/ənˈkwɛntʃəbəɫ/",
  "unravelled": "/ənˈɹævəɫd/",
  "unravelling": "/ənˈɹævəɫɪŋ/",
  "unrealistic": "/ənˌɹiəˈɫɪstɪk/",
  "unseeable": "/ənˈsiəbəɫ/",
  "unspeakably": "/ənˈspikəbɫi/",
  "untruths": '/ənˈtɹuθs/',
  "unusual": '/ənˈjuʒəwəɫ/',
  "upanishad": "/uˈpɑnəʃɑd/",
  "updike's": '/ˈəpˌdaɪks/',
  "upend": "/əpˈɛnd/",
  "upended": "/əpˈɛndəd/",
  "upending": "/əpˈɛndɪŋ/",
  "upgrade": "/ˈəpˌɡɹeɪd/",
  "upholsterer": "/əˈpoʊɫstɝɝ/",
  "uplinked": "/ˈuˌpɫɪŋkt/",
  "uproarious": "/əpˈɹɔɹiəs/",
  "uppsala": "/ˈʊpˌsɑɫɑ/",
  "uppercase": "/ˈəpɝˈkeɪs/",
  "uptalk": "/ˈəpˌtɔk/",
  "uriah": "/juˈɹaɪə/",
  "urinal": "/ˈjɝənəɫ/",
  "url": "/ˌjuˌɑˈɹɛɫ/",
  "usability": "/jusəˈbɪɫəti/",
  "usain": "/juˈseɪn/",
  "usameribancs": '/ˌjuˌɛsəˈmɛɹɪˌbæŋks/',
  "usual": '/ˈjuʒəwəɫ/',
  "usurer": "/ˈjuʒɝɝ/",
  "usuries": "/ˈjuʒɝiz/",
  "usury": "/ˈjuʒɝi/",
  "utilitarianism": "/juˌtɪɫəˈtɛɹiənɪzəm/",
  "utopianism": "/juˈtoʊpiənɪzəm/",
  "utrecht": "/juˈtɹɛkt/",
  "uvula": "/ˈjuvjəɫə/",
  "uvular": "/ˈjuvjəɫəɹ/",
  "uw's": "/ˈjuˈdəbz/",
  "vaping": "/ˈveɪpɪŋ/",
  "vaporizing": "/ˈveɪpɝˌaɪzɪŋ/",
  "varicose": "/ˈvɛɹəˌkoʊs/",
  "vase": "/ˈveɪs/",
  "vashon": "/væˈʃɑn/",
  "vedic": "/ˈvɛdɪk/",
  "veg": "/ˈvɛdʒ/",
  "vegan": "/ˈviɡən/",
  "vegetarian": "/ˌvɛdʒəˈtɛɹˌiən/",
  "vehicle": "/ˈviɪkəɫ/",
  "vehicle's": "/ˈviɪkəɫz/",
  "vehicles": "/ˈviɪkəɫz/",
  "vehicles'": "/ˈviɪkəɫz/",
  "velar": "/ˈviɫɝ/",
  "velarization": "/ˌviɫɝəˈzeɪʃən/",
  "velarize": "/ˈviɫəɹaɪz/",
  "velarized": "/ˈviɫəɹaɪzd/",
  "vellum": "/ˈvɛɫəm/",
  "velum": "/ˈviɫəm/",
  "ventriloquist": "/vɛnˈtɹɪɫəˌkwɪst/",
  "venues": "/ˈvɛnjuz/",
  "venusian": "/vɪˈnuʒən/",
  "verbose": "/vɝˈboʊs/",
  "verged": "/ˈvɝdʒd/",
  "vertiginous": "/vɝˈtɪdʒənəs/",
  "vervet": "/ˈvɝvət/",
  "vesicle": "/ˈvɛsɪkəɫ/",
  "vespertine": "/ˈvɛspɝˌtaɪn/",
  "vhs": "/vieɪtʃˈɛs/",
  "vibrato": "/vəˈbɹɑtoʊ/",
  "víctor": "/ˈvɪktɝ/",
  "victual": "/ˈvɪtəɫ/",
  "vida": "/ˈvidə/",
  "viewability": "/vjuəˈbɪɫəti/",
  "viewable": "/ˈvjuəbəɫ/",
  "vigour": "/ˈvɪɡɝ/",
  "vijay": "/ˈvidʒeɪ/",
  "vinaigrette": "/ˌvɪnəˈɡɹɛt/",
  "vinculum": "/ˈvɪnkjuɫəm/",
  "violence": "/ˈvaɪɫəns/",
  "violent": "/ˈvaɪɫənt/",
  "violet": "/ˈvaɪɫɪt/",
  "viperous": "/ˈvaɪpɝəs/",
  "virality": "/vəˈɹæɫəti/",
  "visualizations": "/ˌvɪʒwəɫəˈzeɪʃənz/",
  "visualizer": "/ˈvɪʒwəˌɫaɪzɝ/",
  "visualizers": "/ˈvɪʒwəˌɫaɪzɝz/",
  "vitalize": "/ˈvaɪtəˌɫaɪz/",
  "vitalized": "/ˈvaɪtəˌɫaɪzd/",
  "viticulture": "/ˈvɪtəˌkəɫtʃɝ/",
  "viticulturist": "/ˌvɪtəˈkəɫtʃɝɪst/",
  "vocab": "/ˈvoʊkæb/",
  "vocalization": "/ˌvoʊkəɫɪˈzeɪʃən/",
  "volcanism": "/ˈvəɫkənɪzəm/",
  "voigt": '/ˈvɔɪt/',
  "voilà": "/ˌvwɑˈɫɑ/",
  "vortex": "/ˈvɔɹˌtɛks/",
  "vortices": "/ˈvɔɹtəsiz/",
  "voyaging": "/ˈvɔɪədʒɪŋ/",
  "w/": "/ˈwɪθ/",
  "wabi": "/ˈwɑbi/",
  "wabi-cha": "/ˈwɑbiˈtʃɑ/",
  "wabi-sabi": "/ˈwɑbiˈsɑbi/",
  "wakanda": "/wəˈkɑndə/",
  "wakefulness": "/ˈweɪkfəɫnəs/",
  "walk": "/ˈwɔk/",
  "walkability": "/ˌwɔkəˈbɪɫəti/",
  "walkable": "/ˈwɔkəbəɫ/",
  "walkthrough": "/ˈwɔkθɹu/",
  "walkthroughs": "/ˈwɔkθɹuz/",
  "warhol's": "/ˈwɔˌɹɔɫz/",
  "wash": "/ˈwɔʃ/",
  "washable": "/ˈwɔʃəbəɫ/",
  "washbasin": "/ˈwɔʃˌbeɪsən/",
  "washboard": "/ˈwɔʃˌbɔɹd/",
  "washburn": "/ˈwɔʃˌbɝn/",
  "washcloth": "/ˈwɔʃˌkɫɔθ/",
  "washed": "/ˈwɔʃt/",
  "washer": "/ˈwɔʃɝ/",
  "washers": "/ˈwɔʃɝz/",
  "washes": "/ˈwɔʃɪz/",
  "washi's": "/ˈwɔʃiz/",
  "washing": "/ˈwɔʃɪŋ/",
  "washington": "/ˈwɔʃɪŋtən/",
  "washington's": "/ˈwɔʃɪŋtənz/",
  "washingtonian": "/ˌwɔʃɪŋˈtoʊniən/",
  "washingtonians": "/ˌwɔʃɪŋˈtoʊniənz/",
  "washout": "/ˈwɔˌʃaʊt/",
  "washouts": "/ˈwɔˌʃaʊts/",
  "washroom": "/ˈwɔʃˌɹum/",
  "washtub": "/ˈwɔʃˌtəb/",
  "washy": "/ˈwɔʃi/",
  "wasn't": "/ˈwəzənt/",
  "wastage": "/ˈweɪstɪdʒ/",
  "watchable": "/ˈwɑtʃəbəɫ/",
  "waterdrop": "/ˈwɔtɝˌdɹɑp/",
  "waterproofed": "/ˈwɔtɝˌpɹuft/",
  "waterslide": "/ˈwɔtɝˌsɫaɪd/",
  "watertower": "/ˈwɔtɝˌtaʊɝ/",
  "watterson": "/ˈwɔtɝsən/",
  "waypoint": "/ˈweɪpɔɪnt/",
  "wazzu": "/wɑˈzu/",
  "wavelength": '/ˈweɪvˌɫɛŋkθ/',
  "wavelengths": '/ˈweɪvˌɫɛŋkθs/',
  "wavelike": "/ˈweɪvˌɫaɪk/",
  "weaponize": "/ˈwɛpənaɪz/",
  "weaponized": "/ˈwɛpənaɪzd/",
  "weaponizing": "/ˈwɛpənaɪzɪŋ/",
  "wearier": "/ˈwiɹiɝ/",
  "weeknight": "/ˈwiknaɪt/",
  "weenie": "/ˈwini/",
  "weierstrass": "/ˈvaɪɝˌʃtɹɑs/",
  "weir": "/ˈwɪɹ/",
  "westward-faring": "/ˌwɛstwɝdˈfɛɹɪŋ/",
  "wharves": "/ˈwɔɹvz/",
  "whatchamacallit": "/ˈwətʃəməkɔɫɪt/",
  "whidbey": "/ˈwɪdbi/",
  "whiplike": "/ˈhwɪpˌɫaɪk/",
  "whir": "/ˈwɝ/",
  "whirr": "/ˈwɝ/",
  "whirred": "/ˈwɝd/",
  "whirring": "/ˈwɝɪŋ/",
  "whiteboard": "/ˈwaɪtˌbɔɹd/",
  "whiteout": "/ˈwaɪtˌaʊt/",
  "whitespace": "/ˈwaɪtspeɪs/",
  "whodunnit": "/huˈdənɪt/",
  "whodunnits": "/huˈdənɪts/",
  "wiedlin": "/ˈwidɫən/",
  "wiffle": "/ˈwɪfəɫ/",
  "wikimedia": "/wɪkiˈmidiə/",
  "wingless": "/ˈwɪŋɫəs/",
  "wireframe": "/ˈwaɪɝˌfɹeɪm/",
  "wiseass": "/ˈwaɪzˌæs/",
  "wittiest": "/ˈwɪtiəst/",
  "wobbles": "/ˈwɑbəɫz/",
  "wobbliness": "/ˈwɑbɫinəs/",
  "wolfie": "/ˈwʊɫfi/",
  "won": "/ˈwən/",
  "wonk": "/ˈwɔŋk/",
  "wonks": "/ˈwɔŋks/",
  "wonky": "/ˈwɔŋki/",
  "woodstove": "/ˈwʊdˌstoʊv/",
  "wordle": "/ˈwɝdəɫ/",
  "workaround": "/ˈwɝkɝˌaʊnd/",
  "workshopped": "/ˈwɝkˌʃɑpt/",
  "workshopping": "/ˈwɝkˌʃɑpɪŋ/",
  "wormed": "/ˈwɝmd/",
  "wozniack": "/ˈwɑzniæk/",
  "wrinkly": "/ˈɹɪnkɫi/",
  "writable": "/ˈɹaɪtəbəɫ/",
  "write-off": "/ˈɹaɪtˌɔf/",
  "write-offs": "/ˈɹaɪtˌɔfs/",
  "writhe": "/ˈɹaɪð/",
  "writhed": "/ˈɹaɪðd/",
  "wwi": "/ˌwɝɫdˌwɔɹˈwən/",
  "wwii": "/ˌwɝɫdˌwɔɹˈtu/",
  "xanadu": "/ˈzænəˌdu/",
  "xenophobe": "/ˈzɛnəˌfoʊb/",
  "xenophobic": "/ˌzɛnəˈfoʊbɪk/",
  "xochitl": "/zoʊˈtʃitəɫ/",
  "yakima": "/ˈjækəmɑ/",
  "yankovic": "/ˈjænkəvɪk/",
  "yaupon": "/ˈjupɑn/",
  "yearling": "/ˈjɪɹɫɪŋ/",
  "yelped": "/ˈjɛɫpt/",
  "yerba": "/ˈjɛɹbə/",
  "yoghurt": "/ˈjoʊɡɝt/",
  "yourself": "/jɝˈsɛɫf/",
  "yourselves": "/jɝˈsɛɫvz/",
  "youtube": "/ˈjuˌtub/",
  "yucatán": "/jukəˈtɑn/",
  "zapotec": "/ˈzɑpəˌtek/",
  "zealandia": "/ziˈɫændiə/",
  "zeaxanthin": "/ˌziəˈzænθən/",
  "zeitgeist": "/ˈzaɪtˌɡaɪst/",
  "zendaya": "/zɛnˈdɑjə/",
  "zenlike": "/ˈzɛnɫaɪk/",
  "zeppelin": "/ˈzɛpɫɪn/",
  "zigby": "/ˈzɪɡbi/",
  "zigby's": "/ˈzɪɡbiz/",
  "zine": "/ˈzin/",
  "zooarchaeological": "/ˌzuoʊˌɑɹkiəˈɫɑdʒɪkəɫ/",
  "zooarchaeologist": "/ˌzuoʊˌɑɹkiˈɑɫədʒɪst/",
  "zooarchaeology": "/ˌzuoʊˌɑɹkiˈɑɫədʒi/",
  "zooplankton": "/ˌzoʊəˈpɫænktən/",
  "zürich": "/ˈzʊɹɪk/",
}
